(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("svg-baker-runtime/browser-symbol"), require("svg-sprite-loader/runtime/browser-sprite.build"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "svg-baker-runtime/browser-symbol", "svg-sprite-loader/runtime/browser-sprite.build", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("prop-types"), require("react"), require("svg-baker-runtime/browser-symbol"), require("svg-sprite-loader/runtime/browser-sprite.build"), require("react-dom")) : factory(root["prop-types"], root["react"], root["svg-baker-runtime/browser-symbol"], root["svg-sprite-loader/runtime/browser-sprite.build"], root["react-dom"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 210);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "cancel_24",
  "use": "cancel_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"cancel_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M18.3 5.7a.99.99 0 0 0-1.4 0L12 10.6 7.1 5.7a.99.99 0 0 0-1.4 1.4l4.9 4.9-4.9 4.9a.99.99 0 0 0 1.4 1.4l4.9-4.9 4.9 4.9a.99.99 0 0 0 1.4-1.4L13.4 12l4.9-4.9a.99.99 0 0 0 0-1.4z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 248);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "done_16",
  "use": "done_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"done_16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M6 10.2L3.5 7.7a.99.99 0 1 0-1.4 1.4l3.193 3.193a1 1 0 0 0 1.414 0L14.3 4.7a.99.99 0 0 0-1.4-1.4L6 10.2z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 197);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "dropdown_24",
  "use": "dropdown_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"dropdown_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M12 14.198L6.64 9.732a1 1 0 1 0-1.28 1.536l6 5a1 1 0 0 0 1.28 0l6-5a1 1 0 1 0-1.28-1.536L12 14.198z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = {
  tabbarHeight: 48
};

/***/ }),
/* 9 */
/***/ (function(module) {

module.exports = {"name":"@vkontakte/vkui","version":"2.16.3","main":"dist/vkui.js","license":"MIT","description":"VKUI library","repository":"https://github.com/VKCOM/VKUI","homepage":"https://vkcom.github.io/vkui-styleguide","defaultSchemeId":"client_light","devDependencies":{"@babel/cli":"^7.2.0","@babel/core":"^7.2.2","@babel/plugin-proposal-class-properties":"^7.2.1","@babel/plugin-proposal-object-rest-spread":"^7.2.0","@babel/preset-env":"^7.2.0","@babel/preset-react":"^7.0.0","@vkontakte/appearance":"git@github.com:VKCOM/Appearance.git#2.1.0","@vkontakte/vkui-connect":"^1.1.2","autoprefixer":"^7.2.3","babel-eslint":"^8.2.3","babel-loader":"^8.0.4","css-loader":"^2.0.1","eslint":"^4.19.1","eslint-config-semistandard":"^7.0.0","eslint-config-standard":"^6.0.1","eslint-plugin-promise":"^3.3.0","eslint-plugin-react":"^7.9.1","eslint-plugin-standard":"^2.0.0","mini-css-extract-plugin":"^0.4.0","postcss":"^7.0.7","postcss-custom-properties":"^8.0.9","postcss-import":"^12.0.1","postcss-loader":"3.0.0","pre-commit":"^1.2.2","prop-types":"^15.6.1","react":"^16.4.0","react-docgen":"^2.20.0","react-dom":"^16.4.0","react-frame-component":"^3.0.0","react-styleguidist":"^7.0.17","stylelint":"^9.3.0","stylelint-config-standard":"^16.0.0","webpack":"^4.12.0","webpack-bundle-analyzer":"^2.9.2","webpack-cli":"^3.0.3","webpack-merge":"^4.0.0"},"bin":{"generate_scheme":"./tasks/generate_scheme.js"},"peerDependencies":{"react-dom":"^16.4.0","react":"^16.4.0","@vkontakte/vkui-connect":"^1.1.2","prop-types":"^15.6.1"},"dependencies":{"@vkontakte/icons":"^1.2.3"},"scripts":{"prepublishOnly":"npm run clear && npm run build","styleguide":"NODE_ENV=development styleguidist server --config=styleguide/config.js","dev":"NODE_ENV=development webpack --watch","styleguide:build":"NODE_ENV=production styleguidist build --config=styleguide/config.js","build":"NODE_ENV=production webpack && babel src --out-dir dist --source-maps","clear":"rm -rf dist/*","test":"eslint . && stylelint './src/**/*.css'"},"pre-commit":["test"]};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

(function(window) {
  var FUNCTION = 'function';
  var UNDEFINED = 'undefined';
  var subscribers = [];
  var isWeb = typeof window !== UNDEFINED && !window.AndroidBridge && !window.webkit;
  var eventType = isWeb ? 'message' : 'VKWebAppEvent';

  if (typeof window !== UNDEFINED) {

    //polyfill
    if (!window.CustomEvent) {
      (function() {
        function CustomEvent(event, params) {
          params = params || {bubbles: false, cancelable: false, detail: undefined};
          var evt = document.createEvent('CustomEvent');
          evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
          return evt;
        };

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
      })();
    }

    window.addEventListener(eventType, function() {
      var args = Array.prototype.slice.call(arguments);
      if (isWeb) {
        subscribers.forEach(function(fn) {
          fn({
            detail: args[0].data
          });
        });
      } else {
        subscribers.forEach(function(fn) {
          fn.apply(null, args);
        });
      }
    });
  }

  module.exports = {
    /**
     * Sends a message to native client
     *
     * @example
     * message.send('VKWebAppInit');
     *
     * @param {String} handler Message type
     * @param {Object} params Message data
     * @returns {void}
     */
    send: function send(handler, params) {
      if (!params) {
        params = {};
      }

      var isClient = typeof window !== UNDEFINED;
      var androidBridge = isClient && window.AndroidBridge;
      var iosBridge = isClient && window.webkit && window.webkit.messageHandlers;
      var isDesktop = !androidBridge && !iosBridge;

      if (androidBridge && typeof androidBridge[handler] == FUNCTION) {
        androidBridge[handler](JSON.stringify(params));
      }
      if (iosBridge && iosBridge[handler] && typeof iosBridge[handler].postMessage == FUNCTION) {
        iosBridge[handler].postMessage(params);
      }

      if (isDesktop) {
        parent.postMessage({
          handler: handler,
          params: params,
          type: 'vk-connect'
        }, '*');
      }
    },
    /**
     * Subscribe on VKWebAppEvent
     *
     * @param {Function} fn Event handler
     * @returns {void}
     */
    subscribe: function subscribe(fn) {
      subscribers.push(fn);
    },
    /**
     * Unsubscribe on VKWebAppEvent
     *
     * @param {Function} fn Event handler
     * @returns {void}
     */
    unsubscribe: function unsubscribe(fn) {
      var index = subscribers.indexOf(fn);

      if (index > -1) {
        subscribers.splice(index, 1);
      }
    },

    /**
     * Checks if native client supports nandler
     *
     * @param {String} handler Handler name
     * @returns {boolean}
     */
    supports: function supports(handler) {

      var isClient = typeof window !== UNDEFINED;
      var androidBridge = isClient && window.AndroidBridge;
      var iosBridge = isClient && window.webkit && window.webkit.messageHandlers;
      var desktopEvents = [
        "VKWebAppGetAuthToken",
        "VKWebAppCallAPIMethod",
        "VKWebAppGetGeodata",
        "VKWebAppGetUserInfo",
        "VKWebAppGetPhoneNumber",
        "VKWebAppGetClientVersion",
        "VKWebAppOpenPayForm",
        "VKWebAppShare",
        "VKWebAppAllowNotifications",
        "VKWebAppDenyNotifications",
        "VKWebAppShowWallPostBox",
        "VKWebAppGetEmail",
        "VKWebAppAllowMessagesFromGroup",
        "VKWebAppJoinGroup",
        "VKWebAppOpenApp",
        "VKWebAppSetLocation",
        "VKWebAppScroll",
        "VKWebAppResizeWindow",
      ];

      if (androidBridge && typeof androidBridge[handler] == FUNCTION) return true;

      if (iosBridge && iosBridge[handler] && typeof iosBridge[handler].postMessage == FUNCTION) return true;

      if (!iosBridge && !androidBridge && ~desktopEvents.indexOf(handler)) return true;

      return false;
    }
  };
})(window);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 120);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "search_24",
  "use": "search_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"search_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M16.535 15.12l4.172 4.173a1 1 0 0 1-1.414 1.414l-4.172-4.172a7.25 7.25 0 1 1 1.414-1.414zM10.75 16a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 215);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "back_24",
  "use": "back_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"back_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 0H0v24h24z\" /><path d=\"M7.8 11l4.9-4.9a.99.99 0 0 0-1.4-1.4l-6.593 6.593a1 1 0 0 0 0 1.414L11.3 19.3a.99.99 0 0 0 1.4-1.4L7.8 13H20a1 1 0 0 0 0-2H7.8z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 230);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "search_16",
  "use": "search_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"search_16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M14.743 13.574L10.91 9.74a5.426 5.426 0 0 0 1.05-3.232A5.532 5.532 0 0 0 6.46 1 5.436 5.436 0 0 0 1 6.468a5.532 5.532 0 0 0 5.5 5.508 5.408 5.408 0 0 0 3.242-1.061l.004-.003 3.83 3.831a.826.826 0 1 0 1.167-1.169zm-8.247-2.696a4.425 4.425 0 0 1-4.4-4.406 4.35 4.35 0 0 1 4.368-4.374 4.426 4.426 0 0 1 4.4 4.406 4.35 4.35 0 0 1-4.368 4.374z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 129);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "reorder_ios_24",
  "use": "reorder_ios_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"reorder_ios_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path opacity=\".1\" d=\"M0 0h24v24H0z\" /><path d=\"M2.75 7h18.5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0 4h18.5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 1 1 0-1.5zm0 4h18.5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 1 1 0-1.5z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 130);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "reorder_24",
  "use": "reorder_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"reorder_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M21 18a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zm0-4a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zm0-4a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zM3 6a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 209);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "chevron_24",
  "use": "chevron_24-usage",
  "viewBox": "0 0 16 24",
  "content": "<symbol viewBox=\"0 0 16 24\" id=\"chevron_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v24H0z\" /><path d=\"M4.706 7.706a1 1 0 0 1 0-1.412l.088-.088a.997.997 0 0 1 1.414.002l5.084 5.084a.998.998 0 0 1 0 1.416l-5.084 5.084a1.002 1.002 0 0 1-1.414.002l-.088-.088a.995.995 0 0 1 0-1.412L9 12 4.706 7.706z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 228);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "spinner_16",
  "use": "spinner_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"spinner_16\"><path d=\"M8 16a1 1 0 1 1 0-2 6 6 0 1 0-5.7-4.12 1 1 0 1 1-1.9.626A8 8 0 1 1 8 16z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "spinner_44",
  "use": "spinner_44-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" id=\"spinner_44\"><path d=\"M22 44a1.5 1.5 0 0 1 0-3c10.493 0 19-8.507 19-19S32.493 3 22 3 3 11.507 3 22c0 2.208.376 4.363 1.103 6.397a1.5 1.5 0 1 1-2.825 1.01A21.964 21.964 0 0 1 0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })
/******/ ]);
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 22);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "spinner_32",
  "use": "spinner_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"spinner_32\"><path d=\"M16 32a1.5 1.5 0 0 1 0-3c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16c0 1.557.273 3.074.8 4.502A1.5 1.5 0 1 1 .986 21.54 15.97 15.97 0 0 1 0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(2));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 105);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "spinner_24",
  "use": "spinner_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"spinner_24\"><path d=\"M12 24a1.25 1.25 0 1 1 0-2.5A9.5 9.5 0 1 0 2.5 12c0 1.1.187 2.175.548 3.188a1.25 1.25 0 0 1-2.355.84A11.981 11.981 0 0 1 0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/lib/polyfills.js
var polyfills = __webpack_require__(24);

// EXTERNAL MODULE: ./src/styles/styles.css
var styles = __webpack_require__(23);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// CONCATENATED MODULE: ./src/lib/classnames.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function classNames() {
  var result = [];
  Array.prototype.slice.call(arguments).forEach(function (item) {
    if (!item) {
      return;
    }

    switch (_typeof(item)) {
      case 'string':
        result.push(item);
        break;

      case 'object':
        Object.keys(item).forEach(function (key) {
          if (item[key]) {
            result.push(key);
          }
        });
        break;

      default:
        result.push('' + item);
    }
  });
  return result.join(' ');
}
// CONCATENATED MODULE: ./src/lib/platform.js
var ANDROID = 'android';
var IOS = 'ios';
var ua;
var platformName;
function platform(useragent) {
  if (!ua) {
    ua = useragent || navigator && navigator.userAgent || '';
  }

  if (!platformName) {
    platformName = /android/i.test(ua) ? ANDROID : IOS;
  }

  return platformName;
}
// CONCATENATED MODULE: ./src/helpers/getClassName.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var osname = platform();
function getClassname(base) {
  var _classnames;

  return classNames(base, (_classnames = {}, _defineProperty(_classnames, base + '--ios', osname === IOS), _defineProperty(_classnames, base + '--android', osname === ANDROID), _classnames));
}
// CONCATENATED MODULE: ./src/lib/transitionEvents.js
var supported, prefix;

if (typeof document !== 'undefined' && document.createElement) {
  var d = document.createElement('div');

  for (var transitionEvents_i in d.style) {
    var m = transitionEvents_i.match(/^(moz|webkit|ms|)(transition|animation)$/i);
    if (m) supported = true;

    if (m && m[1]) {
      // согласно спецификации, префиксы к событиям должны быть в нижнем регистре
      // https://www.w3schools.com/jsref/event_transitionend.asp
      prefix = m[1].toLowerCase();
    }
  }
}

/* harmony default export */ var transitionEvents = ({
  supported: supported,
  prefix: prefix
});
// CONCATENATED MODULE: ./src/components/Root/Root.js
function Root_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Root_typeof = function _typeof(obj) { return typeof obj; }; } else { Root_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Root_typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Root_defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (Root_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Root_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Root_osname = platform();
var baseClassName = getClassname('Root');

var Root_Root =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Root, _React$Component);

  function Root(props) {
    var _this;

    _classCallCheck(this, Root);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Root).call(this));

    Root_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onAnimationEnd", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        manual: true
      };

      if (['root-android-animation-hide-back', 'root-android-animation-show-forward', 'root-ios-animation-hide-back', 'root-ios-animation-show-forward'].indexOf(e.animationName) > -1 || e.manual) {
        var isBack = _this.state.isBack;
        var prevView = _this.state.prevView;
        var nextView = _this.state.nextView;

        _this.setState({
          activeView: nextView,
          prevView: null,
          nextView: null,
          visibleViews: [nextView],
          transition: false,
          isBack: undefined
        }, function () {
          isBack ? _this.window.scrollTo(0, _this.state.scrolls[_this.state.activeView]) : _this.window.scrollTo(0, 0);
          _this.props.onTransition && _this.props.onTransition({
            isBack: isBack,
            from: prevView,
            to: nextView
          });
        });
      }
    });

    _this.state = {
      activeView: props.activeView,
      prevView: null,
      nextView: null,
      visibleViews: [props.activeView],
      isBack: undefined,
      scrolls: {}
    };
    _this.arrayChildren = external_react_default.a.Children.toArray(props.children);
    return _this;
  }

  _createClass(Root, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.popout && !this.props.popout) {
        this.blurActiveElement();
      }

      if (nextProps.children !== this.props.children) {
        this.arrayChildren = external_react_default.a.Children.toArray(nextProps.children);
      }

      if (nextProps.activeView !== this.props.activeView) {
        var pageYOffset = this.window.pageYOffset;
        var firstLayerId = this.props.children.find(function (view) {
          return view.props.id === _this2.props.activeView || view.props.id === nextProps.activeView;
        }).props.id;
        var isBack = firstLayerId === nextProps.activeView;
        this.blurActiveElement();
        var nextView = nextProps.activeView;
        var prevView = this.props.activeView;
        this.setState({
          scrolls: _objectSpread({}, this.state.scrolls, Root_defineProperty({}, this.props.activeView, pageYOffset)),
          transition: true,
          activeView: null,
          nextView: nextView,
          prevView: prevView,
          visibleViews: [nextView, prevView],
          isBack: isBack
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.transition && this.state.transition) {
        var prevViewElement = this.document.getElementById("view-".concat(this.state.prevView));
        var nextViewElement = this.document.getElementById("view-".concat(this.state.nextView));
        prevViewElement.querySelector('.View__panel').scrollTop = this.state.scrolls[this.state.prevView];

        if (this.state.isBack) {
          nextViewElement.querySelector('.View__panel').scrollTop = this.state.scrolls[this.state.nextView];
        }

        this.waitAnimationFinish(this.state.isBack ? prevViewElement : nextViewElement, this.onAnimationEnd);
      }
    }
  }, {
    key: "waitAnimationFinish",
    value: function waitAnimationFinish(elem, eventHandler) {
      if (transitionEvents.supported) {
        var eventName = transitionEvents.prefix ? transitionEvents.prefix + 'AnimationEnd' : 'animationend';
        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), Root_osname === ANDROID ? 300 : 600);
      }
    }
  }, {
    key: "blurActiveElement",
    value: function blurActiveElement() {
      if (typeof this.window !== 'undefined' && this.document.activeElement) {
        this.document.activeElement.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var Views = this.arrayChildren.filter(function (View) {
        return _this3.state.visibleViews.indexOf(View.props.id) >= 0;
      });
      var _this$state = this.state,
          transition = _this$state.transition,
          isBack = _this$state.isBack,
          prevView = _this$state.prevView,
          activeView = _this$state.activeView,
          nextView = _this$state.nextView;
      return external_react_default.a.createElement("div", {
        className: classNames(baseClassName, {
          'Root--transition': transition
        })
      }, Views.map(function (View) {
        return external_react_default.a.createElement("div", {
          key: View.props.id,
          id: "view-".concat(View.props.id),
          className: classNames('Root__view', {
            'Root__view--hide-back': View.props.id === prevView && isBack,
            'Root__view--hide-forward': View.props.id === prevView && !isBack,
            'Root__view--show-back': View.props.id === nextView && isBack,
            'Root__view--show-forward': View.props.id === nextView && !isBack,
            'Root__view--active': View.props.id === activeView
          })
        }, external_react_default.a.cloneElement(View, {
          inRoot: true,
          isNext: View.props.id === nextView,
          isPrev: View.props.id === prevView
        }));
      }), this.props.popout && external_react_default.a.createElement("div", {
        className: "Root__popout"
      }, this.props.popout));
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
  }, {
    key: "window",
    get: function get() {
      return this.context.window || window;
    }
  }]);

  return Root;
}(external_react_default.a.Component);

Root_defineProperty(Root_Root, "propTypes", {
  activeView: external_prop_types_default.a.string.isRequired,
  popout: external_prop_types_default.a.node,
  onTransition: external_prop_types_default.a.func,
  children: external_prop_types_default.a.node
});

Root_defineProperty(Root_Root, "defaultProps", {
  popout: null
});

Root_defineProperty(Root_Root, "contextTypes", {
  window: external_prop_types_default.a.any,
  document: external_prop_types_default.a.any
});


// CONCATENATED MODULE: ./src/lib/animate.js
/**
 * Функция для js анимации
 * @param {number} duration
 * @param {function} timing тайминг функция анимации
 * @param {function} draw коллбэк, в который прокидывается прогресс [0, 1]
 * @returns {void}
 */
function animate(_ref) {
  var duration = _ref.duration,
      timing = _ref.timing,
      draw = _ref.draw;

  if (typeof window === 'undefined') {
    return;
  }

  var start = window.performance.now();
  window.requestAnimationFrame(function animate(time) {
    var timeFraction = (time - start) / duration;

    if (timeFraction > 1) {
      timeFraction = 1;
    }

    var progress = timing(timeFraction);
    draw(progress);

    if (timeFraction < 1) {
      window.requestAnimationFrame(animate);
    }
  });
}
// CONCATENATED MODULE: ./src/lib/touch.js
/**
 * Получает кординату по оси абсцисс из touch- или mouse-события
 *
 * @param {Object} e Бразуерное событие
 * @returns {Number} Координата взаимодействия по оси абсцисс
 */
var coordX = function coordX(e) {
  return e.clientX || e.touches && e.touches[0].clientX;
};
/**
 * Получает кординату по оси ординат из touch- или mouse-события
 *
 * @param {Object} e Бразуерное событие
 * @returns {Number} Координата взаимодействия по оси ординат
 */


var coordY = function coordY(e) {
  return e.clientY || e.touches && e.touches[0].clientY;
};

var isClient = typeof window !== 'undefined';
var touchEnabled = isClient && 'ontouchstart' in window;
/**
 * Возвращает массив поддерживаемых событий
 * Если браузер поддерживает pointer events или подключена handjs, вернет события указателя.
 * Если нет, используем события мыши
 *
 * @returns {Array} Массив с названиями событий
 */

function getSupportedEvents() {
  if (touchEnabled) {
    return ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
  }

  return ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];
}


// CONCATENATED MODULE: ./src/components/Touch/Touch.js
function Touch_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Touch_typeof = function _typeof(obj) { return typeof obj; }; } else { Touch_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Touch_typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Touch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Touch_defineProperty(target, key, source[key]); }); } return target; }

function Touch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Touch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Touch_createClass(Constructor, protoProps, staticProps) { if (protoProps) Touch_defineProperties(Constructor.prototype, protoProps); if (staticProps) Touch_defineProperties(Constructor, staticProps); return Constructor; }

function Touch_possibleConstructorReturn(self, call) { if (call && (Touch_typeof(call) === "object" || typeof call === "function")) { return call; } return Touch_assertThisInitialized(self); }

function Touch_getPrototypeOf(o) { Touch_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Touch_getPrototypeOf(o); }

function Touch_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Touch_setPrototypeOf(subClass, superClass); }

function Touch_setPrototypeOf(o, p) { Touch_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Touch_setPrototypeOf(o, p); }

function Touch_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Touch_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var events = getSupportedEvents();

var Touch_Touch =
/*#__PURE__*/
function (_Component) {
  Touch_inherits(Touch, _Component);

  function Touch() {
    var _getPrototypeOf2;

    var _this;

    Touch_classCallCheck(this, Touch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Touch_possibleConstructorReturn(this, (_getPrototypeOf2 = Touch_getPrototypeOf(Touch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "cancelClick", false);

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "gesture", {});

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "onStart", function (e) {
      _this.gesture = {
        startX: coordX(e),
        startY: coordY(e),
        startT: new Date(),
        isPressed: true
      }; // Вызываем нужные колбеки из props

      var outputEvent = Touch_objectSpread({}, _this.gesture, {
        originalEvent: e
      });

      if (_this.props.onStart) {
        _this.props.onStart(outputEvent);
      }

      if (_this.props.onStartX) {
        _this.props.onStartX(outputEvent);
      }

      if (_this.props.onStartY) {
        _this.props.onStartY(outputEvent);
      }

      !touchEnabled && _this.subscribe(_this.document);
    });

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "onMove", function (e) {
      var _this$gesture = _this.gesture,
          isPressed = _this$gesture.isPressed,
          isX = _this$gesture.isX,
          isY = _this$gesture.isY,
          startX = _this$gesture.startX,
          startY = _this$gesture.startY;

      if (isPressed) {
        // смещения
        var shiftX = coordX(e) - startX;
        var shiftY = coordY(e) - startY; // абсолютные значения смещений

        var shiftXAbs = Math.abs(shiftX);
        var shiftYAbs = Math.abs(shiftY); // Если определяем мультитач, то прерываем жест

        if (!!e.touches && e.touches.length > 1) {
          return _this.onEnd(e);
        } // если мы ещё не определились


        if (!isX && !isY) {
          var willBeX = shiftXAbs >= 5 && shiftXAbs > shiftYAbs;
          var willBeY = shiftYAbs >= 5 && shiftYAbs > shiftXAbs;
          var willBeSlidedX = willBeX && !!_this.props.onMoveX || !!_this.props.onMove;
          var willBeSlidedY = willBeY && !!_this.props.onMoveY || !!_this.props.onMove;
          _this.gesture.isY = willBeY;
          _this.gesture.isX = willBeX;
          _this.gesture.isSlideX = willBeSlidedX;
          _this.gesture.isSlideY = willBeSlidedY;
          _this.gesture.isSlide = willBeSlidedX || willBeSlidedY;
        }

        if (_this.gesture.isSlide) {
          _this.gesture.shiftX = shiftX;
          _this.gesture.shiftY = shiftY;
          _this.gesture.shiftXAbs = shiftXAbs;
          _this.gesture.shiftYAbs = shiftYAbs; // Вызываем нужные колбеки из props

          var outputEvent = Touch_objectSpread({}, _this.gesture, {
            originalEvent: e
          });

          if (_this.props.onMove) {
            _this.props.onMove(outputEvent);
          }

          if (_this.gesture.isSlideX && _this.props.onMoveX) {
            _this.props.onMoveX(outputEvent);
          }

          if (_this.gesture.isSlideY && _this.props.onMoveY) {
            _this.props.onMoveY(outputEvent);
          }
        }
      }
    });

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "onEnd", function (e) {
      var _this$gesture2 = _this.gesture,
          isPressed = _this$gesture2.isPressed,
          isSlide = _this$gesture2.isSlide,
          isSlideX = _this$gesture2.isSlideX,
          isSlideY = _this$gesture2.isSlideY;

      if (isPressed) {
        // Вызываем нужные колбеки из props
        var outputEvent = Touch_objectSpread({}, _this.gesture, {
          originalEvent: e
        });

        if (_this.props.onEnd) {
          _this.props.onEnd(outputEvent);
        }

        if (isSlideY && _this.props.onEndY) {
          _this.props.onEndY(outputEvent);
        }

        if (isSlideX && _this.props.onEndX) {
          _this.props.onEndX(outputEvent);
        }
      } // Если закончили жест на ссылке, выставляем флаг для отмены перехода


      _this.cancelClick = e.target.tagName === 'A' && isSlide;
      _this.gesture = {};
      !touchEnabled && _this.unsubscribe(_this.document);
    });

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "onDragStart", function (e) {
      if (e.target.tagName === 'A' || e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    });

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "onClick", function (e) {
      if (_this.cancelClick) {
        _this.cancelClick = false;
        e.preventDefault();
      }

      _this.props.onClick && _this.props.onClick(e);
    });

    Touch_defineProperty(Touch_assertThisInitialized(Touch_assertThisInitialized(_this)), "getRef", function (container) {
      _this.container = container;
      _this.props.getRootRef && _this.props.getRootRef(container);
    });

    return _this;
  }

  Touch_createClass(Touch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.container.addEventListener(events[0], this.onStart, {
        capture: this.props.useCapture,
        passive: false
      });
      touchEnabled && this.subscribe(this.container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.container.removeEventListener(events[0], this.onStart, {
        capture: this.props.useCapture,
        passive: false
      });
      touchEnabled && this.unsubscribe(this.container);
    }
    /**
     * Обработчик событий touchstart
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */

  }, {
    key: "subscribe",
    value: function subscribe(element) {
      element.addEventListener(events[1], this.onMove, {
        capture: this.props.useCapture,
        passive: false
      });
      element.addEventListener(events[2], this.onEnd, {
        capture: this.props.useCapture,
        passive: false
      });
      element.addEventListener(events[3], this.onEnd, {
        capture: this.props.useCapture,
        passive: false
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(element) {
      element.removeEventListener(events[1], this.onMove, {
        capture: this.props.useCapture,
        passive: false
      });
      element.removeEventListener(events[2], this.onEnd, {
        capture: this.props.useCapture,
        passive: false
      });
      element.removeEventListener(events[3], this.onEnd, {
        capture: this.props.useCapture,
        passive: false
      });
    }
    /**
     * Обработчик событий dragstart
     * Отменяет нативное браузерное поведение для вложенных ссылок и изображений
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onStart = _this$props.onStart,
          onStartX = _this$props.onStartX,
          onStartY = _this$props.onStartY,
          onMove = _this$props.onMove,
          onMoveX = _this$props.onMoveX,
          onMoveY = _this$props.onMoveY,
          onEnd = _this$props.onEnd,
          onEndX = _this$props.onEndX,
          onEndY = _this$props.onEndY,
          useCapture = _this$props.useCapture,
          component = _this$props.component,
          getRootRef = _this$props.getRootRef,
          restProps = _objectWithoutProperties(_this$props, ["onStart", "onStartX", "onStartY", "onMove", "onMoveX", "onMoveY", "onEnd", "onEndX", "onEndY", "useCapture", "component", "getRootRef"]);

      var ComponentName = component;
      return external_react_default.a.createElement(ComponentName, _extends({}, restProps, {
        onDragStart: this.onDragStart,
        onClick: this.onClick,
        ref: this.getRef
      }), this.props.children);
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
  }]);

  return Touch;
}(external_react_["Component"]);

Touch_defineProperty(Touch_Touch, "propTypes", {
  onStart: external_prop_types_default.a.func,
  onStartX: external_prop_types_default.a.func,
  onStartY: external_prop_types_default.a.func,
  onMove: external_prop_types_default.a.func,
  onMoveX: external_prop_types_default.a.func,
  onMoveY: external_prop_types_default.a.func,
  onEnd: external_prop_types_default.a.func,
  onEndX: external_prop_types_default.a.func,
  onEndY: external_prop_types_default.a.func,
  useCapture: external_prop_types_default.a.bool,
  component: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,
  onClick: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func
});

Touch_defineProperty(Touch_Touch, "defaultProps", {
  component: 'div',
  children: '',
  useCapture: false
});

Touch_defineProperty(Touch_Touch, "contextTypes", {
  document: external_prop_types_default.a.any
});


// CONCATENATED MODULE: ./src/lib/removeObjectKeys.js
function removeObjectKeys_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { removeObjectKeys_defineProperty(target, key, source[key]); }); } return target; }

function removeObjectKeys_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function removeObjectKeys() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var newObj = removeObjectKeys_objectSpread({}, obj);

  keys.forEach(function (key) {
    return delete newObj[key];
  });
  return newObj;
}
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(4);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);

// CONCATENATED MODULE: ./src/components/PanelHeader/PanelHeader.js
function PanelHeader_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { PanelHeader_typeof = function _typeof(obj) { return typeof obj; }; } else { PanelHeader_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return PanelHeader_typeof(obj); }

function PanelHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PanelHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PanelHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) PanelHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) PanelHeader_defineProperties(Constructor, staticProps); return Constructor; }

function PanelHeader_possibleConstructorReturn(self, call) { if (call && (PanelHeader_typeof(call) === "object" || typeof call === "function")) { return call; } return PanelHeader_assertThisInitialized(self); }

function PanelHeader_getPrototypeOf(o) { PanelHeader_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PanelHeader_getPrototypeOf(o); }

function PanelHeader_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) PanelHeader_setPrototypeOf(subClass, superClass); }

function PanelHeader_setPrototypeOf(o, p) { PanelHeader_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PanelHeader_setPrototypeOf(o, p); }

function PanelHeader_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PanelHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var PanelHeader_osname = platform();
var baseClassNames = getClassname('PanelHeader');

var PanelHeader_PanelHeader =
/*#__PURE__*/
function (_React$Component) {
  PanelHeader_inherits(PanelHeader, _React$Component);

  function PanelHeader() {
    var _getPrototypeOf2;

    var _this;

    PanelHeader_classCallCheck(this, PanelHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = PanelHeader_possibleConstructorReturn(this, (_getPrototypeOf2 = PanelHeader_getPrototypeOf(PanelHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    PanelHeader_defineProperty(PanelHeader_assertThisInitialized(PanelHeader_assertThisInitialized(_this)), "state", {
      ready: false
    });

    return _this;
  }

  PanelHeader_createClass(PanelHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.leftNode = this.document.getElementById('header-left-' + this.context.panel);
      this.addonNode = this.document.getElementById('header-addon-' + this.context.panel);
      this.titleNode = this.document.getElementById('header-title-' + this.context.panel);
      this.rightNode = this.document.getElementById('header-right-' + this.context.panel);
      this.bgNode = this.document.getElementById('header-bg-' + this.context.panel);
      this.props.getRef && this.props.getRef(this.document.getElementById("panel-header-".concat(this.context.panel)));
      this.setState({
        ready: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

      var _this$props = this.props,
          left = _this$props.left,
          addon = _this$props.addon,
          children = _this$props.children,
          right = _this$props.right,
          theme = _this$props.theme,
          noShadow = _this$props.noShadow,
          transparent = _this$props.transparent;
      var isPrimitive = typeof children === 'string' || typeof children === 'number';
      return this.state.ready ? [external_react_dom_default.a.createPortal(external_react_default.a.createElement("div", {
        className: classNames('PanelHeader-bg', (_classnames = {}, PanelHeader_defineProperty(_classnames, "PanelHeader-bg--".concat(theme), true), PanelHeader_defineProperty(_classnames, 'PanelHeader-bg--tp', transparent), PanelHeader_defineProperty(_classnames, "PanelHeader-bg--no-shadow", noShadow || ['bright_light', 'space_gray'].indexOf(this.context.scheme) >= 0), _classnames))
      }), this.bgNode), external_react_dom_default.a.createPortal(external_react_default.a.createElement("div", {
        className: classNames('PanelHeader-left-in', (_classnames2 = {}, PanelHeader_defineProperty(_classnames2, "PanelHeader-left-in--".concat(theme), true), PanelHeader_defineProperty(_classnames2, 'PanelHeader-left-in--tp', transparent), _classnames2))
      }, left), this.leftNode), PanelHeader_osname === IOS && external_react_dom_default.a.createPortal(external_react_default.a.createElement("div", {
        className: classNames('PanelHeader-addon', (_classnames3 = {}, PanelHeader_defineProperty(_classnames3, "PanelHeader-addon--".concat(theme), true), PanelHeader_defineProperty(_classnames3, 'PanelHeader-addon--tp', transparent), _classnames3))
      }, addon), this.addonNode), external_react_dom_default.a.createPortal(external_react_default.a.createElement("div", {
        className: classNames('PanelHeader-content', (_classnames4 = {}, PanelHeader_defineProperty(_classnames4, "PanelHeader-content--".concat(theme), true), PanelHeader_defineProperty(_classnames4, 'PanelHeader-content--tp', transparent), _classnames4))
      }, isPrimitive ? external_react_default.a.createElement("span", null, children) : children), this.titleNode), external_react_dom_default.a.createPortal(external_react_default.a.createElement("div", {
        className: classNames('PanelHeader-right', (_classnames5 = {}, PanelHeader_defineProperty(_classnames5, "PanelHeader-right--".concat(theme), true), PanelHeader_defineProperty(_classnames5, 'PanelHeader-right--tp', transparent), PanelHeader_defineProperty(_classnames5, 'PanelHeader-right--vkapps', this.webviewType === 'vkapps'), _classnames5))
      }, this.webviewType === 'internal' ? right : null), this.rightNode)] : null;
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
  }, {
    key: "webviewType",
    get: function get() {
      return this.context.webviewType || 'vkapps';
    }
  }]);

  return PanelHeader;
}(external_react_default.a.Component);

PanelHeader_defineProperty(PanelHeader_PanelHeader, "propTypes", {
  left: external_prop_types_default.a.node,

  /**
   * iOS only
   */
  addon: external_prop_types_default.a.node,
  right: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,

  /**
   * Вместо `light` используйте `alternate`. Значение `light` устарело и будет удалено в следующей
   * мажорной версии.
   */
  theme: external_prop_types_default.a.oneOf(['light', 'alternate', 'brand']),

  /**
   * @ignore
   */
  transparent: external_prop_types_default.a.bool,
  noShadow: external_prop_types_default.a.bool,
  getRef: external_prop_types_default.a.func
});

PanelHeader_defineProperty(PanelHeader_PanelHeader, "defaultProps", {
  theme: 'brand',
  transparent: false,
  noShadow: false
});

PanelHeader_defineProperty(PanelHeader_PanelHeader, "contextTypes", {
  panel: external_prop_types_default.a.string,
  document: external_prop_types_default.a.any,
  scheme: external_prop_types_default.a.string,
  webviewType: external_prop_types_default.a.oneOf(['vkapps', 'internal'])
});


// CONCATENATED MODULE: ./src/components/View/View.js
function View_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { View_typeof = function _typeof(obj) { return typeof obj; }; } else { View_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return View_typeof(obj); }

function View_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { View_defineProperty(target, key, source[key]); }); } return target; }

function View_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function View_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function View_createClass(Constructor, protoProps, staticProps) { if (protoProps) View_defineProperties(Constructor.prototype, protoProps); if (staticProps) View_defineProperties(Constructor, staticProps); return Constructor; }

function View_possibleConstructorReturn(self, call) { if (call && (View_typeof(call) === "object" || typeof call === "function")) { return call; } return View_assertThisInitialized(self); }

function View_getPrototypeOf(o) { View_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return View_getPrototypeOf(o); }

function View_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) View_setPrototypeOf(subClass, superClass); }

function View_setPrototypeOf(o, p) { View_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return View_setPrototypeOf(o, p); }

function View_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function View_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var View_osname = platform();
var View_baseClassNames = getClassname('View');
var transitionStartEventName = 'VKUI:View:transition-start';
var transitionEndEventName = 'VKUI:View:transition-end';

var View_View =
/*#__PURE__*/
function (_Component) {
  View_inherits(View, _Component);

  function View(props) {
    var _this;

    View_classCallCheck(this, View);

    _this = View_possibleConstructorReturn(this, View_getPrototypeOf(View).call(this, props));

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "refsStore", {});

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "transitionEndHandler", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        manual: true
      };

      if (['animation-ios-next-forward', 'animation-ios-next-back', 'animation-ios-prev-forward', 'animation-ios-prev-back', 'animation-android-next-forward', 'animation-android-prev-back'].indexOf(e.animationName) > -1 || e.manual) {
        var activePanel = _this.props.activePanel;
        var isBack = _this.state.isBack;
        var prevPanel = _this.state.prevPanel;

        _this.document.dispatchEvent(new _this.window.CustomEvent(transitionEndEventName));

        _this.setState({
          prevPanel: null,
          nextPanel: null,
          visiblePanels: [activePanel],
          activePanel: activePanel,
          animated: false,
          isBack: undefined,
          scrolls: isBack ? removeObjectKeys(_this.state.scrolls, [prevPanel]) : _this.state.scrolls
        }, function () {
          isBack && this.window.scrollTo(0, this.state.scrolls[activePanel]);
          this.props.onTransition && this.props.onTransition({
            isBack: isBack,
            from: prevPanel,
            to: activePanel
          });
        });
      }
    });

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "swipingBackTransitionEndHandler", function (e) {
      // indexOf because of vendor prefixes in old browsers
      if (e.propertyName.indexOf('transform') >= 0 && e.target.classList.contains('View__panel--swipe-back-next')) {
        _this.state.swipingBackFinish ? _this.onSwipeBackSuccess() : _this.onSwipeBackCancel();
      }
    });

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "onScrollTop", function () {
      var activePanel = _this.state.activePanel;

      if (activePanel) {
        var scrollTop = _this.document.body.scrollTop || _this.document.this.documentElement.scrollTop;

        if (scrollTop) {
          animate({
            duration: 200,
            timing: function timing(n) {
              return Math.sqrt(n);
            },
            draw: function draw(val) {
              _this.window.scrollTo(0, scrollTop - val * scrollTop);
            }
          });
        }
      }
    });

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "onMoveX", function (e) {
      if (View_osname === IOS && !_this.context.isWebView && (e.startX <= 70 || e.startX >= _this.window.innerWidth - 70) && !_this.state.browserSwipe) {
        _this.setState({
          browserSwipe: true
        });
      }

      if (View_osname === IOS && _this.context.isWebView && _this.props.onSwipeBack) {
        if (_this.state.animated && e.startX <= 70) {
          return;
        }

        if (e.startX <= 70 && !_this.state.swipingBack && _this.props.history.length > 1) {
          _this.setState({
            swipingBack: true,
            swipebackStartX: e.startX,
            startT: e.startT,
            swipeBackPrevPanel: _this.state.activePanel,
            swipeBackNextPanel: _this.props.history.slice(-2)[0],
            scrolls: View_objectSpread({}, _this.state.scrolls, View_defineProperty({}, _this.state.activePanel, _this.window.pageYOffset))
          });
        }

        if (_this.state.swipingBack) {
          var swipeBackShift;

          if (e.shiftX < 0) {
            swipeBackShift = 0;
          } else if (e.shiftX > _this.window.innerWidth - _this.state.swipebackStartX) {
            swipeBackShift = _this.window.innerWidth;
          } else {
            swipeBackShift = e.shiftX;
          }

          _this.setState({
            swipeBackShift: swipeBackShift
          });
        }
      }
    });

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "onEnd", function () {
      if (_this.state.swipingBack) {
        var speed = _this.state.swipeBackShift / (new Date() - _this.state.startT) * 1000;

        if (_this.state.swipeBackShift === 0) {
          _this.onSwipeBackCancel();
        } else if (_this.state.swipeBackShift >= _this.window.innerWidth) {
          _this.onSwipeBackSuccess();
        } else {
          _this.setState({
            swipingBackFinish: speed > 250 || _this.state.swipebackStartX + _this.state.swipeBackShift > _this.window.innerWidth / 2
          });
        }
      }
    });

    View_defineProperty(View_assertThisInitialized(View_assertThisInitialized(_this)), "getRef", function (c) {
      if (c && c.container && c.id) {
        var el = c;

        while (el.container) {
          el = el.container;
        }

        _this.refsStore[c.id] = el;
      }
    });

    _this.state = {
      scrolls: {},
      visiblePanels: [props.activePanel],
      activePanel: props.activePanel,
      isBack: undefined,
      prevPanel: null,
      nextPanel: null,
      swipingBack: false,
      swipebackStartX: 0,
      swipeBackShift: 0,
      swipeBackNextPanel: null,
      swipeBackPrevPanel: null,
      swipingBackFinish: null,
      browserSwipe: false
    };
    return _this;
  }

  View_createClass(View, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      nextProps.popout && !this.props.popout && this.blurActiveElement(); // Нужен переход

      if (this.props.activePanel !== nextProps.activePanel && !this.state.swipingBack && !this.state.browserSwipe) {
        var firstLayer = this.panels.find(function (panel) {
          return panel.props.id === _this2.props.activePanel || panel.props.id === nextProps.activePanel;
        });
        var isBack = firstLayer && firstLayer.props.id === nextProps.activePanel;
        this.blurActiveElement();
        this.setState({
          visiblePanels: [this.props.activePanel, nextProps.activePanel],
          prevPanel: this.props.activePanel,
          nextPanel: nextProps.activePanel,
          activePanel: null,
          animated: true,
          scrolls: View_objectSpread({}, this.state.scrolls, View_defineProperty({}, this.props.activePanel, this.window.pageYOffset)),
          isBack: isBack
        });
      } // Закончилась анимация свайпа назад


      if (this.props.activePanel !== nextProps.activePanel && this.state.swipingBack) {
        var nextPanel = nextProps.activePanel;
        var prevPanel = this.props.activePanel;
        this.setState({
          swipeBackPrevPanel: null,
          swipeBackNextPanel: null,
          swipingBack: false,
          swipingBackFinish: null,
          swipebackStartX: 0,
          swipeBackShift: 0,
          activePanel: nextPanel,
          visiblePanels: [nextPanel],
          scrolls: removeObjectKeys(this.state.scrolls, [this.state.swipeBackPrevPanel])
        }, function () {
          _this2.document.dispatchEvent(new _this2.window.CustomEvent(transitionEndEventName));

          window.scrollTo(0, _this2.state.scrolls[_this2.state.activePanel]);
          _this2.props.onTransition && _this2.props.onTransition({
            isBack: true,
            from: prevPanel,
            to: nextPanel
          });
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrolls = this.state.scrolls; // Начался переход

      if (!prevState.animated && this.state.animated) {
        this.document.dispatchEvent(new this.window.CustomEvent(transitionStartEventName, {
          detail: {
            scrolls: scrolls
          }
        }));
        var nextPanelElement = this.pickPanel(this.state.nextPanel);
        var prevPanelElement = this.pickPanel(this.state.prevPanel);
        prevPanelElement.scrollTop = scrolls[this.state.prevPanel];

        if (this.state.isBack) {
          nextPanelElement.scrollTop = scrolls[this.state.nextPanel];
        }

        this.waitAnimationFinish(this.pickPanel(this.state.isBack ? this.state.prevPanel : this.state.nextPanel), this.transitionEndHandler);
      } // Начался свайп назад


      if (!prevState.swipingBack && this.state.swipingBack) {
        this.document.dispatchEvent(new this.window.CustomEvent(transitionStartEventName, {
          detail: {
            scrolls: scrolls
          }
        }));
        this.props.onSwipeBackStart && this.props.onSwipeBackStart();

        var _nextPanelElement = this.pickPanel(this.state.swipeBackNextPanel);

        var _prevPanelElement = this.pickPanel(this.state.swipeBackPrevPanel);

        _nextPanelElement.scrollTop = scrolls[this.state.swipeBackNextPanel];
        _prevPanelElement.scrollTop = scrolls[this.state.swipeBackPrevPanel];
      } // Началась анимация завершения свайпа назад.


      if (prevState.swipingBackFinish === null && this.state.swipingBackFinish !== null) {
        this.waitTransitionFinish(this.pickPanel(this.state.swipeBackNextPanel), this.swipingBackTransitionEndHandler);
      } // Если свайп назад отменился (когда пользователь недостаточно сильно свайпнул)


      if (prevState.swipingBackFinish === false && this.state.swipingBackFinish === null) {
        this.window.scrollTo(0, scrolls[this.state.activePanel]);
      } // Закончился Safari свайп


      if (prevProps.activePanel !== this.props.activePanel && this.state.browserSwipe) {
        this.setState({
          browserSwipe: false,
          nextPanel: null,
          prevPanel: null,
          animated: false,
          visiblePanels: [this.props.activePanel],
          activePanel: this.props.activePanel
        });
      }
    }
  }, {
    key: "waitTransitionFinish",
    value: function waitTransitionFinish(elem, eventHandler) {
      if (transitionEvents.supported) {
        var eventName = transitionEvents.prefix ? transitionEvents.prefix + 'TransitionEnd' : 'transitionend';
        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), View_osname === ANDROID ? 300 : 600);
      }
    }
  }, {
    key: "waitAnimationFinish",
    value: function waitAnimationFinish(elem, eventHandler) {
      if (transitionEvents.supported) {
        var eventName = transitionEvents.prefix ? transitionEvents.prefix + 'AnimationEnd' : 'animationend';
        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), View_osname === ANDROID ? 300 : 600);
      }
    }
  }, {
    key: "blurActiveElement",
    value: function blurActiveElement() {
      if (typeof this.window !== 'undefined' && this.document.activeElement) {
        this.document.activeElement.blur();
      }
    }
  }, {
    key: "pickPanel",
    value: function pickPanel(id) {
      var elem = this.document.getElementById(id);

      if (!elem) {
        console.warn("Element #".concat(id, " not found"));
      }

      return elem && elem.parentNode.parentNode;
    }
  }, {
    key: "onSwipeBackSuccess",
    value: function onSwipeBackSuccess() {
      this.props.onSwipeBack && this.props.onSwipeBack();
    }
  }, {
    key: "onSwipeBackCancel",
    value: function onSwipeBackCancel() {
      var _this3 = this;

      this.setState({
        swipeBackPrevPanel: null,
        swipeBackNextPanel: null,
        swipingBack: false,
        swipingBackFinish: null,
        swipebackStartX: 0,
        swipeBackShift: 0
      }, function () {
        _this3.document.dispatchEvent(new _this3.window.CustomEvent(transitionEndEventName));
      });
    }
  }, {
    key: "calcPanelSwipeStyles",
    value: function calcPanelSwipeStyles(panelId) {
      var isPrev = panelId === this.state.swipeBackPrevPanel;
      var isNext = panelId === this.state.swipeBackNextPanel;

      if (!isPrev && !isNext || this.state.swipingBackFinish !== null) {
        return {};
      }

      var prevPanelTranslate = "".concat(this.state.swipeBackShift, "px");
      var nextPanelTranslate = "".concat(-50 + this.state.swipeBackShift * 100 / this.window.innerWidth / 2, "%");
      var prevPanelShadow = 0.3 * (this.window.innerWidth - this.state.swipeBackShift) / this.window.innerWidth;

      if (this.state.swipingBackFinish !== null) {
        return isPrev ? {
          boxShadow: "-2px 0 12px rgba(0, 0, 0, ".concat(prevPanelShadow, ")")
        } : {};
      }

      if (isNext) {
        return {
          transform: "translate3d(".concat(nextPanelTranslate, ", 0, 0)"),
          WebkitTransform: "translate3d(".concat(nextPanelTranslate, ", 0, 0)")
        };
      }

      if (isPrev) {
        return {
          transform: "translate3d(".concat(prevPanelTranslate, ", 0, 0)"),
          WebkitTransform: "translate3d(".concat(prevPanelTranslate, ", 0, 0)"),
          boxShadow: "-2px 0 12px rgba(0, 0, 0, ".concat(prevPanelShadow, ")")
        };
      }

      return {};
    }
  }, {
    key: "calcHeaderSwipeStyles",
    value: function calcHeaderSwipeStyles(panelId) {
      var isPrev = panelId === this.state.swipeBackPrevPanel;
      var isNext = panelId === this.state.swipeBackNextPanel;

      if (!isPrev && !isNext || this.state.swipingBackFinish !== null) {
        return {
          title: {},
          bg: {},
          left: {},
          addon: {},
          right: {}
        };
      }

      var opacity = this.state.swipeBackShift / this.window.innerWidth;
      var titleTransform = this.state.swipeBackShift / this.window.innerWidth * 30;
      var leftTransform = this.state.swipeBackShift / this.window.innerWidth * 30;

      if (isNext) {
        return {
          title: {
            transform: "translate3d(".concat(-30 + titleTransform, "vw, 0, 0)"),
            WebkitTransform: "translate3d(".concat(-30 + titleTransform, "vw, 0, 0)"),
            opacity: opacity
          },
          left: {
            opacity: opacity
          },
          addon: {
            opacity: 1,
            transform: "translate3d(".concat(-30 + leftTransform, "vw, 0, 0)"),
            WebkitTransform: "translate3d(".concat(-30 + leftTransform, "vw, 0, 0)")
          },
          right: {
            opacity: opacity
          }
        };
      }

      if (isPrev) {
        return {
          title: {
            transform: "translate3d(".concat(titleTransform, "vw, 0, 0)"),
            WebkitTransform: "translate3d(".concat(titleTransform, "vw, 0, 0)"),
            opacity: 1 - opacity
          },
          bg: {
            opacity: 1 - opacity
          },
          left: {
            opacity: 1 - opacity
          },
          addon: {
            transform: "translate3d(".concat(leftTransform, "vw, 0, 0)"),
            WebkitTransform: "translate3d(".concat(leftTransform, "vw, 0, 0)"),
            opacity: 1 - opacity
          }
        };
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var inRoot = _ref.inRoot,
          isNext = _ref.isNext,
          isPrev = _ref.isPrev;
      return inRoot ? !isNext && !isPrev : true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          style = _this$props.style,
          popout = _this$props.popout,
          header = _this$props.header;
      var _this$state = this.state,
          prevPanel = _this$state.prevPanel,
          nextPanel = _this$state.nextPanel,
          activePanel = _this$state.activePanel,
          swipeBackPrevPanel = _this$state.swipeBackPrevPanel,
          swipeBackNextPanel = _this$state.swipeBackNextPanel;
      var hasPopout = !!popout;
      var panels = this.panels.filter(function (panel) {
        return _this4.state.visiblePanels.indexOf(panel.props.id) > -1 || panel.props.id === _this4.state.swipeBackPrevPanel || panel.props.id === _this4.state.swipeBackNextPanel;
      });
      var modifiers = {
        'View--header': header,
        'View--animated': this.state.animated,
        'View--swiping-back': this.state.swipingBack
      };
      return external_react_default.a.createElement(Touch_Touch, {
        component: "section",
        className: classNames(View_baseClassNames, modifiers),
        style: style,
        onMoveX: this.onMoveX,
        onEnd: this.onEnd
      }, header && external_react_default.a.createElement("div", {
        className: "View__header"
      }, View_osname === IOS && external_react_default.a.createElement("div", {
        className: "View__header-scrolltop",
        onClick: this.onScrollTop
      }), external_react_default.a.createElement("div", {
        className: classNames(baseClassNames)
      }, panels.map(function (panel) {
        return external_react_default.a.createElement("div", {
          className: classNames('PanelHeader__in', {
            'PanelHeader__in--active': panel.props.id === activePanel,
            'PanelHeader__in--prev': panel.props.id === prevPanel,
            'PanelHeader__in--next': panel.props.id === nextPanel,
            'PanelHeader__in--swipe-back-prev': panel.props.id === _this4.state.swipeBackPrevPanel,
            'PanelHeader__in--swipe-back-next': panel.props.id === _this4.state.swipeBackNextPanel,
            'PanelHeader__in--swipe-back-success': _this4.state.swipingBackFinish === true,
            'PanelHeader__in--swipe-back-failed': _this4.state.swipingBackFinish === false
          }),
          key: panel.props.id,
          id: "panel-header-".concat(panel.props.id)
        }, external_react_default.a.createElement("div", {
          className: "PanelHeader__bg",
          key: panel.props.id,
          id: "header-bg-".concat(panel.props.id),
          style: _this4.calcHeaderSwipeStyles(panel.props.id).bg
        }), external_react_default.a.createElement("div", {
          className: "PanelHeader__container"
        }, external_react_default.a.createElement("div", {
          className: "PanelHeader__left"
        }, external_react_default.a.createElement("div", {
          className: "PanelHeader__left-in",
          id: "header-left-".concat(panel.props.id),
          style: _this4.calcHeaderSwipeStyles(panel.props.id).left
        }), View_osname === IOS && external_react_default.a.createElement("div", {
          className: "PanelHeader__addon",
          id: "header-addon-".concat(panel.props.id),
          style: _this4.calcHeaderSwipeStyles(panel.props.id).icon
        })), external_react_default.a.createElement("div", {
          className: "PanelHeader__content",
          style: _this4.calcHeaderSwipeStyles(panel.props.id).title,
          id: "header-title-".concat(panel.props.id)
        }), external_react_default.a.createElement("div", {
          className: "PanelHeader__right",
          id: "header-right-".concat(panel.props.id),
          style: _this4.calcHeaderSwipeStyles(panel.props.id).right
        })));
      }))), external_react_default.a.createElement("div", {
        className: "View__panels"
      }, panels.map(function (panel) {
        return external_react_default.a.createElement("div", {
          className: classNames('View__panel', {
            'View__panel--active': panel.props.id === activePanel,
            'View__panel--prev': panel.props.id === prevPanel,
            'View__panel--next': panel.props.id === nextPanel,
            'View__panel--swipe-back-prev': panel.props.id === _this4.state.swipeBackPrevPanel,
            'View__panel--swipe-back-next': panel.props.id === _this4.state.swipeBackNextPanel,
            'View__panel--swipe-back-success': _this4.state.swipingBackFinish === true,
            'View__panel--swipe-back-failed': _this4.state.swipingBackFinish === false
          }),
          style: _this4.calcPanelSwipeStyles(panel.props.id),
          key: panel.props.id
        }, external_react_default.a.createElement("div", {
          className: "View__panel-in"
        }, external_react_default.a.cloneElement(panel, {
          isNext: panel.props.id === nextPanel || panel.props.id === swipeBackNextPanel,
          isPrev: panel.props.id === prevPanel || panel.props.id === swipeBackPrevPanel
        })));
      })), hasPopout && external_react_default.a.createElement("div", {
        className: "View__popout"
      }, popout));
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
  }, {
    key: "window",
    get: function get() {
      return this.context.window || window;
    }
  }, {
    key: "panels",
    get: function get() {
      return [].concat(this.props.children);
    }
  }]);

  return View;
}(external_react_["Component"]);

View_defineProperty(View_View, "propTypes", {
  style: external_prop_types_default.a.object,
  activePanel: external_prop_types_default.a.string,
  header: external_prop_types_default.a.oneOfType([external_prop_types_default.a.object, external_prop_types_default.a.bool]),
  children: external_prop_types_default.a.node,
  popout: external_prop_types_default.a.node,
  onTransition: external_prop_types_default.a.func,

  /**
   * @ignore
   */
  onSwipeBack: external_prop_types_default.a.func,

  /**
   * @ignore
   */
  onSwipeBackStart: external_prop_types_default.a.func,

  /**
   * @ignore
   */
  history: external_prop_types_default.a.arrayOf(external_prop_types_default.a.string),

  /**
   * @ignore
   */
  isNext: external_prop_types_default.a.bool,

  /**
   * @ignore
   */
  isPrev: external_prop_types_default.a.bool,

  /**
   * @ignore
   */
  inRoot: external_prop_types_default.a.bool
});

View_defineProperty(View_View, "defaultProps", {
  style: {},
  children: null,
  popout: null,
  header: true,
  history: []
});

View_defineProperty(View_View, "contextTypes", {
  isWebView: external_prop_types_default.a.bool,
  window: external_prop_types_default.a.any,
  document: external_prop_types_default.a.any
});


// EXTERNAL MODULE: ./src/appearance/constants.js
var constants = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/Panel/Panel.js
function Panel_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Panel_typeof = function _typeof(obj) { return typeof obj; }; } else { Panel_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Panel_typeof(obj); }

function Panel_extends() { Panel_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Panel_extends.apply(this, arguments); }

function Panel_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Panel_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Panel_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Panel_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Panel_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Panel_createClass(Constructor, protoProps, staticProps) { if (protoProps) Panel_defineProperties(Constructor.prototype, protoProps); if (staticProps) Panel_defineProperties(Constructor, staticProps); return Constructor; }

function Panel_possibleConstructorReturn(self, call) { if (call && (Panel_typeof(call) === "object" || typeof call === "function")) { return call; } return Panel_assertThisInitialized(self); }

function Panel_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Panel_getPrototypeOf(o) { Panel_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Panel_getPrototypeOf(o); }

function Panel_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Panel_setPrototypeOf(subClass, superClass); }

function Panel_setPrototypeOf(o, p) { Panel_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Panel_setPrototypeOf(o, p); }

function Panel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Panel_baseClassNames = getClassname('Panel');

var Panel_Panel =
/*#__PURE__*/
function (_Component) {
  Panel_inherits(Panel, _Component);

  function Panel() {
    Panel_classCallCheck(this, Panel);

    return Panel_possibleConstructorReturn(this, Panel_getPrototypeOf(Panel).apply(this, arguments));
  }

  Panel_createClass(Panel, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        panel: this.props.id
      };
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var optimized = _ref.optimized,
          isNext = _ref.isNext,
          isPrev = _ref.isPrev;
      return optimized ? !isNext && !isPrev : true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          centered = _this$props.centered,
          children = _this$props.children,
          isPrev = _this$props.isPrev,
          isNext = _this$props.isNext,
          theme = _this$props.theme,
          optimized = _this$props.optimized,
          restProps = Panel_objectWithoutProperties(_this$props, ["className", "centered", "children", "isPrev", "isNext", "theme", "optimized"]);

      var tabbarPadding = this.context.hasTabbar ? constants["tabbarHeight"] : 0;
      return external_react_default.a.createElement("div", Panel_extends({}, restProps, {
        className: classNames(Panel_baseClassNames, className, Panel_defineProperty({
          'Panel--centered': centered
        }, "Panel--tm-".concat(theme), theme))
      }), external_react_default.a.createElement("div", {
        className: "Panel__in",
        style: {
          paddingBottom: this.context.insets && this.context.insets.bottom ? this.context.insets.bottom + tabbarPadding : null
        }
      }, external_react_default.a.createElement("div", {
        className: "Panel__in-before"
      }), children, external_react_default.a.createElement("div", {
        className: "Panel__in-after"
      })));
    }
  }, {
    key: "insets",
    get: function get() {
      return this.context.insets || {};
    }
  }]);

  return Panel;
}(external_react_["Component"]);

Panel_defineProperty(Panel_Panel, "childContextTypes", {
  panel: external_prop_types_default.a.string
});

Panel_defineProperty(Panel_Panel, "propTypes", {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  theme: external_prop_types_default.a.oneOf(['white', 'gray']),
  id: external_prop_types_default.a.string.isRequired,
  optimized: external_prop_types_default.a.bool,
  centered: external_prop_types_default.a.bool,
  style: external_prop_types_default.a.object,

  /**
   * @ignore
   */
  isPrev: external_prop_types_default.a.bool,

  /**
   * @ignore
   */
  isNext: external_prop_types_default.a.bool
});

Panel_defineProperty(Panel_Panel, "defaultProps", {
  children: '',
  theme: 'gray',
  centered: false,
  optimized: true
});

Panel_defineProperty(Panel_Panel, "contextTypes", {
  insets: external_prop_types_default.a.shape({
    top: external_prop_types_default.a.number,
    right: external_prop_types_default.a.number,
    bottom: external_prop_types_default.a.number,
    left: external_prop_types_default.a.number
  }),
  hasTabbar: external_prop_types_default.a.bool
});


// CONCATENATED MODULE: ./src/lib/offset.js
function getOffsetRect(elem) {
  var box = elem.getBoundingClientRect();
  var body = document.body;
  var doc = document.documentElement;
  var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || doc.scrollLeft || body.scrollLeft;
  var clientTop = doc.clientTop || body.clientTop || 0;
  var clientLeft = doc.clientLeft || body.clientLeft || 0;
  return {
    top: Math.round(box.top + scrollTop - clientTop),
    left: Math.round(box.left + scrollLeft - clientLeft),
    width: elem.offsetWidth,
    height: elem.offsetHeight
  };
}
// CONCATENATED MODULE: ./src/components/Tappable/Tappable.js
function Tappable_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Tappable_typeof = function _typeof(obj) { return typeof obj; }; } else { Tappable_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Tappable_typeof(obj); }

function Tappable_extends() { Tappable_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Tappable_extends.apply(this, arguments); }

function Tappable_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Tappable_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Tappable_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Tappable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Tappable_defineProperty(target, key, source[key]); }); } return target; }

function Tappable_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tappable_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Tappable_createClass(Constructor, protoProps, staticProps) { if (protoProps) Tappable_defineProperties(Constructor.prototype, protoProps); if (staticProps) Tappable_defineProperties(Constructor, staticProps); return Constructor; }

function Tappable_possibleConstructorReturn(self, call) { if (call && (Tappable_typeof(call) === "object" || typeof call === "function")) { return call; } return Tappable_assertThisInitialized(self); }

function Tappable_getPrototypeOf(o) { Tappable_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Tappable_getPrototypeOf(o); }

function Tappable_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Tappable_setPrototypeOf(subClass, superClass); }

function Tappable_setPrototypeOf(o, p) { Tappable_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Tappable_setPrototypeOf(o, p); }

function Tappable_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Tappable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var ts = function ts() {
  return +Date.now();
};

var Tappable_baseClassNames = getClassname('Tappable');
var Tappable_osname = platform();
var ACTIVE_DELAY = 70;
var ACTIVE_EFFECT_DELAY = 600;
var storage = {};
/**
 * Очищает таймауты и хранилище для всех экземпляров компонента, кроме переданного
 *
 * @param {String} exclude ID экземпляра-исключения
 * @returns {void}
 */

function deactivateOtherInstances(exclude) {
  Object.keys(storage).filter(function (id) {
    return id !== exclude;
  }).forEach(function (id) {
    clearTimeout(storage[id].activeTimeout);
    clearTimeout(storage[id].timeout);
    storage[id].stop();
    delete storage[id];
  });
}

var Tappable_Tappable =
/*#__PURE__*/
function (_Component) {
  Tappable_inherits(Tappable, _Component);

  function Tappable(props) {
    var _this;

    Tappable_classCallCheck(this, Tappable);

    _this = Tappable_possibleConstructorReturn(this, Tappable_getPrototypeOf(Tappable).call(this, props));

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "isSlide", false);

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "onStart", function (_ref) {
      var originalEvent = _ref.originalEvent;
      _this.props.stopPropagation && originalEvent.stopPropagation();

      if (originalEvent.touches && originalEvent.touches.length > 1) {
        return deactivateOtherInstances();
      }

      if (Tappable_osname === ANDROID) {
        _this.onDown(originalEvent);
      }

      storage[_this.id] = {};
      _this.getStorage().stop = _this.stop;
      _this.getStorage().activeTimeout = setTimeout(_this.start, ACTIVE_DELAY);
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "onMove", function (_ref2) {
      var originalEvent = _ref2.originalEvent,
          shiftXAbs = _ref2.shiftXAbs,
          shiftYAbs = _ref2.shiftYAbs;
      _this.props.stopPropagation && originalEvent.stopPropagation();

      if (shiftXAbs > 20 || shiftYAbs > 20) {
        _this.isSlide = true;

        _this.stop();
      }
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "onEnd", function (_ref3) {
      var originalEvent = _ref3.originalEvent;
      _this.props.stopPropagation && originalEvent.stopPropagation();
      var now = ts();

      if (originalEvent.touches && originalEvent.touches.length > 0) {
        _this.isSlide = false;
        return;
      }

      if (_this.state.active) {
        if (now - _this.state.ts >= 100) {
          // Долгий тап, выключаем подсветку
          _this.stop();
        } else {
          // Короткий тап, оставляем подсветку
          var timeout = setTimeout(_this.stop, _this.props.activeEffectDelay - now + _this.state.ts);

          var store = _this.getStorage();

          if (store) {
            store.timeout = timeout;
          }
        }
      } else if (!_this.isSlide) {
        // Очень короткий тап, включаем подсветку
        _this.start();

        var _timeout = setTimeout(_this.stop, _this.props.activeEffectDelay);

        if (_this.getStorage()) {
          clearTimeout(_this.getStorage().activeTimeout);
          _this.getStorage().timeout = _timeout;
        } else {
          _this.timeout = _timeout;
        }
      }

      _this.isSlide = false;
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "onDown", function (e) {
      if (Tappable_osname === ANDROID) {
        var _getOffsetRect = getOffsetRect(_this.container),
            top = _getOffsetRect.top,
            left = _getOffsetRect.left;

        var x = coordX(e);
        var y = coordY(e);
        var key = 'wave' + Date.now().toString();

        _this.setState(function (state) {
          return {
            clicks: Tappable_objectSpread({}, state.clicks, Tappable_defineProperty({}, key, {
              x: Math.round(x - left),
              y: Math.round(y - top)
            }))
          };
        });

        _this.wavesTimeout = setTimeout(function () {
          _this.setState(function (state) {
            var clicks = Tappable_objectSpread({}, state.clicks);

            delete clicks[key];
            return {
              clicks: clicks
            };
          });
        }, 225);
      }
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "start", function () {
      if (!_this.state.active) {
        _this.setState({
          active: true,
          ts: ts()
        });
      }

      deactivateOtherInstances(_this.id);
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "stop", function () {
      if (_this.state.active) {
        _this.setState({
          active: false,
          ts: null
        });
      }

      if (_this.getStorage()) {
        clearTimeout(_this.getStorage().activeTimeout);
        delete storage[_this.id];
      }
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "getStorage", function () {
      return storage[_this.id];
    });

    Tappable_defineProperty(Tappable_assertThisInitialized(Tappable_assertThisInitialized(_this)), "getRef", function (container) {
      _this.container = container;
      _this.props.getRootRef && _this.props.getRootRef(container);
    });

    _this.id = Math.round(Math.random() * 1e8).toString(16);
    _this.state = {
      clicks: {},
      active: false,
      ts: null
    };
    return _this;
  }

  Tappable_createClass(Tappable, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (storage[this.id]) {
        clearTimeout(storage[this.id].timeout);
        clearTimeout(storage[this.id].activeTimeout);
        delete storage[this.id];
      }

      clearTimeout(this.wavesTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          clicks = _this$state.clicks,
          active = _this$state.active;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          component = _this$props.component,
          activeEffectDelay = _this$props.activeEffectDelay,
          stopPropagation = _this$props.stopPropagation,
          getRootRef = _this$props.getRootRef,
          restProps = Tappable_objectWithoutProperties(_this$props, ["children", "className", "component", "activeEffectDelay", "stopPropagation", "getRootRef"]);

      var Component = !restProps.disabled ? Touch_Touch : component;
      var classes = classNames(Tappable_baseClassNames, className, {
        'Tappable--active': active,
        'Tappable--inactive': !active
      });
      var props = {};

      if (!restProps.disabled) {
        props.component = component;
        props.onStart = this.onStart;
        props.onMove = this.onMove;
        props.onEnd = this.onEnd;
      }

      if (typeof Component === 'string') {
        props.ref = this.getRef;
      } else {
        props.getRootRef = this.getRef;
      }

      return external_react_default.a.createElement(Component, Tappable_extends({}, restProps, {
        className: classes
      }, props), Tappable_osname === ANDROID && external_react_default.a.createElement("span", {
        className: "Tappable__waves"
      }, Object.keys(clicks).map(function (k) {
        return external_react_default.a.createElement("span", {
          className: "Tappable__wave",
          style: {
            top: clicks[k].y,
            left: clicks[k].x
          },
          key: k
        });
      })), children);
    }
  }]);

  return Tappable;
}(external_react_["Component"]);

Tappable_defineProperty(Tappable_Tappable, "propTypes", {
  onClick: external_prop_types_default.a.func,
  className: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,
  component: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.element]),
  role: external_prop_types_default.a.string,
  activeEffectDelay: external_prop_types_default.a.number,
  stopPropagation: external_prop_types_default.a.bool,
  disabled: external_prop_types_default.a.bool,
  getRootRef: external_prop_types_default.a.func
});

Tappable_defineProperty(Tappable_Tappable, "defaultProps", {
  component: 'div',
  role: 'button',
  stopPropagation: false,
  disabled: false,
  activeEffectDelay: ACTIVE_EFFECT_DELAY
});


// CONCATENATED MODULE: ./src/components/HeaderButton/HeaderButton.js
function HeaderButton_extends() { HeaderButton_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return HeaderButton_extends.apply(this, arguments); }

function HeaderButton_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = HeaderButton_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function HeaderButton_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var HeaderButton_baseClassName = getClassname('HeaderButton');

var HeaderButton_HeaderButton = function HeaderButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      primary = _ref.primary,
      restProps = HeaderButton_objectWithoutProperties(_ref, ["className", "children", "primary"]);

  var isPrimitive = typeof children === 'string' || typeof children === 'number';
  var component = restProps.href ? 'a' : 'button';
  return external_react_default.a.createElement(Tappable_Tappable, HeaderButton_extends({}, restProps, {
    component: component,
    activeEffectDelay: 200,
    className: classNames(HeaderButton_baseClassName, className, {
      'HeaderButton--primary': primary
    })
  }), isPrimitive ? external_react_default.a.createElement("span", {
    className: "HeaderButton__primitive"
  }, children) : children);
};

HeaderButton_HeaderButton.propTypes = {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  primary: external_prop_types_default.a.bool,

  /**
   * Делает из кнопки ссылку
   */
  href: external_prop_types_default.a.string
};
HeaderButton_HeaderButton.defaultProps = {
  primary: false
};
/* harmony default export */ var components_HeaderButton_HeaderButton = (HeaderButton_HeaderButton);
// CONCATENATED MODULE: ./src/components/PanelHeaderContent/PanelHeaderContent.js
function PanelHeaderContent_extends() { PanelHeaderContent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PanelHeaderContent_extends.apply(this, arguments); }

function PanelHeaderContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { PanelHeaderContent_defineProperty(target, key, source[key]); }); } return target; }

function PanelHeaderContent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PanelHeaderContent_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = PanelHeaderContent_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function PanelHeaderContent_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var PanelHeaderContent_osname = platform();
var PanelHeaderContent_baseClassNames = getClassname('PanelHeaderContent');

var PanelHeaderContent_PanelHeaderContent = function PanelHeaderContent(_ref) {
  var className = _ref.className,
      style = _ref.style,
      aside = _ref.aside,
      status = _ref.status,
      before = _ref.before,
      children = _ref.children,
      onClick = _ref.onClick,
      restProps = PanelHeaderContent_objectWithoutProperties(_ref, ["className", "style", "aside", "status", "before", "children", "onClick"]);

  var InComponent = onClick ? Tappable_Tappable : 'div';
  var rootProps = onClick ? {} : restProps;
  var inProps = onClick ? PanelHeaderContent_objectSpread({}, restProps, {
    activeEffectDelay: 200
  }) : {};
  return external_react_default.a.createElement("div", PanelHeaderContent_extends({}, rootProps, {
    className: classNames(PanelHeaderContent_baseClassNames, className),
    style: style
  }), PanelHeaderContent_osname === ANDROID && before && external_react_default.a.createElement("div", {
    className: "PanelHeaderContent__before"
  }, before), external_react_default.a.createElement(InComponent, PanelHeaderContent_extends({}, inProps, {
    className: "PanelHeaderContent__in",
    onClick: onClick
  }), status && external_react_default.a.createElement("div", {
    className: "PanelHeaderContent__status"
  }, status), external_react_default.a.createElement("div", {
    className: "PanelHeaderContent__children"
  }, external_react_default.a.createElement("span", null, children), aside && external_react_default.a.createElement("div", {
    className: "PanelHeaderContent__aside"
  }, aside))));
};

PanelHeaderContent_PanelHeaderContent.propTypes = {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,
  aside: external_prop_types_default.a.node,
  status: external_prop_types_default.a.node,
  onClick: external_prop_types_default.a.func,

  /**
   * Android only
   */
  before: external_prop_types_default.a.node
};
/* harmony default export */ var components_PanelHeaderContent_PanelHeaderContent = (PanelHeaderContent_PanelHeaderContent);
// CONCATENATED MODULE: ./src/components/FixedLayout/FixedLayout.js
function FixedLayout_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FixedLayout_typeof = function _typeof(obj) { return typeof obj; }; } else { FixedLayout_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FixedLayout_typeof(obj); }

function FixedLayout_extends() { FixedLayout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FixedLayout_extends.apply(this, arguments); }

function FixedLayout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { FixedLayout_defineProperty(target, key, source[key]); }); } return target; }

function FixedLayout_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = FixedLayout_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function FixedLayout_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function FixedLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FixedLayout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FixedLayout_createClass(Constructor, protoProps, staticProps) { if (protoProps) FixedLayout_defineProperties(Constructor.prototype, protoProps); if (staticProps) FixedLayout_defineProperties(Constructor, staticProps); return Constructor; }

function FixedLayout_possibleConstructorReturn(self, call) { if (call && (FixedLayout_typeof(call) === "object" || typeof call === "function")) { return call; } return FixedLayout_assertThisInitialized(self); }

function FixedLayout_getPrototypeOf(o) { FixedLayout_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FixedLayout_getPrototypeOf(o); }

function FixedLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FixedLayout_setPrototypeOf(subClass, superClass); }

function FixedLayout_setPrototypeOf(o, p) { FixedLayout_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FixedLayout_setPrototypeOf(o, p); }

function FixedLayout_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FixedLayout_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var FixedLayout_baseClassNames = getClassname('FixedLayout');

var FixedLayout_FixedLayout =
/*#__PURE__*/
function (_React$Component) {
  FixedLayout_inherits(FixedLayout, _React$Component);

  function FixedLayout() {
    var _getPrototypeOf2;

    var _this;

    FixedLayout_classCallCheck(this, FixedLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = FixedLayout_possibleConstructorReturn(this, (_getPrototypeOf2 = FixedLayout_getPrototypeOf(FixedLayout)).call.apply(_getPrototypeOf2, [this].concat(args)));

    FixedLayout_defineProperty(FixedLayout_assertThisInitialized(FixedLayout_assertThisInitialized(_this)), "state", {
      position: null,
      top: null
    });

    FixedLayout_defineProperty(FixedLayout_assertThisInitialized(FixedLayout_assertThisInitialized(_this)), "onViewTransitionStart", function (e) {
      var panelScroll = e.detail.scrolls[_this.context.panel] || 0;

      _this.setState({
        position: 'absolute',
        top: _this.el.offsetTop + panelScroll
      });
    });

    FixedLayout_defineProperty(FixedLayout_assertThisInitialized(FixedLayout_assertThisInitialized(_this)), "onViewTransitionEnd", function () {
      _this.setState({
        position: null,
        top: null
      });
    });

    FixedLayout_defineProperty(FixedLayout_assertThisInitialized(FixedLayout_assertThisInitialized(_this)), "getRef", function (el) {
      return _this.el = el;
    });

    return _this;
  }

  FixedLayout_createClass(FixedLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.document.addEventListener(transitionStartEventName, this.onViewTransitionStart);
      this.document.addEventListener(transitionEndEventName, this.onViewTransitionEnd);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.document.removeEventListener(transitionStartEventName, this.onViewTransitionStart);
      this.document.removeEventListener(transitionEndEventName, this.onViewTransitionEnd);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          style = _this$props.style,
          vertical = _this$props.vertical,
          restProps = FixedLayout_objectWithoutProperties(_this$props, ["className", "children", "style", "vertical"]);

      var tabbarPadding = this.context.hasTabbar ? constants["tabbarHeight"] : 0;
      var paddingBottom = vertical === 'bottom' && this.context.insets && this.context.insets.bottom ? this.context.insets.bottom + tabbarPadding : null;
      return external_react_default.a.createElement("div", FixedLayout_extends({}, restProps, {
        ref: this.getRef,
        className: classNames(FixedLayout_baseClassNames, FixedLayout_defineProperty({}, "FixedLayout--".concat(vertical), vertical), className),
        style: FixedLayout_objectSpread({}, style, this.state, {
          paddingBottom: paddingBottom
        })
      }), external_react_default.a.createElement("div", {
        className: "FixedLayout__in"
      }, children));
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
  }]);

  return FixedLayout;
}(external_react_default.a.Component);

FixedLayout_defineProperty(FixedLayout_FixedLayout, "propTypes", {
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  vertical: external_prop_types_default.a.oneOf(['top', 'bottom'])
});

FixedLayout_defineProperty(FixedLayout_FixedLayout, "contextTypes", {
  insets: external_prop_types_default.a.shape({
    bottom: external_prop_types_default.a.number
  }),
  panel: external_prop_types_default.a.string,
  document: external_prop_types_default.a.any,
  hasTabbar: external_prop_types_default.a.bool
});


// CONCATENATED MODULE: ./src/components/HeaderContext/HeaderContext.js
function HeaderContext_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { HeaderContext_typeof = function _typeof(obj) { return typeof obj; }; } else { HeaderContext_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return HeaderContext_typeof(obj); }

function HeaderContext_extends() { HeaderContext_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return HeaderContext_extends.apply(this, arguments); }

function HeaderContext_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = HeaderContext_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function HeaderContext_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function HeaderContext_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HeaderContext_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HeaderContext_createClass(Constructor, protoProps, staticProps) { if (protoProps) HeaderContext_defineProperties(Constructor.prototype, protoProps); if (staticProps) HeaderContext_defineProperties(Constructor, staticProps); return Constructor; }

function HeaderContext_possibleConstructorReturn(self, call) { if (call && (HeaderContext_typeof(call) === "object" || typeof call === "function")) { return call; } return HeaderContext_assertThisInitialized(self); }

function HeaderContext_getPrototypeOf(o) { HeaderContext_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return HeaderContext_getPrototypeOf(o); }

function HeaderContext_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) HeaderContext_setPrototypeOf(subClass, superClass); }

function HeaderContext_setPrototypeOf(o, p) { HeaderContext_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return HeaderContext_setPrototypeOf(o, p); }

function HeaderContext_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function HeaderContext_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var HeaderContext_baseClassNames = getClassname('HeaderContext');

var HeaderContext_HeaderContext =
/*#__PURE__*/
function (_React$Component) {
  HeaderContext_inherits(HeaderContext, _React$Component);

  function HeaderContext() {
    var _getPrototypeOf2;

    var _this;

    HeaderContext_classCallCheck(this, HeaderContext);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = HeaderContext_possibleConstructorReturn(this, (_getPrototypeOf2 = HeaderContext_getPrototypeOf(HeaderContext)).call.apply(_getPrototypeOf2, [this].concat(args)));

    HeaderContext_defineProperty(HeaderContext_assertThisInitialized(HeaderContext_assertThisInitialized(_this)), "state", {
      closing: false
    });

    HeaderContext_defineProperty(HeaderContext_assertThisInitialized(HeaderContext_assertThisInitialized(_this)), "onAnimationFinish", function () {
      return _this.setState({
        closing: false
      });
    });

    HeaderContext_defineProperty(HeaderContext_assertThisInitialized(HeaderContext_assertThisInitialized(_this)), "getRef", function (el) {
      return _this.el = el;
    });

    return _this;
  }

  HeaderContext_createClass(HeaderContext, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.opened !== this.props.opened) {
        if (nextProps.opened === false) {
          this.setState({
            closing: true
          });
          this.waitAnimationFinish(this.onAnimationFinish);
        } else {
          clearTimeout(this.closeAnimationTimeiout);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeAnimationTimeiout);
    }
  }, {
    key: "waitAnimationFinish",
    value: function waitAnimationFinish(eventHandler) {
      if (transitionEvents.supported) {
        var eventName = transitionEvents.prefix ? transitionEvents.prefix + 'AnimationEnd' : 'animationend';
        this.el.removeEventListener(eventName, eventHandler);
        this.el.addEventListener(eventName, eventHandler);
      } else {
        this.closeAnimationTimeiout = setTimeout(eventHandler.bind(this), 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          opened = _this$props.opened,
          onClose = _this$props.onClose,
          restProps = HeaderContext_objectWithoutProperties(_this$props, ["children", "className", "opened", "onClose"]);

      return external_react_default.a.createElement(FixedLayout_FixedLayout, HeaderContext_extends({}, restProps, {
        className: classNames(HeaderContext_baseClassNames, {
          'HeaderContext--opened': opened,
          'HeaderContext--closing': this.state.closing
        }, className),
        vertical: "top"
      }), external_react_default.a.createElement("div", {
        className: "HeaderContext__in",
        ref: this.getRef
      }, (opened || this.state.closing) && children), (opened || this.state.closing) && external_react_default.a.createElement("div", {
        onClick: onClose,
        className: "HeaderContext__fade"
      }));
    }
  }]);

  return HeaderContext;
}(external_react_default.a.Component);

HeaderContext_defineProperty(HeaderContext_HeaderContext, "propTypes", {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,
  onClose: external_prop_types_default.a.func.isRequired,
  opened: external_prop_types_default.a.bool.isRequired
});

HeaderContext_defineProperty(HeaderContext_HeaderContext, "defaultProps", {
  opened: false
});


// CONCATENATED MODULE: ./src/components/Epic/Epic.js
function Epic_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Epic_typeof = function _typeof(obj) { return typeof obj; }; } else { Epic_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Epic_typeof(obj); }

function Epic_extends() { Epic_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Epic_extends.apply(this, arguments); }

function Epic_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Epic_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Epic_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Epic_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Epic_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Epic_createClass(Constructor, protoProps, staticProps) { if (protoProps) Epic_defineProperties(Constructor.prototype, protoProps); if (staticProps) Epic_defineProperties(Constructor, staticProps); return Constructor; }

function Epic_possibleConstructorReturn(self, call) { if (call && (Epic_typeof(call) === "object" || typeof call === "function")) { return call; } return Epic_assertThisInitialized(self); }

function Epic_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Epic_getPrototypeOf(o) { Epic_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Epic_getPrototypeOf(o); }

function Epic_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Epic_setPrototypeOf(subClass, superClass); }

function Epic_setPrototypeOf(o, p) { Epic_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Epic_setPrototypeOf(o, p); }

function Epic_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Epic_baseClassName = getClassname('Epic');

var Epic_Epic =
/*#__PURE__*/
function (_React$Component) {
  Epic_inherits(Epic, _React$Component);

  function Epic() {
    Epic_classCallCheck(this, Epic);

    return Epic_possibleConstructorReturn(this, Epic_getPrototypeOf(Epic).apply(this, arguments));
  }

  Epic_createClass(Epic, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasTabbar: this.props.hasOwnProperty('tabbar')
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          activeStory = _this$props.activeStory,
          tabbar = _this$props.tabbar,
          children = _this$props.children,
          restProps = Epic_objectWithoutProperties(_this$props, ["className", "activeStory", "tabbar", "children"]);

      return external_react_default.a.createElement("div", Epic_extends({}, restProps, {
        className: classNames(Epic_baseClassName, className)
      }), external_react_default.a.Children.toArray(children).find(function (item) {
        return item.props.id === activeStory;
      }), tabbar);
    }
  }]);

  return Epic;
}(external_react_default.a.Component);

Epic_defineProperty(Epic_Epic, "propTypes", {
  className: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,
  tabbar: external_prop_types_default.a.node.isRequired,
  activeStory: external_prop_types_default.a.string.isRequired
});

Epic_defineProperty(Epic_Epic, "childContextTypes", {
  hasTabbar: external_prop_types_default.a.bool
});


// CONCATENATED MODULE: ./src/components/Tabbar/Tabbar.js
function Tabbar_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Tabbar_typeof = function _typeof(obj) { return typeof obj; }; } else { Tabbar_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Tabbar_typeof(obj); }

function Tabbar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tabbar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Tabbar_createClass(Constructor, protoProps, staticProps) { if (protoProps) Tabbar_defineProperties(Constructor.prototype, protoProps); if (staticProps) Tabbar_defineProperties(Constructor, staticProps); return Constructor; }

function Tabbar_possibleConstructorReturn(self, call) { if (call && (Tabbar_typeof(call) === "object" || typeof call === "function")) { return call; } return Tabbar_assertThisInitialized(self); }

function Tabbar_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Tabbar_getPrototypeOf(o) { Tabbar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Tabbar_getPrototypeOf(o); }

function Tabbar_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Tabbar_setPrototypeOf(subClass, superClass); }

function Tabbar_setPrototypeOf(o, p) { Tabbar_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Tabbar_setPrototypeOf(o, p); }

function Tabbar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Tabbar_baseClassName = getClassname('Tabbar');

var Tabbar_Tabbar =
/*#__PURE__*/
function (_React$Component) {
  Tabbar_inherits(Tabbar, _React$Component);

  function Tabbar() {
    Tabbar_classCallCheck(this, Tabbar);

    return Tabbar_possibleConstructorReturn(this, Tabbar_getPrototypeOf(Tabbar).apply(this, arguments));
  }

  Tabbar_createClass(Tabbar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          shadow = _this$props.shadow;
      return external_react_default.a.createElement("div", {
        className: classNames(Tabbar_baseClassName, className, {
          'Tabbar--shadow': shadow
        }),
        style: {
          paddingBottom: this.context.insets && this.context.insets.bottom || null
        }
      }, children);
    }
  }]);

  return Tabbar;
}(external_react_default.a.Component);

Tabbar_defineProperty(Tabbar_Tabbar, "propTypes", {
  className: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,

  /**
   * флаг для показа/скрытия верхней тени (Android) или границы (iOS)
   */
  shadow: external_prop_types_default.a.bool
});

Tabbar_defineProperty(Tabbar_Tabbar, "defaultProps", {
  shadow: true
});

Tabbar_defineProperty(Tabbar_Tabbar, "contextTypes", {
  insets: external_prop_types_default.a.shape({
    bottom: external_prop_types_default.a.number
  })
});


// CONCATENATED MODULE: ./src/components/TabbarItem/TabbarItem.js
function TabbarItem_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TabbarItem_typeof = function _typeof(obj) { return typeof obj; }; } else { TabbarItem_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TabbarItem_typeof(obj); }

function TabbarItem_extends() { TabbarItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return TabbarItem_extends.apply(this, arguments); }

function TabbarItem_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = TabbarItem_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function TabbarItem_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TabbarItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TabbarItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TabbarItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) TabbarItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) TabbarItem_defineProperties(Constructor, staticProps); return Constructor; }

function TabbarItem_possibleConstructorReturn(self, call) { if (call && (TabbarItem_typeof(call) === "object" || typeof call === "function")) { return call; } return TabbarItem_assertThisInitialized(self); }

function TabbarItem_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TabbarItem_getPrototypeOf(o) { TabbarItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TabbarItem_getPrototypeOf(o); }

function TabbarItem_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TabbarItem_setPrototypeOf(subClass, superClass); }

function TabbarItem_setPrototypeOf(o, p) { TabbarItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TabbarItem_setPrototypeOf(o, p); }

function TabbarItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var TabbarItem_baseClassName = getClassname('TabbarItem');

var TabbarItem_TabbarItem =
/*#__PURE__*/
function (_React$Component) {
  TabbarItem_inherits(TabbarItem, _React$Component);

  function TabbarItem() {
    TabbarItem_classCallCheck(this, TabbarItem);

    return TabbarItem_possibleConstructorReturn(this, TabbarItem_getPrototypeOf(TabbarItem).apply(this, arguments));
  }

  TabbarItem_createClass(TabbarItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          selected = _this$props.selected,
          label = _this$props.label,
          restProps = TabbarItem_objectWithoutProperties(_this$props, ["className", "children", "selected", "label"]);

      return external_react_default.a.createElement("div", TabbarItem_extends({}, restProps, {
        className: classNames(TabbarItem_baseClassName, className, {
          'TabbarItem--selected': selected
        })
      }), external_react_default.a.createElement("div", {
        className: "TabbarItem__in"
      }, children, label && external_react_default.a.createElement("span", {
        className: "TabbarItem__label"
      }, label)));
    }
  }]);

  return TabbarItem;
}(external_react_default.a.Component);

TabbarItem_defineProperty(TabbarItem_TabbarItem, "propTypes", {
  className: external_prop_types_default.a.string,
  selected: external_prop_types_default.a.bool,
  children: external_prop_types_default.a.node,
  label: external_prop_types_default.a.node
});


// CONCATENATED MODULE: ./src/components/InnerScroll/InnerScroll.js
function InnerScroll_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { InnerScroll_typeof = function _typeof(obj) { return typeof obj; }; } else { InnerScroll_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return InnerScroll_typeof(obj); }

function InnerScroll_extends() { InnerScroll_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return InnerScroll_extends.apply(this, arguments); }

function InnerScroll_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = InnerScroll_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function InnerScroll_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function InnerScroll_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InnerScroll_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function InnerScroll_createClass(Constructor, protoProps, staticProps) { if (protoProps) InnerScroll_defineProperties(Constructor.prototype, protoProps); if (staticProps) InnerScroll_defineProperties(Constructor, staticProps); return Constructor; }

function InnerScroll_possibleConstructorReturn(self, call) { if (call && (InnerScroll_typeof(call) === "object" || typeof call === "function")) { return call; } return InnerScroll_assertThisInitialized(self); }

function InnerScroll_getPrototypeOf(o) { InnerScroll_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return InnerScroll_getPrototypeOf(o); }

function InnerScroll_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) InnerScroll_setPrototypeOf(subClass, superClass); }

function InnerScroll_setPrototypeOf(o, p) { InnerScroll_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return InnerScroll_setPrototypeOf(o, p); }

function InnerScroll_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function InnerScroll_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var InnerScroll_baseClassName = getClassname('InnerScroll');

var InnerScroll_InnerScroll =
/*#__PURE__*/
function (_React$Component) {
  InnerScroll_inherits(InnerScroll, _React$Component);

  function InnerScroll() {
    var _getPrototypeOf2;

    var _this;

    InnerScroll_classCallCheck(this, InnerScroll);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = InnerScroll_possibleConstructorReturn(this, (_getPrototypeOf2 = InnerScroll_getPrototypeOf(InnerScroll)).call.apply(_getPrototypeOf2, [this].concat(args)));

    InnerScroll_defineProperty(InnerScroll_assertThisInitialized(InnerScroll_assertThisInitialized(_this)), "onScroll", function (e) {
      if (_this.el.scrollTop <= 0) {
        _this.el.scrollTop = 1;
      } else if (_this.el.scrollTop >= _this.el.scrollHeight - _this.el.offsetHeight) {
        _this.el.scrollTop = _this.el.scrollHeight - _this.el.offsetHeight - 1;
      }

      _this.props.onScroll && _this.props.onScroll(e);
    });

    InnerScroll_defineProperty(InnerScroll_assertThisInitialized(InnerScroll_assertThisInitialized(_this)), "ref", function (el) {
      return _this.el = el;
    });

    return _this;
  }

  InnerScroll_createClass(InnerScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.el.scrollTop = 1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          onScroll = _this$props.onScroll,
          restProps = InnerScroll_objectWithoutProperties(_this$props, ["className", "children", "onScroll"]);

      return external_react_default.a.createElement("div", InnerScroll_extends({}, restProps, {
        className: classNames(InnerScroll_baseClassName, className),
        onScroll: this.onScroll,
        ref: this.getRef
      }), children);
    }
  }]);

  return InnerScroll;
}(external_react_default.a.Component);

InnerScroll_defineProperty(InnerScroll_InnerScroll, "propTypes", {
  className: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  onScroll: external_prop_types_default.a.func
});


// CONCATENATED MODULE: ./src/components/HorizontalScroll/HorizontalScroll.js
function HorizontalScroll_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { HorizontalScroll_typeof = function _typeof(obj) { return typeof obj; }; } else { HorizontalScroll_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return HorizontalScroll_typeof(obj); }

function HorizontalScroll_extends() { HorizontalScroll_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return HorizontalScroll_extends.apply(this, arguments); }

function HorizontalScroll_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = HorizontalScroll_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function HorizontalScroll_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function HorizontalScroll_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HorizontalScroll_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HorizontalScroll_createClass(Constructor, protoProps, staticProps) { if (protoProps) HorizontalScroll_defineProperties(Constructor.prototype, protoProps); if (staticProps) HorizontalScroll_defineProperties(Constructor, staticProps); return Constructor; }

function HorizontalScroll_possibleConstructorReturn(self, call) { if (call && (HorizontalScroll_typeof(call) === "object" || typeof call === "function")) { return call; } return HorizontalScroll_assertThisInitialized(self); }

function HorizontalScroll_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function HorizontalScroll_getPrototypeOf(o) { HorizontalScroll_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return HorizontalScroll_getPrototypeOf(o); }

function HorizontalScroll_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) HorizontalScroll_setPrototypeOf(subClass, superClass); }

function HorizontalScroll_setPrototypeOf(o, p) { HorizontalScroll_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return HorizontalScroll_setPrototypeOf(o, p); }

function HorizontalScroll_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var HorizontalScroll_HorizontalScroll =
/*#__PURE__*/
function (_React$Component) {
  HorizontalScroll_inherits(HorizontalScroll, _React$Component);

  function HorizontalScroll() {
    HorizontalScroll_classCallCheck(this, HorizontalScroll);

    return HorizontalScroll_possibleConstructorReturn(this, HorizontalScroll_getPrototypeOf(HorizontalScroll).apply(this, arguments));
  }

  HorizontalScroll_createClass(HorizontalScroll, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          restProps = HorizontalScroll_objectWithoutProperties(_this$props, ["children", "className"]);

      return external_react_default.a.createElement("div", HorizontalScroll_extends({}, restProps, {
        className: classNames('HorizontalScroll', className)
      }), external_react_default.a.createElement("div", {
        className: "HorizontalScroll__in"
      }, children));
    }
  }]);

  return HorizontalScroll;
}(external_react_default.a.Component);

HorizontalScroll_defineProperty(HorizontalScroll_HorizontalScroll, "propTypes", {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object
});


// CONCATENATED MODULE: ./src/components/PopoutWrapper/PopoutWrapper.js
function PopoutWrapper_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { PopoutWrapper_typeof = function _typeof(obj) { return typeof obj; }; } else { PopoutWrapper_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return PopoutWrapper_typeof(obj); }

function PopoutWrapper_extends() { PopoutWrapper_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PopoutWrapper_extends.apply(this, arguments); }

function PopoutWrapper_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = PopoutWrapper_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function PopoutWrapper_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function PopoutWrapper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PopoutWrapper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PopoutWrapper_createClass(Constructor, protoProps, staticProps) { if (protoProps) PopoutWrapper_defineProperties(Constructor.prototype, protoProps); if (staticProps) PopoutWrapper_defineProperties(Constructor, staticProps); return Constructor; }

function PopoutWrapper_possibleConstructorReturn(self, call) { if (call && (PopoutWrapper_typeof(call) === "object" || typeof call === "function")) { return call; } return PopoutWrapper_assertThisInitialized(self); }

function PopoutWrapper_getPrototypeOf(o) { PopoutWrapper_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PopoutWrapper_getPrototypeOf(o); }

function PopoutWrapper_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) PopoutWrapper_setPrototypeOf(subClass, superClass); }

function PopoutWrapper_setPrototypeOf(o, p) { PopoutWrapper_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PopoutWrapper_setPrototypeOf(o, p); }

function PopoutWrapper_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PopoutWrapper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var PopoutWrapper_osname = platform();
var PopoutWrapper_baseClassNames = getClassname('PopoutWrapper');

var PopoutWrapper_PopoutWrapper =
/*#__PURE__*/
function (_React$Component) {
  PopoutWrapper_inherits(PopoutWrapper, _React$Component);

  function PopoutWrapper() {
    var _getPrototypeOf2;

    var _this;

    PopoutWrapper_classCallCheck(this, PopoutWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = PopoutWrapper_possibleConstructorReturn(this, (_getPrototypeOf2 = PopoutWrapper_getPrototypeOf(PopoutWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    PopoutWrapper_defineProperty(PopoutWrapper_assertThisInitialized(PopoutWrapper_assertThisInitialized(_this)), "state", {
      opened: false
    });

    PopoutWrapper_defineProperty(PopoutWrapper_assertThisInitialized(PopoutWrapper_assertThisInitialized(_this)), "onFadeInEnd", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        manual: true
      };

      if (e.animationName === 'animation-full-fade-in' || e.manual) {
        _this.setState({
          opened: true
        });
      }
    });

    PopoutWrapper_defineProperty(PopoutWrapper_assertThisInitialized(PopoutWrapper_assertThisInitialized(_this)), "preventTouch", function (e) {
      return e.preventDefault();
    });

    PopoutWrapper_defineProperty(PopoutWrapper_assertThisInitialized(PopoutWrapper_assertThisInitialized(_this)), "onClick", function (e) {
      return _this.state.opened && _this.props.onClick && _this.props.onClick(e);
    });

    PopoutWrapper_defineProperty(PopoutWrapper_assertThisInitialized(PopoutWrapper_assertThisInitialized(_this)), "getRef", function (el) {
      return _this.el = el;
    });

    return _this;
  }

  PopoutWrapper_createClass(PopoutWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('touchmove', this.preventTouch, {
        passive: false
      });
      this.waitAnimationFinish(this.el, this.onFadeInEnd);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('touchmove', this.preventTouch, {
        passive: false
      });
      clearTimeout(this.animationFinishTimeout);
    }
  }, {
    key: "waitAnimationFinish",
    value: function waitAnimationFinish(elem, eventHandler) {
      if (transitionEvents.supported) {
        var eventName = transitionEvents.prefix ? transitionEvents.prefix + 'AnimationEnd' : 'animationend';
        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        this.animationFinishTimeout = setTimeout(eventHandler.bind(this), PopoutWrapper_osname === ANDROID ? 300 : 600);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          v = _this$props.v,
          h = _this$props.h,
          closing = _this$props.closing,
          children = _this$props.children,
          hasMask = _this$props.hasMask,
          onClick = _this$props.onClick,
          className = _this$props.className,
          restProps = PopoutWrapper_objectWithoutProperties(_this$props, ["v", "h", "closing", "children", "hasMask", "onClick", "className"]);

      return external_react_default.a.createElement("div", PopoutWrapper_extends({}, restProps, {
        className: classNames(PopoutWrapper_baseClassNames, (_classnames = {}, PopoutWrapper_defineProperty(_classnames, "PopoutWrapper--v-".concat(v), v), PopoutWrapper_defineProperty(_classnames, "PopoutWrapper--h-".concat(h), h), PopoutWrapper_defineProperty(_classnames, 'PopoutWrapper--closing', closing), _classnames), className),
        onClick: this.onClick,
        ref: this.getRef
      }), hasMask && external_react_default.a.createElement("div", {
        className: "PopoutWrapper__mask"
      }), external_react_default.a.createElement("div", {
        className: "PopoutWrapper__container"
      }, children));
    }
  }]);

  return PopoutWrapper;
}(external_react_default.a.Component);

PopoutWrapper_defineProperty(PopoutWrapper_PopoutWrapper, "propTypes", {
  hasMask: external_prop_types_default.a.bool,
  v: external_prop_types_default.a.oneOf(['top', 'center', 'bottom']),
  h: external_prop_types_default.a.oneOf(['left', 'center', 'right']),
  closing: external_prop_types_default.a.bool,
  onClick: external_prop_types_default.a.func,
  style: external_prop_types_default.a.object,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string
});

PopoutWrapper_defineProperty(PopoutWrapper_PopoutWrapper, "defaultProps", {
  hasMask: true,
  v: 'center',
  h: 'center',
  closing: false
});


// CONCATENATED MODULE: ./src/components/Alert/Alert.js
function Alert_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Alert_typeof = function _typeof(obj) { return typeof obj; }; } else { Alert_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Alert_typeof(obj); }

function Alert_extends() { Alert_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Alert_extends.apply(this, arguments); }

function Alert_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Alert_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Alert_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Alert_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Alert_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Alert_createClass(Constructor, protoProps, staticProps) { if (protoProps) Alert_defineProperties(Constructor.prototype, protoProps); if (staticProps) Alert_defineProperties(Constructor, staticProps); return Constructor; }

function Alert_possibleConstructorReturn(self, call) { if (call && (Alert_typeof(call) === "object" || typeof call === "function")) { return call; } return Alert_assertThisInitialized(self); }

function Alert_getPrototypeOf(o) { Alert_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Alert_getPrototypeOf(o); }

function Alert_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Alert_setPrototypeOf(subClass, superClass); }

function Alert_setPrototypeOf(o, p) { Alert_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Alert_setPrototypeOf(o, p); }

function Alert_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Alert_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Alert_baseClassNames = getClassname('Alert');

var Alert_Alert =
/*#__PURE__*/
function (_Component) {
  Alert_inherits(Alert, _Component);

  function Alert() {
    var _getPrototypeOf2;

    var _this;

    Alert_classCallCheck(this, Alert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Alert_possibleConstructorReturn(this, (_getPrototypeOf2 = Alert_getPrototypeOf(Alert)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Alert_defineProperty(Alert_assertThisInitialized(Alert_assertThisInitialized(_this)), "onItemClick", function (item) {
      return function () {
        item.autoclose && _this.props.onClose();
        item.action && item.action();
      };
    });

    return _this;
  }

  Alert_createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          actions = _this$props.actions,
          actionsLayout = _this$props.actionsLayout,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          restProps = Alert_objectWithoutProperties(_this$props, ["actions", "actionsLayout", "children", "className", "style"]);

      return external_react_default.a.createElement(PopoutWrapper_PopoutWrapper, {
        className: className,
        style: style
      }, external_react_default.a.createElement("div", Alert_extends({}, restProps, {
        className: classNames(Alert_baseClassNames, {
          'Alert--v': actionsLayout === 'vertical',
          'Alert--h': actionsLayout === 'horizontal'
        })
      }), external_react_default.a.createElement("div", {
        className: "Alert__content"
      }, children), external_react_default.a.createElement("footer", {
        className: "Alert__footer"
      }, actions.map(function (button, i) {
        return external_react_default.a.createElement(Tappable_Tappable, {
          component: "button",
          className: classNames('Alert__btn', Alert_defineProperty({}, "Alert__btn--".concat(button.style), true)),
          onClick: _this2.onItemClick(button),
          key: "alert-action-".concat(i)
        }, external_react_default.a.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: button.title
          }
        }));
      }))));
    }
  }]);

  return Alert;
}(external_react_["Component"]);

Alert_defineProperty(Alert_Alert, "propTypes", {
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,
  actionsLayout: external_prop_types_default.a.oneOf(['vertical', 'horizontal']),
  actions: external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({
    title: external_prop_types_default.a.string,
    action: external_prop_types_default.a.func,
    style: external_prop_types_default.a.oneOf(['primary', 'cancel', 'destructive', 'default'])
  })),
  onClose: external_prop_types_default.a.func
});

Alert_defineProperty(Alert_Alert, "defaultProps", {
  actionsLayout: 'horizontal',
  actions: []
});


// CONCATENATED MODULE: ./src/components/ActionSheet/ActionSheet.js
function ActionSheet_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ActionSheet_typeof = function _typeof(obj) { return typeof obj; }; } else { ActionSheet_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ActionSheet_typeof(obj); }

function ActionSheet_extends() { ActionSheet_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ActionSheet_extends.apply(this, arguments); }

function ActionSheet_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ActionSheet_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ActionSheet_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ActionSheet_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ActionSheet_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ActionSheet_createClass(Constructor, protoProps, staticProps) { if (protoProps) ActionSheet_defineProperties(Constructor.prototype, protoProps); if (staticProps) ActionSheet_defineProperties(Constructor, staticProps); return Constructor; }

function ActionSheet_possibleConstructorReturn(self, call) { if (call && (ActionSheet_typeof(call) === "object" || typeof call === "function")) { return call; } return ActionSheet_assertThisInitialized(self); }

function ActionSheet_getPrototypeOf(o) { ActionSheet_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ActionSheet_getPrototypeOf(o); }

function ActionSheet_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ActionSheet_setPrototypeOf(subClass, superClass); }

function ActionSheet_setPrototypeOf(o, p) { ActionSheet_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ActionSheet_setPrototypeOf(o, p); }

function ActionSheet_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ActionSheet_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var ActionSheet_osname = platform();
var ActionSheet_baseClassNames = getClassname('ActionSheet');

var ActionSheet_ActionSheet =
/*#__PURE__*/
function (_React$Component) {
  ActionSheet_inherits(ActionSheet, _React$Component);

  function ActionSheet() {
    var _getPrototypeOf2;

    var _this;

    ActionSheet_classCallCheck(this, ActionSheet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = ActionSheet_possibleConstructorReturn(this, (_getPrototypeOf2 = ActionSheet_getPrototypeOf(ActionSheet)).call.apply(_getPrototypeOf2, [this].concat(args)));

    ActionSheet_defineProperty(ActionSheet_assertThisInitialized(ActionSheet_assertThisInitialized(_this)), "state", {
      closing: false
    });

    ActionSheet_defineProperty(ActionSheet_assertThisInitialized(ActionSheet_assertThisInitialized(_this)), "onClose", function () {
      _this.setState({
        closing: true
      });

      _this.waitTransitionFinish(_this.props.onClose);
    });

    ActionSheet_defineProperty(ActionSheet_assertThisInitialized(ActionSheet_assertThisInitialized(_this)), "onItemClick", function (action, autoclose) {
      return function () {
        if (autoclose) {
          _this.setState({
            closing: true
          });

          _this.waitTransitionFinish(function () {
            autoclose && _this.props.onClose();
            action && action();
          });
        } else {
          action && action();
        }
      };
    });

    ActionSheet_defineProperty(ActionSheet_assertThisInitialized(ActionSheet_assertThisInitialized(_this)), "getRef", function (el) {
      return _this.el = el;
    });

    ActionSheet_defineProperty(ActionSheet_assertThisInitialized(ActionSheet_assertThisInitialized(_this)), "stopPropagation", function (e) {
      return e.stopPropagation();
    });

    return _this;
  }

  ActionSheet_createClass(ActionSheet, [{
    key: "waitTransitionFinish",
    value: function waitTransitionFinish(eventHandler) {
      if (transitionEvents.supported) {
        var eventName = transitionEvents.prefix ? transitionEvents.prefix + 'TransitionEnd' : 'transitionend';
        this.el.removeEventListener(eventName, eventHandler);
        this.el.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), ActionSheet_osname === ANDROID ? 200 : 300);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          title = _this$props.title,
          text = _this$props.text,
          style = _this$props.style,
          restProps = ActionSheet_objectWithoutProperties(_this$props, ["children", "className", "title", "text", "style"]);

      return external_react_default.a.createElement(PopoutWrapper_PopoutWrapper, {
        closing: this.state.closing,
        v: ActionSheet_osname === IOS ? 'bottom' : 'center',
        h: "center",
        className: className,
        style: style,
        onClick: this.onClose
      }, external_react_default.a.createElement("div", ActionSheet_extends({}, restProps, {
        ref: this.getRef,
        onClick: this.stopPropagation,
        className: classNames(ActionSheet_baseClassNames, {
          'ActionSheet--closing': this.state.closing
        })
      }), ActionSheet_osname === IOS && external_react_default.a.createElement("header", {
        className: "ActionSheet__header"
      }, title && external_react_default.a.createElement("div", {
        className: "ActionSheet__title"
      }, title), text && external_react_default.a.createElement("div", {
        className: "ActionSheet__text"
      }, text)), external_react_default.a.Children.map(children, function (Child, index) {
        return Child && external_react_default.a.cloneElement(Child, {
          onClick: _this2.onItemClick(Child.props.onClick, Child.props.autoclose),
          style: index === children.length - 1 && _this2.context.insets ? {
            marginBottom: _this2.context.insets.bottom
          } : null
        });
      }, null)));
    }
  }]);

  return ActionSheet;
}(external_react_default.a.Component);

ActionSheet_defineProperty(ActionSheet_ActionSheet, "propTypes", {
  /**
   * iOS only
   */
  title: external_prop_types_default.a.node,

  /**
   * iOS only
   */
  text: external_prop_types_default.a.node,
  onClose: external_prop_types_default.a.func.isRequired,
  style: external_prop_types_default.a.object,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string
});

ActionSheet_defineProperty(ActionSheet_ActionSheet, "contextTypes", {
  insets: external_prop_types_default.a.object
});


// CONCATENATED MODULE: ./src/components/ActionSheetItem/ActionSheetItem.js
function ActionSheetItem_extends() { ActionSheetItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ActionSheetItem_extends.apply(this, arguments); }

function ActionSheetItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ActionSheetItem_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ActionSheetItem_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ActionSheetItem_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var ActionSheetItem_baseClassNames = getClassname('ActionSheetItem');

var ActionSheetItem_ActionSheetItem = function ActionSheetItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      autoclose = _ref.autoclose,
      theme = _ref.theme,
      restProps = ActionSheetItem_objectWithoutProperties(_ref, ["className", "children", "autoclose", "theme"]);

  return external_react_default.a.createElement(Tappable_Tappable, ActionSheetItem_extends({}, restProps, {
    className: classNames(ActionSheetItem_baseClassNames, className, ActionSheetItem_defineProperty({}, "ActionSheetItem--".concat(theme), true)),
    component: theme === 'cancel' ? 'span' : 'div'
  }), external_react_default.a.createElement("span", {
    className: "ActionSheetItem__in"
  }, children));
};

ActionSheetItem_ActionSheetItem.propTypes = {
  theme: external_prop_types_default.a.oneOf(['default', 'destructive', 'cancel']),
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  onClick: external_prop_types_default.a.func,
  className: external_prop_types_default.a.string,
  autoclose: external_prop_types_default.a.bool
};
ActionSheetItem_ActionSheetItem.defaultProps = {
  theme: 'default'
};
/* harmony default export */ var components_ActionSheetItem_ActionSheetItem = (ActionSheetItem_ActionSheetItem);
// CONCATENATED MODULE: ./src/components/NativePopouts/NativePopouts.js
function NativePopouts_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { NativePopouts_typeof = function _typeof(obj) { return typeof obj; }; } else { NativePopouts_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return NativePopouts_typeof(obj); }

function NativePopouts_extends() { NativePopouts_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return NativePopouts_extends.apply(this, arguments); }

function NativePopouts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { NativePopouts_defineProperty(target, key, source[key]); }); } return target; }

function NativePopouts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NativePopouts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function NativePopouts_createClass(Constructor, protoProps, staticProps) { if (protoProps) NativePopouts_defineProperties(Constructor.prototype, protoProps); if (staticProps) NativePopouts_defineProperties(Constructor, staticProps); return Constructor; }

function NativePopouts_possibleConstructorReturn(self, call) { if (call && (NativePopouts_typeof(call) === "object" || typeof call === "function")) { return call; } return NativePopouts_assertThisInitialized(self); }

function NativePopouts_getPrototypeOf(o) { NativePopouts_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return NativePopouts_getPrototypeOf(o); }

function NativePopouts_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) NativePopouts_setPrototypeOf(subClass, superClass); }

function NativePopouts_setPrototypeOf(o, p) { NativePopouts_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return NativePopouts_setPrototypeOf(o, p); }

function NativePopouts_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function NativePopouts_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function brToNl() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regex = /<br\s*\/?>/gi;
  return str.replace(regex, '\n');
}

var actionId = 1;
/**
 * @deprecated будет удален в 3.0.0
 */

var NativePopouts_NativePopouts =
/*#__PURE__*/
function (_React$Component) {
  NativePopouts_inherits(NativePopouts, _React$Component);

  function NativePopouts() {
    var _getPrototypeOf2;

    var _this;

    NativePopouts_classCallCheck(this, NativePopouts);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = NativePopouts_possibleConstructorReturn(this, (_getPrototypeOf2 = NativePopouts_getPrototypeOf(NativePopouts)).call.apply(_getPrototypeOf2, [this].concat(args)));

    NativePopouts_defineProperty(NativePopouts_assertThisInitialized(NativePopouts_assertThisInitialized(_this)), "state", {
      popout: null
    });

    NativePopouts_defineProperty(NativePopouts_assertThisInitialized(NativePopouts_assertThisInitialized(_this)), "actions", []);

    NativePopouts_defineProperty(NativePopouts_assertThisInitialized(NativePopouts_assertThisInitialized(_this)), "actionsStore", {});

    NativePopouts_defineProperty(NativePopouts_assertThisInitialized(NativePopouts_assertThisInitialized(_this)), "vkuiListener", function (e) {
      if (e.type === 'VKWebAppEvent' && e.detail && e.detail.action) {
        if (_this.actionsStore.hasOwnProperty(e.detail.action)) {
          _this.actionsStore[e.detail.action](e.detail);

          _this.props.popout && _this.props.popout.onClose && _this.props.popout.onClose();
        }
      }
    });

    return _this;
  }

  NativePopouts_createClass(NativePopouts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.vkuiConnect.subscribe(this.vkuiListener);

      if (this.props.popout) {
        this.renderPopout(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.vkuiConnect.unsubscribe(this.vkuiListener);
    }
  }, {
    key: "renderNativeAlert",
    value: function renderNativeAlert(popout) {
      var style = popout.style,
          title = popout.title,
          message = popout.text;
      this.props.vkuiConnect.send('VKWebAppAlert', {
        style: style,
        title: brToNl(title),
        message: brToNl(message),
        actions: this.actions.map(function (item) {
          return removeObjectKeys(item, ['action']);
        })
      });
    }
  }, {
    key: "renderUIAlert",
    value: function renderUIAlert(popout) {
      var title = popout.title,
          text = popout.text,
          onClose = popout.onClose,
          actionsLayout = popout.actionsLayout;
      this.setState({
        popout: external_react_default.a.createElement(Alert_Alert, {
          actions: this.actions.map(function (item) {
            return removeObjectKeys(item, ['params']);
          }),
          onClose: onClose,
          actionsLayout: actionsLayout
        }, title && external_react_default.a.createElement("h2", null, title), text && external_react_default.a.createElement("p", null, text))
      });
    }
  }, {
    key: "renderNativeSheet",
    value: function renderNativeSheet(popout) {
      var style = popout.style;
      this.props.vkuiConnect.send('VKWebAppAlert', {
        style: style,
        actions: this.actions.map(function (item) {
          return removeObjectKeys(item, ['action']);
        })
      });
    }
  }, {
    key: "renderUISheet",
    value: function renderUISheet(popout) {
      var title = popout.title,
          text = popout.text,
          onClose = popout.onClose;
      this.setState({
        popout: external_react_default.a.createElement(ActionSheet_ActionSheet, {
          title: title,
          text: text,
          onClose: onClose
        }, this.actions.map(function (item, index) {
          return external_react_default.a.createElement(components_ActionSheetItem_ActionSheetItem, {
            autoclose: item.autoclose,
            theme: item.style,
            onClick: item.action,
            key: "".concat(index)
          }, item.title);
        }))
      });
    }
  }, {
    key: "closeUIPopout",
    value: function closeUIPopout() {
      this.setState({
        popout: null
      });
    }
  }, {
    key: "renderPopout",
    value: function renderPopout(props) {
      if (props.popout.style) {
        this.actions = props.popout.actions.map(function (item) {
          return NativePopouts_objectSpread({}, item, {
            autoclose: item.hasOwnProperty('autoclose') ? item.autoclose : true,
            action: item.action || props.popout.onClose,
            handler: NativePopouts_objectSpread({}, item.params, {
              action: "action-".concat(actionId++)
            })
          });
        });
        this.actionsStore = this.actions.reduce(function (res, item) {
          res[item.handler.action] = item.action;
          return res;
        }, {});

        switch (props.popout.style) {
          case 'alert':
            this.context.isWebView ? this.renderNativeAlert(props.popout) : this.renderUIAlert(props.popout);
            break;

          case 'actionSheet':
            this.context.isWebView ? this.renderNativeSheet(props.popout) : this.renderUISheet(props.popout);
            break;
        }
      } else {
        this.setState({
          popout: props.popout
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.popout && this.props.popout) {
        this.closeUIPopout();
      }

      if (nextProps.popout && nextProps.popout !== this.props.popout) {
        this.context.isWebView && this.closeUIPopout();
        this.renderPopout(nextProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Component = this.props.component;
      return external_react_default.a.createElement(Component, NativePopouts_extends({}, removeObjectKeys(this.props, ['popout']), {
        popout: this.state.popout
      }));
    }
  }]);

  return NativePopouts;
}(external_react_default.a.Component);

NativePopouts_defineProperty(NativePopouts_NativePopouts, "propTypes", {
  popout: external_prop_types_default.a.oneOfType([external_prop_types_default.a.shape({
    style: external_prop_types_default.a.oneOf(['alert', 'actionSheet']).isRequired,
    title: external_prop_types_default.a.string,
    text: external_prop_types_default.a.string,
    onClose: external_prop_types_default.a.func.isRequired,
    actions: external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({
      style: external_prop_types_default.a.oneOf(['cancel', 'default', 'destructive']),
      title: external_prop_types_default.a.string,
      action: external_prop_types_default.a.func
    }))
  }), external_prop_types_default.a.element]),
  vkuiConnect: external_prop_types_default.a.object.isRequired,

  /**
   * Root or View
   */
  component: external_prop_types_default.a.func.isRequired
});

NativePopouts_defineProperty(NativePopouts_NativePopouts, "contextTypes", {
  isWebView: external_prop_types_default.a.bool
});


// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/spinner.js
var spinner = __webpack_require__(20);
var spinner_default = /*#__PURE__*/__webpack_require__.n(spinner);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/32/spinner.js
var _32_spinner = __webpack_require__(19);
var _32_spinner_default = /*#__PURE__*/__webpack_require__.n(_32_spinner);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/44/spinner.js
var _44_spinner = __webpack_require__(18);
var _44_spinner_default = /*#__PURE__*/__webpack_require__.n(_44_spinner);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/16/spinner.js
var _16_spinner = __webpack_require__(17);
var _16_spinner_default = /*#__PURE__*/__webpack_require__.n(_16_spinner);

// CONCATENATED MODULE: ./src/components/Spinner/Spinner.js
function Spinner_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Spinner_typeof = function _typeof(obj) { return typeof obj; }; } else { Spinner_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Spinner_typeof(obj); }

function Spinner_extends() { Spinner_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Spinner_extends.apply(this, arguments); }

function Spinner_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Spinner_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Spinner_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Spinner_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Spinner_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Spinner_createClass(Constructor, protoProps, staticProps) { if (protoProps) Spinner_defineProperties(Constructor.prototype, protoProps); if (staticProps) Spinner_defineProperties(Constructor, staticProps); return Constructor; }

function Spinner_possibleConstructorReturn(self, call) { if (call && (Spinner_typeof(call) === "object" || typeof call === "function")) { return call; } return Spinner_assertThisInitialized(self); }

function Spinner_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Spinner_getPrototypeOf(o) { Spinner_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Spinner_getPrototypeOf(o); }

function Spinner_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Spinner_setPrototypeOf(subClass, superClass); }

function Spinner_setPrototypeOf(o, p) { Spinner_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Spinner_setPrototypeOf(o, p); }

function Spinner_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var Spinner_baseClassNames = getClassname('Spinner');

var Spinner_Spinner =
/*#__PURE__*/
function (_PureComponent) {
  Spinner_inherits(Spinner, _PureComponent);

  function Spinner() {
    Spinner_classCallCheck(this, Spinner);

    return Spinner_possibleConstructorReturn(this, Spinner_getPrototypeOf(Spinner).apply(this, arguments));
  }

  Spinner_createClass(Spinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          size = _this$props.size,
          restProps = Spinner_objectWithoutProperties(_this$props, ["className", "size"]);

      return external_react_default.a.createElement("div", Spinner_extends({}, restProps, {
        className: classNames(Spinner_baseClassNames, className)
      }), this.svgSpinner);
    }
  }, {
    key: "svgSpinner",
    get: function get() {
      switch (this.props.size) {
        case 'large':
          return external_react_default.a.createElement(_44_spinner_default.a, {
            className: "Spinner__self"
          });

        case 'medium':
          return external_react_default.a.createElement(_32_spinner_default.a, {
            className: "Spinner__self"
          });

        case 'small':
          return external_react_default.a.createElement(_16_spinner_default.a, {
            className: "Spinner__self"
          });

        default:
          return external_react_default.a.createElement(spinner_default.a, {
            className: "Spinner__self"
          });
      }
    }
  }]);

  return Spinner;
}(external_react_["PureComponent"]);

Spinner_defineProperty(Spinner_Spinner, "propTypes", {
  style: external_prop_types_default.a.object,
  size: external_prop_types_default.a.oneOf(['small', 'regular', 'large', 'medium']),
  className: external_prop_types_default.a.string
});

Spinner_defineProperty(Spinner_Spinner, "defaultProps", {
  size: 'regular'
});


// CONCATENATED MODULE: ./src/components/ScreenSpinner/ScreenSpinner.js
function ScreenSpinner_extends() { ScreenSpinner_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ScreenSpinner_extends.apply(this, arguments); }

function ScreenSpinner_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ScreenSpinner_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ScreenSpinner_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var ScreenSpinner_baseClassName = getClassname('ScreenSpinner');
function ScreenSpinner(_ref) {
  var style = _ref.style,
      className = _ref.className,
      restProps = ScreenSpinner_objectWithoutProperties(_ref, ["style", "className"]);

  return external_react_default.a.createElement(PopoutWrapper_PopoutWrapper, {
    className: classNames(ScreenSpinner_baseClassName, className),
    style: style
  }, external_react_default.a.createElement("div", {
    className: "ScreenSpinner__container"
  }, external_react_default.a.createElement(Spinner_Spinner, ScreenSpinner_extends({
    size: "large"
  }, restProps))));
}
ScreenSpinner.propTypes = {
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object
};
ScreenSpinner.defaultProps = {};
// CONCATENATED MODULE: ./src/components/CellButton/CellButton.js
function CellButton_extends() { CellButton_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CellButton_extends.apply(this, arguments); }

function CellButton_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CellButton_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CellButton_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function CellButton_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var CellButton_baseClassName = getClassname('CellButton');

var CellButton_CellButton = function CellButton(_ref) {
  var _classnames;

  var className = _ref.className,
      align = _ref.align,
      level = _ref.level,
      before = _ref.before,
      children = _ref.children,
      restProps = CellButton_objectWithoutProperties(_ref, ["className", "align", "level", "before", "children"]);

  return external_react_default.a.createElement(Tappable_Tappable, CellButton_extends({}, restProps, {
    className: classNames(CellButton_baseClassName, className, (_classnames = {}, CellButton_defineProperty(_classnames, "CellButton--lvl-".concat(level), level), CellButton_defineProperty(_classnames, "CellButton--aln-".concat(align), align), _classnames)),
    stopPropagation: true
  }), external_react_default.a.createElement("div", {
    className: "CellButton__in"
  }, before && external_react_default.a.createElement("div", {
    className: "CellButton__before"
  }, before), children && external_react_default.a.createElement("div", {
    className: "CellButton__content"
  }, children)));
};

CellButton_CellButton.propTypes = {
  level: external_prop_types_default.a.oneOf(['primary', 'danger']),
  align: external_prop_types_default.a.oneOf(['left', 'center', 'right']),
  before: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  component: external_prop_types_default.a.any
};
CellButton_CellButton.defaultProps = {
  level: 'primary',
  align: 'left'
};
/* harmony default export */ var components_CellButton_CellButton = (CellButton_CellButton);
// CONCATENATED MODULE: ./src/components/Button/Button.js
function Button_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Button_typeof = function _typeof(obj) { return typeof obj; }; } else { Button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Button_typeof(obj); }

function Button_extends() { Button_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Button_extends.apply(this, arguments); }

function Button_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Button_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Button_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Button_createClass(Constructor, protoProps, staticProps) { if (protoProps) Button_defineProperties(Constructor.prototype, protoProps); if (staticProps) Button_defineProperties(Constructor, staticProps); return Constructor; }

function Button_possibleConstructorReturn(self, call) { if (call && (Button_typeof(call) === "object" || typeof call === "function")) { return call; } return Button_assertThisInitialized(self); }

function Button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Button_getPrototypeOf(o) { Button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Button_getPrototypeOf(o); }

function Button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Button_setPrototypeOf(subClass, superClass); }

function Button_setPrototypeOf(o, p) { Button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Button_setPrototypeOf(o, p); }

function Button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Button_baseClassName = getClassname('Button');

var Button_Button =
/*#__PURE__*/
function (_React$Component) {
  Button_inherits(Button, _React$Component);

  function Button() {
    Button_classCallCheck(this, Button);

    return Button_possibleConstructorReturn(this, Button_getPrototypeOf(Button).apply(this, arguments));
  }

  Button_createClass(Button, [{
    key: "render",
    value: function render() {
      if (this.props.type === 'cell') {
        var _this$props = this.props,
            stretched = _this$props.stretched,
            size = _this$props.size,
            restProps = Button_objectWithoutProperties(_this$props, ["stretched", "size"]);

        return external_react_default.a.createElement(components_CellButton_CellButton, restProps);
      } else {
        var _classnames;

        var _this$props2 = this.props,
            className = _this$props2.className,
            _size = _this$props2.size,
            level = _this$props2.level,
            _stretched = _this$props2.stretched,
            align = _this$props2.align,
            children = _this$props2.children,
            before = _this$props2.before,
            _restProps = Button_objectWithoutProperties(_this$props2, ["className", "size", "level", "stretched", "align", "children", "before"]);

        return external_react_default.a.createElement(Tappable_Tappable, Button_extends({}, _restProps, {
          className: classNames(Button_baseClassName, className, (_classnames = {}, Button_defineProperty(_classnames, "Button--sz-".concat(_size), true), Button_defineProperty(_classnames, "Button--lvl-".concat(Button.mapOldLevel(level)), true), Button_defineProperty(_classnames, "Button--aln-".concat(align || 'center'), true), Button_defineProperty(_classnames, "Button--str", _stretched), _classnames)),
          stopPropagation: true
        }), external_react_default.a.createElement("div", {
          className: "Button__in"
        }, before && external_react_default.a.createElement("div", {
          className: "Button__before"
        }, before), children && external_react_default.a.createElement("div", {
          className: "Button__content"
        }, children)));
      }
    }
  }], [{
    key: "mapOldLevel",
    value: function mapOldLevel(level) {
      switch (level) {
        case '1':
          return 'primary';

        case '2':
          return 'secondary';

        case '3':
          return 'tertiary';

        case 'sell':
          return 'outline';

        case 'buy':
          return 'commerce';

        default:
          return level;
      }
    }
  }]);

  return Button;
}(external_react_default.a.Component);

Button_defineProperty(Button_Button, "propTypes", {
  /**
   * Значения `1`, `2`, `3`, `sell`, `buy` устарели. Маппинг на новые значения находится в
   * статическом методе `Button.mapOldLevel(level)`. Старые значения будут удалены в 3.0.0
   */
  level: external_prop_types_default.a.oneOf(['primary', 'secondary', 'tertiary', 'outline', 'commerce', '1', '2', '3', 'sell', 'buy']),
  size: external_prop_types_default.a.oneOf(['m', 'l', 'xl']),

  /**
   * @deprecated Кнопки-ячейки `<Button type="cell" />` переехали в отдельный компонент: `<CellButton />`.
   * Свойство `type` будет удалено в 3.0.0
   */
  type: external_prop_types_default.a.oneOf(['default', 'cell']),
  align: external_prop_types_default.a.oneOf(['left', 'center', 'right']),
  stretched: external_prop_types_default.a.bool,
  before: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  component: external_prop_types_default.a.any
});

Button_defineProperty(Button_Button, "defaultProps", {
  level: 'primary',
  type: 'default',
  component: 'button',
  size: 'm',
  stretched: false
});


// CONCATENATED MODULE: ./src/components/Header/Header.js
function Header_extends() { Header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Header_extends.apply(this, arguments); }

function Header_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Header_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Header_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Header_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Header_baseClassNames = getClassname('Header');

var Header_Header = function Header(_ref) {
  var className = _ref.className,
      level = _ref.level,
      children = _ref.children,
      aside = _ref.aside,
      getRootRef = _ref.getRootRef,
      restProps = Header_objectWithoutProperties(_ref, ["className", "level", "children", "aside", "getRootRef"]);

  return external_react_default.a.createElement("div", Header_extends({}, restProps, {
    ref: getRootRef,
    className: classNames(Header_baseClassNames, className, Header_defineProperty({}, "Header--level-".concat(level), true))
  }), external_react_default.a.createElement("div", {
    className: "Header__in"
  }, external_react_default.a.createElement("div", {
    className: "Header__content"
  }, children), aside && external_react_default.a.createElement("div", {
    className: "Header__aside"
  }, aside)));
};

Header_Header.propTypes = {
  className: external_prop_types_default.a.string,
  level: external_prop_types_default.a.oneOf(['1', '2']),
  aside: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  getRootRef: external_prop_types_default.a.func
};
Header_Header.defaultProps = {
  level: '1'
};
/* harmony default export */ var components_Header_Header = (Header_Header);
// CONCATENATED MODULE: ./src/components/Group/Group.js
function Group_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Group_typeof = function _typeof(obj) { return typeof obj; }; } else { Group_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Group_typeof(obj); }

function Group_extends() { Group_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Group_extends.apply(this, arguments); }

function Group_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Group_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Group_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Group_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Group_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Group_createClass(Constructor, protoProps, staticProps) { if (protoProps) Group_defineProperties(Constructor.prototype, protoProps); if (staticProps) Group_defineProperties(Constructor, staticProps); return Constructor; }

function Group_possibleConstructorReturn(self, call) { if (call && (Group_typeof(call) === "object" || typeof call === "function")) { return call; } return Group_assertThisInitialized(self); }

function Group_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Group_getPrototypeOf(o) { Group_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Group_getPrototypeOf(o); }

function Group_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Group_setPrototypeOf(subClass, superClass); }

function Group_setPrototypeOf(o, p) { Group_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Group_setPrototypeOf(o, p); }

function Group_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Group_baseClassNames = getClassname('Group');

var Group_Group =
/*#__PURE__*/
function (_Component) {
  Group_inherits(Group, _Component);

  function Group() {
    Group_classCallCheck(this, Group);

    return Group_possibleConstructorReturn(this, Group_getPrototypeOf(Group).apply(this, arguments));
  }

  Group_createClass(Group, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          description = _this$props.description,
          className = _this$props.className,
          children = _this$props.children,
          getRootRef = _this$props.getRootRef,
          restProps = Group_objectWithoutProperties(_this$props, ["title", "description", "className", "children", "getRootRef"]);

      return external_react_default.a.createElement("div", Group_extends({}, restProps, {
        ref: getRootRef,
        className: classNames(Group_baseClassNames, className)
      }), title && external_react_default.a.createElement(components_Header_Header, {
        level: "2"
      }, title), children && external_react_default.a.createElement("div", {
        className: "Group__content"
      }, children), description && external_react_default.a.createElement("div", {
        className: "Group__description"
      }, description));
    }
  }]);

  return Group;
}(external_react_["Component"]);

Group_defineProperty(Group_Group, "propTypes", {
  style: external_prop_types_default.a.object,
  title: external_prop_types_default.a.node,
  description: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  getRootRef: external_prop_types_default.a.func
});

Group_defineProperty(Group_Group, "defaultProps", {
  title: null,
  description: null
});


// CONCATENATED MODULE: ./src/components/List/List.js
function List_extends() { List_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return List_extends.apply(this, arguments); }

function List_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = List_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function List_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var List_baseClassNames = getClassname('List');

var List_List = function List(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = List_objectWithoutProperties(_ref, ["className", "children"]);

  return external_react_default.a.createElement("div", List_extends({}, restProps, {
    className: classNames(List_baseClassNames, className)
  }), children);
};

List_List.propTypes = {
  style: external_prop_types_default.a.object,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string
};
List_List.defaultProps = {
  style: {},
  children: ''
};
/* harmony default export */ var components_List_List = (List_List);
// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/chevron.js
var chevron = __webpack_require__(16);
var chevron_default = /*#__PURE__*/__webpack_require__.n(chevron);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/16/done.js
var done = __webpack_require__(6);
var done_default = /*#__PURE__*/__webpack_require__.n(done);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/cancel.js
var cancel = __webpack_require__(5);
var cancel_default = /*#__PURE__*/__webpack_require__.n(cancel);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/reorder.js
var reorder = __webpack_require__(15);
var reorder_default = /*#__PURE__*/__webpack_require__.n(reorder);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/reorder_ios.js
var reorder_ios = __webpack_require__(14);
var reorder_ios_default = /*#__PURE__*/__webpack_require__.n(reorder_ios);

// CONCATENATED MODULE: ./src/components/Cell/Cell.js
function Cell_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Cell_typeof = function _typeof(obj) { return typeof obj; }; } else { Cell_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Cell_typeof(obj); }

function Cell_extends() { Cell_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Cell_extends.apply(this, arguments); }

function Cell_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Cell_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Cell_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Cell_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Cell_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Cell_createClass(Constructor, protoProps, staticProps) { if (protoProps) Cell_defineProperties(Constructor.prototype, protoProps); if (staticProps) Cell_defineProperties(Constructor, staticProps); return Constructor; }

function Cell_possibleConstructorReturn(self, call) { if (call && (Cell_typeof(call) === "object" || typeof call === "function")) { return call; } return Cell_assertThisInitialized(self); }

function Cell_getPrototypeOf(o) { Cell_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Cell_getPrototypeOf(o); }

function Cell_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Cell_setPrototypeOf(subClass, superClass); }

function Cell_setPrototypeOf(o, p) { Cell_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Cell_setPrototypeOf(o, p); }

function Cell_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Cell_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var Cell_osname = platform();
var Cell_baseClassNames = getClassname('Cell');

var Cell_Cell =
/*#__PURE__*/
function (_Component) {
  Cell_inherits(Cell, _Component);

  function Cell() {
    var _getPrototypeOf2;

    var _this;

    Cell_classCallCheck(this, Cell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Cell_possibleConstructorReturn(this, (_getPrototypeOf2 = Cell_getPrototypeOf(Cell)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "state", {
      isRemoveActivated: false,
      removeOffset: 0,
      dragging: false
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "onClick", function (e) {
      var _this$props = _this.props,
          removable = _this$props.removable,
          onClick = _this$props.onClick;

      if (e.target.tagName.toLowerCase() === 'input') {
        e.stopPropagation();
      } else if (removable) {
        return null;
      } else {
        onClick && onClick(e);
      }
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "activateRemove", function () {
      _this.setState({
        isRemoveActivated: true
      });

      _this.document.addEventListener('click', _this.deactivateRemove);
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "deactivateRemove", function () {
      _this.setState({
        isRemoveActivated: false,
        removeOffset: 0
      });

      _this.document.removeEventListener('click', _this.deactivateRemove);
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "onRemoveClick", function (e) {
      e.nativeEvent.stopImmediatePropagation();
      e.preventDefault();
      _this.props.onRemove && _this.props.onRemove(e, _this.rootEl);
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "getRemoveRef", function (el) {
      return _this.removeButton = el;
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "getRootRef", function (el) {
      _this.rootEl = el;
      _this.props.getRootRef && _this.props.getRootRef(el);
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "onDragStart", function () {
      _this.setState({
        dragging: true
      });

      _this.dragShift = 0;
      _this.listEl = _this.rootEl.closest('.List');
      _this.listEl && _this.listEl.classList.add('List--dragging');
      _this.siblings = Array.prototype.slice.call(_this.rootEl.parentElement.childNodes);
      _this.dragStartIndex = _this.siblings.indexOf(_this.rootEl);
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "onDragMove", function (e) {
      e.originalEvent.preventDefault();
      _this.rootEl.style.transform = "translateY(".concat(e.shiftY, "px)");

      var rootGesture = _this.rootEl.getBoundingClientRect();

      _this.dragDirection = _this.dragShift - e.shiftY < 0 ? 'down' : 'up';
      _this.dragShift = e.shiftY;
      _this.dragEndIndex = _this.dragStartIndex;

      _this.siblings.forEach(function (sibling, siblingIndex) {
        var siblingGesture = sibling.getBoundingClientRect();

        if (_this.dragStartIndex < siblingIndex) {
          if (rootGesture.bottom > siblingGesture.top + siblingGesture.height / 2) {
            if (_this.dragDirection === 'down') sibling.style.transform = "translateY(-100%)";
            _this.dragEndIndex++;
          }

          if (rootGesture.top < siblingGesture.bottom - siblingGesture.height / 2 && _this.dragDirection === 'up') {
            sibling.style.transform = "translateY(0)";
          }
        } else if (_this.dragStartIndex > siblingIndex) {
          if (rootGesture.top < siblingGesture.bottom - siblingGesture.height / 2) {
            if (_this.dragDirection === 'up') sibling.style.transform = "translateY(100%)";
            _this.dragEndIndex--;
          }

          if (rootGesture.bottom > siblingGesture.top + siblingGesture.height / 2 && _this.dragDirection === 'down') {
            sibling.style.transform = "translateY(0)";
          }
        }
      });
    });

    Cell_defineProperty(Cell_assertThisInitialized(Cell_assertThisInitialized(_this)), "onDragEnd", function () {
      _this.setState({
        dragging: false
      });

      _this.listEl && _this.listEl.classList.remove('List--dragging');
      _this.props.onDragFinish && _this.props.onDragFinish({
        from: _this.dragStartIndex,
        to: _this.dragEndIndex
      });

      _this.siblings.forEach(function (sibling) {
        return sibling.style.transform = null;
      });

      delete _this.dragShift;
      delete _this.listEl;
      delete _this.siblings;
      delete _this.dragStartIndex;
      delete _this.dragEndIndex;
      delete _this.dragDirection;
    });

    return _this;
  }

  Cell_createClass(Cell, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.document.removeEventListener('click', this.deactivateRemove);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isRemoveActivated !== this.state.isRemoveActivated && this.state.isRemoveActivated) {
        this.setState({
          removeOffset: this.removeButton.offsetWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props2 = this.props,
          before = _this$props2.before,
          indicator = _this$props2.indicator,
          asideContent = _this$props2.asideContent,
          expandable = _this$props2.expandable,
          onClick = _this$props2.onClick,
          children = _this$props2.children,
          getRootRef = _this$props2.getRootRef,
          description = _this$props2.description,
          selectable = _this$props2.selectable,
          multiline = _this$props2.multiline,
          className = _this$props2.className,
          onRemove = _this$props2.onRemove,
          removable = _this$props2.removable,
          removePlaceholder = _this$props2.removePlaceholder,
          draggable = _this$props2.draggable,
          onDragFinish = _this$props2.onDragFinish,
          href = _this$props2.href,
          size = _this$props2.size,
          bottomContent = _this$props2.bottomContent,
          restProps = Cell_objectWithoutProperties(_this$props2, ["before", "indicator", "asideContent", "expandable", "onClick", "children", "getRootRef", "description", "selectable", "multiline", "className", "onRemove", "removable", "removePlaceholder", "draggable", "onDragFinish", "href", "size", "bottomContent"]);

      selectable = selectable && !draggable;
      var rootProps = selectable ? {} : restProps;
      var inputProps = selectable ? restProps : {};
      var linkProps = href ? restProps : {};
      return external_react_default.a.createElement("div", Cell_extends({}, rootProps, {
        onClick: href || draggable ? null : this.onClick,
        className: classNames(Cell_baseClassNames, (_classnames = {
          'Cell--expandable': expandable,
          'Cell--multiline': multiline
        }, Cell_defineProperty(_classnames, "Cell--".concat(size), size), Cell_defineProperty(_classnames, 'Cell--dragging', this.state.dragging), Cell_defineProperty(_classnames, 'Cell--draggable', draggable), _classnames), className),
        ref: this.getRootRef
      }), external_react_default.a.createElement(Tappable_Tappable, Cell_extends({}, linkProps, {
        onClick: href ? this.onClick : null,
        component: selectable ? 'label' : href ? 'a' : 'div',
        className: "Cell__in",
        href: href,
        disabled: !selectable && !onClick && !href || removable || draggable,
        style: removable ? {
          transform: "translateX(-".concat(this.state.removeOffset, "px)")
        } : null
      }), selectable && external_react_default.a.createElement("input", Cell_extends({}, inputProps, {
        type: "checkbox",
        className: "Cell__checkbox"
      })), external_react_default.a.createElement("div", {
        className: "Cell__before"
      }, selectable && Cell_osname === IOS && external_react_default.a.createElement("div", {
        className: "Cell__checkbox-marker"
      }, external_react_default.a.createElement(done_default.a, null)), removable && Cell_osname === IOS && external_react_default.a.createElement("div", {
        className: "Cell__remove-marker",
        onClick: this.activateRemove
      }), Cell_osname === ANDROID && draggable && external_react_default.a.createElement(Touch_Touch, {
        onStart: this.onDragStart,
        onMoveY: this.onDragMove,
        onEnd: this.onDragEnd,
        className: "Cell__dragger"
      }, external_react_default.a.createElement(reorder_default.a, null)), before && external_react_default.a.createElement("div", {
        className: "Cell__before-in"
      }, before)), external_react_default.a.createElement("div", {
        className: "Cell__main"
      }, external_react_default.a.createElement("div", {
        className: "Cell__children"
      }, children), description && external_react_default.a.createElement("div", {
        className: "Cell__description"
      }, description), size === 'l' && bottomContent && external_react_default.a.createElement("div", {
        className: "Cell__bottom"
      }, bottomContent)), external_react_default.a.createElement("div", {
        className: "Cell__indicator"
      }, indicator), external_react_default.a.createElement("div", {
        className: "Cell__aside"
      }, asideContent, selectable && Cell_osname === ANDROID && external_react_default.a.createElement("div", {
        className: "Cell__checkbox-marker"
      }, external_react_default.a.createElement(done_default.a, null)), removable && Cell_osname === ANDROID && external_react_default.a.createElement("div", {
        className: "Cell__remove-marker",
        onClick: this.onRemoveClick
      }, external_react_default.a.createElement(cancel_default.a, null)), Cell_osname === IOS && expandable && !draggable && external_react_default.a.createElement(chevron_default.a, {
        className: "Cell__chevron"
      }), Cell_osname === IOS && draggable && external_react_default.a.createElement(Touch_Touch, {
        className: "Cell__dragger",
        onStart: this.onDragStart,
        onMoveY: this.onDragMove,
        onEnd: this.onDragEnd
      }, external_react_default.a.createElement(reorder_ios_default.a, null)))), removable && Cell_osname === IOS && external_react_default.a.createElement("div", {
        ref: this.getRemoveRef,
        className: "Cell__remove",
        onClick: this.onRemoveClick,
        style: removable ? {
          transform: "translateX(-".concat(this.state.removeOffset, "px)")
        } : null
      }, external_react_default.a.createElement("span", {
        className: "Cell__remove-in"
      }, removePlaceholder)));
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
    /**
     * предотвращает двойное срабатывание в случае с input
     * (https://github.com/vuejs/vue/issues/3699#issuecomment-247957931)
     * предотвращает клик в случае, когда включен режим removable
     * @param e
     */

  }]);

  return Cell;
}(external_react_["Component"]);

Cell_defineProperty(Cell_Cell, "propTypes", {
  /**
   * Контейнер для контента от `children`.
   */
  before: external_prop_types_default.a.node,

  /**
   * Контейнер для текста справа от `children`.
   */
  indicator: external_prop_types_default.a.node,

  /**
   * Контейнер для контента справа от `children` и `indicator`.
   */
  asideContent: external_prop_types_default.a.node,

  /**
   * Выставляйте этот флаг, если клик по ячейке вызывает переход на другую панель. Флаг нужен для корректной
   * стилизации такой ячейки.
   */
  expandable: external_prop_types_default.a.bool,
  children: external_prop_types_default.a.node,
  onClick: external_prop_types_default.a.func,

  /**
   * Добавляет возможность переноса содержимого `children` и `description`. Без этого флага текст будет уходить
   * в троеточие.
   */
  multiline: external_prop_types_default.a.bool,

  /**
   * Контейнер для дополнительного содержимого под `children`.
   */
  description: external_prop_types_default.a.node,
  getRootRef: external_prop_types_default.a.func,

  /**
   * Контейнер для произвольного содержимого под `description`. Рисуется только если передать `size="l"`.
   */
  bottomContent: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,

  /**
   * Размер влияет на выравнивание блоков по вертикали, вид сепаратора (iOS) и возможность вставлять `bottomContent`.
   */
  size: external_prop_types_default.a.oneOf(['m', 'l']),

  /**
   * Флаг для перехода в режим ячеек-чекбоксов.
   * **Важно:** в этом режиме обработчик `onClick` вызываться не будет.
   * **Важно:** этот режим несовместим с `draggable`. В случае истинности двух этих флагов, приоритет отдается
   * `draggable`.
   */
  selectable: external_prop_types_default.a.bool,

  /**
   * Флаг для перехода в режим удаляемых ячеек. **Важно:** в этом режиме обработчик `onClick` вызываться не будет.
   */
  removable: external_prop_types_default.a.bool,

  /**
   * Коллбэк срабатывает при клике на контрол удаления.
   */
  onRemove: external_prop_types_default.a.func,

  /**
   * iOS only. Текст в выезжаеющей кнопке для удаления ячейки.
   */
  removePlaceholder: external_prop_types_default.a.node,

  /**
   * Флаг для перехода в режим перетаскивания. **Важно:** в этом режиме обработчик `onClick` вызываться не будет.
   */
  draggable: external_prop_types_default.a.bool,

  /**
   * Коллбэк срабатывает при завершении перетаскивания.
   * **Важно:** режим перетаскивания не меняет порядок ячеек в DOM. В коллбэке есть объект с полями `from` и `to`.
   * Эти числа нужны для того, чтобы разработчик понимал, с какого индекса на какой произошел переход. В песочнице
   * есть рабочий пример с обработкой этих чисел и перерисовкой списка.
   */
  onDragFinish: external_prop_types_default.a.func,

  /**
   * При передаче `href`, ячейка становится полноценной ссылкой. Поддерживаются все валидные для этого элемента
   * атрибуты (`target`, `rel` и т.д.).
   */
  href: external_prop_types_default.a.string
});

Cell_defineProperty(Cell_Cell, "defaultProps", {
  before: null,
  indicator: '',
  asideContent: '',
  bottomContent: null,
  expandable: false,
  children: '',
  selectable: false,
  multiline: false,
  removable: false,
  size: 'm',
  removePlaceholder: 'Удалить'
});

Cell_defineProperty(Cell_Cell, "contextTypes", {
  document: external_prop_types_default.a.any
});


// CONCATENATED MODULE: ./src/components/Div/Div.js
function Div_extends() { Div_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Div_extends.apply(this, arguments); }

function Div_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Div_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Div_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Div_baseClassNames = getClassname('Div');
function Div(_ref) {
  var className = _ref.className,
      children = _ref.children,
      getRootRef = _ref.getRootRef,
      restProps = Div_objectWithoutProperties(_ref, ["className", "children", "getRootRef"]);

  return external_react_default.a.createElement("div", Div_extends({}, restProps, {
    ref: getRootRef,
    className: classNames(Div_baseClassNames, className)
  }), children);
}
Div.propTypes = {
  style: external_prop_types_default.a.object,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  getRootRef: external_prop_types_default.a.func
};
// CONCATENATED MODULE: ./src/components/Footer/Footer.js
function Footer_extends() { Footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Footer_extends.apply(this, arguments); }

function Footer_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Footer_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Footer_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var Footer_Footer = function Footer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = Footer_objectWithoutProperties(_ref, ["className", "children"]);

  return external_react_default.a.createElement(Div, Footer_extends({}, restProps, {
    className: classNames('Footer', className)
  }), children);
};

Footer_Footer.propTypes = {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object
};
/* harmony default export */ var components_Footer_Footer = (Footer_Footer);
// CONCATENATED MODULE: ./src/components/InfoRow/InfoRow.js
function InfoRow_extends() { InfoRow_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return InfoRow_extends.apply(this, arguments); }

function InfoRow_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = InfoRow_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function InfoRow_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var InfoRow_baseClassName = getClassname('InfoRow');

var InfoRow_InfoRow = function InfoRow(_ref) {
  var title = _ref.title,
      className = _ref.className,
      children = _ref.children,
      restProps = InfoRow_objectWithoutProperties(_ref, ["title", "className", "children"]);

  return external_react_default.a.createElement("div", InfoRow_extends({}, restProps, {
    className: classNames(InfoRow_baseClassName, className)
  }), title && external_react_default.a.createElement("div", {
    className: "InfoRow__title"
  }, title), children && external_react_default.a.createElement("div", null, children));
};

InfoRow_InfoRow.propTypes = {
  title: external_prop_types_default.a.node.isRequired,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object
};
/* harmony default export */ var components_InfoRow_InfoRow = (InfoRow_InfoRow);
// CONCATENATED MODULE: ./src/components/Avatar/Avatar.js
function Avatar_extends() { Avatar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Avatar_extends.apply(this, arguments); }

function Avatar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Avatar_defineProperty(target, key, source[key]); }); } return target; }

function Avatar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Avatar_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Avatar_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Avatar_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Avatar_baseClassName = getClassname('Avatar');

var Avatar_Avatar = function Avatar(_ref) {
  var src = _ref.src,
      size = _ref.size,
      type = _ref.type,
      style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      getRootRef = _ref.getRootRef,
      restProps = Avatar_objectWithoutProperties(_ref, ["src", "size", "type", "style", "className", "children", "getRootRef"]);

  var Component = src ? 'img' : 'div';
  var borderRadius;

  switch (type) {
    case 'default':
      borderRadius = '50%';
      break;

    case 'image':
      borderRadius = 4;
      break;

    case 'app':
      borderRadius = Math.floor(size * 10 / 48);
      break;
  }

  return external_react_default.a.createElement("div", {
    className: classNames(Avatar_baseClassName, className, Avatar_defineProperty({}, "Avatar--type-".concat(type), true)),
    ref: getRootRef
  }, external_react_default.a.createElement("div", {
    className: "Avatar__in"
  }, external_react_default.a.createElement(Component, Avatar_extends({}, restProps, {
    className: "Avatar__img",
    src: src,
    style: Avatar_objectSpread({}, style, {
      width: size,
      height: size,
      borderRadius: borderRadius
    })
  })), children && external_react_default.a.createElement("div", {
    className: "Avatar__children",
    style: {
      width: size,
      height: size,
      borderRadius: borderRadius
    }
  }, children)));
};

Avatar_Avatar.propTypes = {
  size: external_prop_types_default.a.oneOf([80, 72, 64, 56, 48, 40, 36, 32, 28]),
  src: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  type: external_prop_types_default.a.oneOf(['default', 'image', 'app']),
  children: external_prop_types_default.a.node,
  getRootRef: external_prop_types_default.a.func
};
Avatar_Avatar.defaultProps = {
  size: 48,
  type: 'default'
};
/* harmony default export */ var components_Avatar_Avatar = (Avatar_Avatar);
// CONCATENATED MODULE: ./src/components/Entity/Entity.js
function Entity_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Entity_typeof = function _typeof(obj) { return typeof obj; }; } else { Entity_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Entity_typeof(obj); }

function Entity_extends() { Entity_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Entity_extends.apply(this, arguments); }

function Entity_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Entity_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Entity_createClass(Constructor, protoProps, staticProps) { if (protoProps) Entity_defineProperties(Constructor.prototype, protoProps); if (staticProps) Entity_defineProperties(Constructor, staticProps); return Constructor; }

function Entity_possibleConstructorReturn(self, call) { if (call && (Entity_typeof(call) === "object" || typeof call === "function")) { return call; } return Entity_assertThisInitialized(self); }

function Entity_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Entity_getPrototypeOf(o) { Entity_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Entity_getPrototypeOf(o); }

function Entity_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Entity_setPrototypeOf(subClass, superClass); }

function Entity_setPrototypeOf(o, p) { Entity_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Entity_setPrototypeOf(o, p); }

function Entity_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Entity_baseClassNames = getClassname('Entity'); // @TODO Try to load photo

/**
 * @deprecated Используйте `Cell`. Этот компонент устарел и будет удален в 3.0.0
 */

var Entity_Entity =
/*#__PURE__*/
function (_Component) {
  Entity_inherits(Entity, _Component);

  function Entity() {
    Entity_classCallCheck(this, Entity);

    return Entity_possibleConstructorReturn(this, Entity_getPrototypeOf(Entity).apply(this, arguments));
  }

  Entity_createClass(Entity, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          photo = _this$props.photo,
          title = _this$props.title,
          description = _this$props.description,
          avatarProps = _this$props.avatarProps,
          children = _this$props.children;
      return external_react_default.a.createElement("div", {
        className: classNames(Entity_baseClassNames, className),
        style: style
      }, external_react_default.a.createElement("div", {
        className: "Entity__aside"
      }, external_react_default.a.createElement(components_Avatar_Avatar, Entity_extends({
        src: photo,
        alt: title,
        size: this.avatarSize
      }, avatarProps))), external_react_default.a.createElement("div", {
        className: "Entity__main"
      }, title && external_react_default.a.createElement("div", {
        className: "Entity__title"
      }, title), description && external_react_default.a.createElement("div", {
        className: "Entity__description"
      }, description), children && external_react_default.a.createElement("div", {
        className: "Entity__content"
      }, children)));
    }
  }, {
    key: "avatarSize",
    get: function get() {
      switch (this.props.size) {
        case 'm':
          return 64;

        case 's':
          return 48;

        default:
          return this.props.size;
      }
    }
  }]);

  return Entity;
}(external_react_["Component"]);

Entity_defineProperty(Entity_Entity, "propTypes", {
  style: external_prop_types_default.a.object,

  /**
   * @deprecated Используйте `avatarProps.size`
   */
  size: external_prop_types_default.a.oneOf(['m', 's', 80, 72, 64, 56, 48, 40, 36, 32, 28]),
  photo: external_prop_types_default.a.string,
  title: external_prop_types_default.a.node,
  description: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  avatarProps: external_prop_types_default.a.shape(components_Avatar_Avatar.propTypes),
  children: external_prop_types_default.a.node
});

Entity_defineProperty(Entity_Entity, "defaultProps", {
  size: 48,
  photo: '',
  title: '',
  description: ''
});


// CONCATENATED MODULE: ./src/components/Gallery/Gallery.js
function Gallery_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Gallery_typeof = function _typeof(obj) { return typeof obj; }; } else { Gallery_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Gallery_typeof(obj); }

function Gallery_extends() { Gallery_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Gallery_extends.apply(this, arguments); }

function Gallery_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Gallery_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Gallery_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Gallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Gallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Gallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) Gallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) Gallery_defineProperties(Constructor, staticProps); return Constructor; }

function Gallery_possibleConstructorReturn(self, call) { if (call && (Gallery_typeof(call) === "object" || typeof call === "function")) { return call; } return Gallery_assertThisInitialized(self); }

function Gallery_getPrototypeOf(o) { Gallery_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Gallery_getPrototypeOf(o); }

function Gallery_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Gallery_setPrototypeOf(subClass, superClass); }

function Gallery_setPrototypeOf(o, p) { Gallery_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Gallery_setPrototypeOf(o, p); }

function Gallery_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Gallery_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Gallery_baseClassNames = getClassname('Gallery');

var Gallery_Gallery =
/*#__PURE__*/
function (_Component) {
  Gallery_inherits(Gallery, _Component);

  function Gallery(props) {
    var _this;

    Gallery_classCallCheck(this, Gallery);

    _this = Gallery_possibleConstructorReturn(this, Gallery_getPrototypeOf(Gallery).call(this, props));

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "slidesStore", {});

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "go", function (targetIndex) {
      _this.setState({
        animation: true,
        shiftX: _this.calculateIndent(targetIndex),
        current: targetIndex
      });

      if (_this.timeout) {
        _this.clearTimeout();

        _this.setTimeout(_this.props.autoplay);
      }
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "onStart", function (e) {
      _this.setState({
        animation: false,
        startT: e.startT
      });
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "onMoveX", function (e) {
      if (!_this.isDraggable()) {
        return;
      }

      e.originalEvent.preventDefault();

      if (e.isSlideX) {
        _this.props.onDragStart && _this.props.onDragStart();

        if (_this.state.deltaX !== e.shiftX || _this.state.dragging !== e.isSlideX) {
          _this.setState({
            deltaX: e.shiftX,
            dragging: e.isSlideX
          });
        }

        return true;
      }
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "onEnd", function (e) {
      var targetIndex = e.isSlide ? _this.getTarget() : _this.state.current;
      _this.props.onDragEnd && _this.props.onDragEnd();

      _this.setState({
        shiftX: _this.calculateIndent(targetIndex),
        deltaX: 0,
        animation: true,
        current: targetIndex,
        duration: '.24'
      });

      if (_this.props.onEnd) {
        _this.props.onEnd({
          targetIndex: targetIndex
        });
      }

      if (_this.timeout) {
        _this.clearTimeout();

        _this.setTimeout(_this.props.autoplay);
      }

      return true;
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "onResize", function () {
      _this.initializeSlides();

      var layerWidth = _this.state.layerWidth;
      var containerWidth = _this.container.offsetWidth;
      var viewportWidth = _this.viewport.offsetWidth;

      _this.setState({
        shiftX: _this.calculateIndent(_this.state.current),
        containerWidth: containerWidth,
        min: _this.calcMin({
          layerWidth: layerWidth,
          containerWidth: containerWidth,
          viewportWidth: viewportWidth
        }),
        animation: false
      }, function () {
        window.requestAnimationFrame(function () {
          return _this.setState({
            animation: true
          });
        });
      });
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "setTimeout", function (duration) {
      _this.timeout = setTimeout(function () {
        var _this$state = _this.state,
            slides = _this$state.slides,
            current = _this$state.current;
        var targetIndex = current < slides.length - 1 ? current + 1 : 0;

        _this.go(targetIndex);
      }, duration);
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "clearTimeout", function () {
      clearTimeout(_this.timeout);
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "reduceChildren", function (acc, item, i) {
      if (item) {
        var ref = _this.getSlideRef(i);

        acc.push(external_react_default.a.createElement("div", {
          className: "Gallery__slide",
          key: "slide-".concat(i),
          ref: ref
        }, item));
      }

      return acc;
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "getContainerRef", function (container) {
      _this.container = container;
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "getViewportRef", function (viewport) {
      _this.viewport = viewport ? viewport.container : {};
    });

    Gallery_defineProperty(Gallery_assertThisInitialized(Gallery_assertThisInitialized(_this)), "getSlideRef", function (id) {
      return function (slide) {
        _this.slidesStore["slide-".concat(id)] = slide;
      };
    });

    var _current = typeof props.slideIndex === 'number' ? props.slideIndex : props.initialSlideIndex;

    _this.state = {
      containerWidth: 0,
      current: _current,
      deltaX: 0,
      shiftX: 0,
      slides: [],
      animation: false,
      duration: 0.24
    };
    _this.slides = _this.getChildren(props.children);
    return _this;
  }

  Gallery_createClass(Gallery, [{
    key: "initializeSlides",
    value: function initializeSlides() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var slides = this.getSlidesCoords();
      var containerWidth = this.container.offsetWidth;
      var viewportWidth = this.viewport.offsetWidth;
      var layerWidth = slides.reduce(function (val, slide) {
        return slide.width + val;
      }, 0);
      var min = this.calcMin({
        containerWidth: containerWidth,
        layerWidth: layerWidth,
        viewportWidth: viewportWidth
      });
      var max = 0;
      this.setState({
        min: min,
        max: max,
        layerWidth: layerWidth,
        containerWidth: containerWidth,
        slides: slides
      }, callback);
    }
  }, {
    key: "calcMin",
    value: function calcMin(_ref) {
      var containerWidth = _ref.containerWidth,
          layerWidth = _ref.layerWidth,
          viewportWidth = _ref.viewportWidth;

      switch (this.props.align) {
        case 'left':
          return containerWidth - layerWidth;

        case 'right':
          return viewportWidth - layerWidth;

        case 'center':
          return viewportWidth - (containerWidth - viewportWidth) / 2 - layerWidth;
      }
    }
    /**
     * Получает координаты и размеры каждого слайда
      * @returns {Array} Массив с объектами, описывающими габариты слайда
     */

  }, {
    key: "getSlidesCoords",
    value: function getSlidesCoords() {
      var _this2 = this;

      return [].concat(this.props.children).reduce(function (acc, item, i) {
        if (item) {
          var elem = _this2.slidesStore["slide-".concat(i)];

          var res = {
            coordX: elem.offsetLeft,
            width: elem.offsetWidth,
            id: item.props.id
          };
          acc.push(res);
        }

        return acc;
      }, []);
    }
    /**
     * Считает отступ слоя галереи во время драга
     *
     * @returns {Number} Значения отступа
     */

  }, {
    key: "calculateDragIndent",
    value: function calculateDragIndent() {
      var _this$state2 = this.state,
          shiftX = _this$state2.shiftX,
          deltaX = _this$state2.deltaX,
          min = _this$state2.min,
          max = _this$state2.max;
      var indent = shiftX + deltaX;

      if (indent > max) {
        return max + Number((indent - max) / 3);
      } else if (indent < min) {
        return min + Number((indent - min) / 3);
      }

      return indent;
    }
    /**
     * Считает отступ слоя галереи
     *
     * @param {Number} targetIndex ID целевого слайда
     * @returns {Number} Значения отступа
     */

  }, {
    key: "calculateIndent",
    value: function calculateIndent(targetIndex) {
      var slides = this.state.slides;

      if (!this.isDraggable()) {
        return 0;
      }

      var coordX = slides.length ? slides[targetIndex].coordX : 0;
      return this.validateIndent(-1 * coordX);
    }
  }, {
    key: "validateIndent",
    value: function validateIndent(value) {
      var _this$state3 = this.state,
          min = _this$state3.min,
          max = _this$state3.max;

      if (value < min) {
        return min;
      } else if (value > max) {
        return max;
      }

      return value;
    }
  }, {
    key: "isDraggable",
    value: function isDraggable() {
      return this.state.layerWidth > this.state.containerWidth;
    }
    /**
     * Получает индекс слайда, к которому будет осуществлен переход
     *
     * @returns {Number} Индекс слайда
     */

  }, {
    key: "getTarget",
    value: function getTarget() {
      var _this$state4 = this.state,
          slides = _this$state4.slides,
          current = _this$state4.current,
          deltaX = _this$state4.deltaX,
          shiftX = _this$state4.shiftX,
          startT = _this$state4.startT;
      var expectDeltaX = deltaX / (new Date() - startT) * 240 * 0.6;
      var shift = shiftX + deltaX + expectDeltaX;
      var direction = deltaX < 0 ? 1 : -1; // Находим ближайшую границу слайда к текущему отступу

      var targetIndex = slides.reduce(function (val, item, index) {
        var previousValue = Math.abs(slides[val].coordX + shift);
        var currentValue = Math.abs(item.coordX + shift);
        return previousValue < currentValue ? val : index;
      }, current);

      if (targetIndex === current) {
        var targetSlide = current + direction;

        if (targetSlide >= 0 && targetSlide < slides.length) {
          if (Math.abs(deltaX) > slides[targetSlide].width * 0.05) {
            targetIndex = targetSlide;
          }
        }
      }

      return targetIndex;
    }
  }, {
    key: "getChildren",
    value: function getChildren(children) {
      return [].concat(children || this.props.children).reduce(this.reduceChildren, []);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.initializeSlides(function () {
        _this3.setState({
          shiftX: _this3.calculateIndent(_this3.state.current)
        });
      });
      window.addEventListener('resize', this.onResize);

      if (this.props.autoplay) {
        this.setTimeout(this.props.autoplay);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.isChildrenDirty) {
        this.isChildrenDirty = false;
        this.initializeSlides();
      }

      if (prevState.current !== this.state.current && this.props.onChange) {
        this.props.onChange(this.state.current);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.slides = this.getChildren(nextProps.children);
      this.isChildrenDirty = true;

      if (nextProps.autoplay && !this.props.autoplay) {
        if (nextProps.autoplay) {
          this.setTimeout(nextProps.autoplay);
        }
      }

      if (!nextProps.autoplay && this.props.autoplay) {
        this.clearTimeout();
      }

      if (nextProps.slideIndex !== this.props.slideIndex && typeof nextProps.slideIndex === 'number') {
        this.go(nextProps.slideIndex);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
      this.clearTimeout();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state5 = this.state,
          animation = _this$state5.animation,
          duration = _this$state5.duration,
          current = _this$state5.current,
          dragging = _this$state5.dragging;

      var _this$props = this.props,
          children = _this$props.children,
          slideWidth = _this$props.slideWidth,
          autoplay = _this$props.autoplay,
          initialSlideIndex = _this$props.initialSlideIndex,
          slideIndex = _this$props.slideIndex,
          onDragStart = _this$props.onDragStart,
          onDragEnd = _this$props.onDragEnd,
          onChange = _this$props.onChange,
          onEnd = _this$props.onEnd,
          align = _this$props.align,
          bullets = _this$props.bullets,
          className = _this$props.className,
          restProps = Gallery_objectWithoutProperties(_this$props, ["children", "slideWidth", "autoplay", "initialSlideIndex", "slideIndex", "onDragStart", "onDragEnd", "onChange", "onEnd", "align", "bullets", "className"]);

      var indent = dragging ? this.calculateDragIndent() : this.calculateIndent(current);
      var layerStyle = {
        WebkitTransform: "translateX(".concat(indent, "px)"),
        transform: "translateX(".concat(indent, "px)"),
        WebkitTransition: animation ? "-webkit-transform ".concat(duration, "s cubic-bezier(.1, 0, .25, 1)") : 'none',
        transition: animation ? "transform ".concat(duration, "s cubic-bezier(.1, 0, .25, 1)") : 'none'
      };
      return external_react_default.a.createElement("div", Gallery_extends({}, restProps, {
        className: classNames(Gallery_baseClassNames, className, Gallery_defineProperty({
          'Gallery--dragging': dragging
        }, "Gallery--".concat(this.props.align), true)),
        ref: this.getContainerRef
      }), external_react_default.a.createElement(Touch_Touch, {
        className: "Gallery__viewport",
        onStartX: this.onStart,
        onMoveX: this.onMoveX,
        onEnd: this.onEnd,
        style: {
          width: slideWidth
        },
        ref: this.getViewportRef
      }, external_react_default.a.createElement("div", {
        className: "Gallery__layer",
        style: layerStyle
      }, this.slides)), this.props.bullets && external_react_default.a.createElement("div", {
        className: classNames('Gallery__bullets', Gallery_defineProperty({}, "Gallery__bullets--".concat(this.props.bullets), true))
      }, this.slides.map(function (item, index) {
        return external_react_default.a.createElement("div", {
          className: classNames('Gallery__bullet', {
            'Gallery__bullet--active': index === current
          }),
          key: index
        });
      })));
    }
  }]);

  return Gallery;
}(external_react_["Component"]);

Gallery_defineProperty(Gallery_Gallery, "propTypes", {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,
  slideWidth: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number]),
  autoplay: external_prop_types_default.a.number,
  initialSlideIndex: external_prop_types_default.a.number,
  slideIndex: external_prop_types_default.a.number,
  onDragStart: external_prop_types_default.a.func,
  onDragEnd: external_prop_types_default.a.func,
  onChange: external_prop_types_default.a.func,
  onEnd: external_prop_types_default.a.func,
  align: external_prop_types_default.a.oneOf(['left', 'center', 'right']),
  bullets: external_prop_types_default.a.oneOf(['dark', 'light', false])
});

Gallery_defineProperty(Gallery_Gallery, "defaultProps", {
  slideWidth: '100%',
  children: '',
  autoplay: 0,
  initialSlideIndex: 0,
  align: 'left',
  bullets: false
});


// CONCATENATED MODULE: ./src/components/Progress/Progress.js
function Progress_extends() { Progress_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Progress_extends.apply(this, arguments); }

function Progress_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Progress_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Progress_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Progress_baseClassName = getClassname('Progress');

var Progress_Progress = function Progress(_ref) {
  var value = _ref.value,
      className = _ref.className,
      getRootRef = _ref.getRootRef,
      restProps = Progress_objectWithoutProperties(_ref, ["value", "className", "getRootRef"]);

  return external_react_default.a.createElement("div", Progress_extends({}, restProps, {
    ref: getRootRef,
    className: classNames(Progress_baseClassName, className)
  }), external_react_default.a.createElement("div", {
    className: "Progress__bg"
  }), external_react_default.a.createElement("div", {
    className: "Progress__in",
    style: {
      width: "".concat(value, "%")
    }
  }));
};

Progress_Progress.propTypes = {
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  value: external_prop_types_default.a.number,
  getRootRef: external_prop_types_default.a.func
};
Progress_Progress.defaultProps = {
  value: 0
};
/* harmony default export */ var components_Progress_Progress = (Progress_Progress);
// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/16/search.js
var search = __webpack_require__(13);
var search_default = /*#__PURE__*/__webpack_require__.n(search);

// CONCATENATED MODULE: ./src/components/SearchIOS/SearchIOS.js
function SearchIOS_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SearchIOS_typeof = function _typeof(obj) { return typeof obj; }; } else { SearchIOS_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SearchIOS_typeof(obj); }

function SearchIOS_extends() { SearchIOS_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SearchIOS_extends.apply(this, arguments); }

function SearchIOS_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = SearchIOS_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function SearchIOS_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SearchIOS_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchIOS_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SearchIOS_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchIOS_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchIOS_defineProperties(Constructor, staticProps); return Constructor; }

function SearchIOS_possibleConstructorReturn(self, call) { if (call && (SearchIOS_typeof(call) === "object" || typeof call === "function")) { return call; } return SearchIOS_assertThisInitialized(self); }

function SearchIOS_getPrototypeOf(o) { SearchIOS_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SearchIOS_getPrototypeOf(o); }

function SearchIOS_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) SearchIOS_setPrototypeOf(subClass, superClass); }

function SearchIOS_setPrototypeOf(o, p) { SearchIOS_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SearchIOS_setPrototypeOf(o, p); }

function SearchIOS_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SearchIOS_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var SearchIOS_baseClassName = getClassname('Search');
var searchId = 0;

var SearchIOS_SearchIOS =
/*#__PURE__*/
function (_React$Component) {
  SearchIOS_inherits(SearchIOS, _React$Component);

  function SearchIOS(props) {
    var _this;

    SearchIOS_classCallCheck(this, SearchIOS);

    _this = SearchIOS_possibleConstructorReturn(this, SearchIOS_getPrototypeOf(SearchIOS).call(this, props));

    SearchIOS_defineProperty(SearchIOS_assertThisInitialized(SearchIOS_assertThisInitialized(_this)), "onFocus", function (e) {
      _this.setState({
        focused: true
      });

      _this.props.onFocus && _this.props.onFocus(e);
    });

    SearchIOS_defineProperty(SearchIOS_assertThisInitialized(SearchIOS_assertThisInitialized(_this)), "onBlur", function (e) {
      _this.setState({
        focused: false
      });

      _this.props.onBlur && _this.props.onBlur(e);
    });

    SearchIOS_defineProperty(SearchIOS_assertThisInitialized(SearchIOS_assertThisInitialized(_this)), "onChange", function (e) {
      if (!_this.isControlledOutside) {
        _this.setState({
          value: e.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e.target.value, e);
      }
    });

    SearchIOS_defineProperty(SearchIOS_assertThisInitialized(SearchIOS_assertThisInitialized(_this)), "onCancel", function () {
      if (!_this.isControlledOutside) {
        _this.setState({
          value: ''
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange('');
      }
    });

    SearchIOS_defineProperty(SearchIOS_assertThisInitialized(SearchIOS_assertThisInitialized(_this)), "inputRef", function (el) {
      return _this.props.getRef && _this.props.getRef(el);
    });

    var state = {
      showAfter: false,
      focused: false,
      placeholderOffset: null,
      afterWidth: null
    };

    if (props.hasOwnProperty('value')) {
      _this.isControlledOutside = true;
    } else {
      state.value = props.defaultValue || '';
    }

    searchId++;
    _this.state = state;
    return _this;
  }

  SearchIOS_createClass(SearchIOS, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          className = _this$props.className,
          theme = _this$props.theme,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          defaultValue = _this$props.defaultValue,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          after = _this$props.after,
          getRef = _this$props.getRef,
          inputProps = SearchIOS_objectWithoutProperties(_this$props, ["className", "theme", "onFocus", "onBlur", "onChange", "defaultValue", "value", "placeholder", "after", "getRef"]);

      return external_react_default.a.createElement("div", {
        className: classNames(SearchIOS_baseClassName, (_classnames = {}, SearchIOS_defineProperty(_classnames, "Search--".concat(theme), true), SearchIOS_defineProperty(_classnames, 'Search--focused', this.state.focused), SearchIOS_defineProperty(_classnames, 'Search--has-value', this.value), SearchIOS_defineProperty(_classnames, 'Search--has-after', after), _classnames), className)
      }, external_react_default.a.createElement("div", {
        className: "Search__in"
      }, external_react_default.a.createElement("div", {
        className: "Search__width"
      }), external_react_default.a.createElement("div", {
        className: "Search__control"
      }, external_react_default.a.createElement("input", SearchIOS_extends({}, inputProps, {
        id: "search-".concat(searchId),
        ref: this.inputRef,
        type: "text",
        className: "Search__input",
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.onChange,
        value: this.value
      })), after && external_react_default.a.createElement("div", {
        className: "Search__after-width"
      }, after), external_react_default.a.createElement("label", {
        className: "Search__placeholder",
        htmlFor: "search-".concat(searchId)
      }, external_react_default.a.createElement("div", {
        className: "Search__placeholder-in"
      }, external_react_default.a.createElement(search_default.a, null), external_react_default.a.createElement("div", {
        className: "Search__placeholder-text",
        dangerouslySetInnerHTML: {
          __html: placeholder
        }
      })))), after && external_react_default.a.createElement("div", {
        className: "Search__after",
        onClick: this.onCancel
      }, external_react_default.a.createElement("div", {
        className: "Search__after-in"
      }, after))));
    }
  }, {
    key: "value",
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return SearchIOS;
}(external_react_default.a.Component);

SearchIOS_defineProperty(SearchIOS_SearchIOS, "propTypes", {
  className: external_prop_types_default.a.string,
  after: external_prop_types_default.a.node,
  defaultValue: external_prop_types_default.a.string,
  value: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func,
  onFocus: external_prop_types_default.a.func,
  onBlur: external_prop_types_default.a.func,
  placeholder: external_prop_types_default.a.node,
  theme: external_prop_types_default.a.oneOf(['header', 'default']),
  getRef: external_prop_types_default.a.func
});

SearchIOS_defineProperty(SearchIOS_SearchIOS, "defaultProps", {
  after: 'Отменить',
  theme: 'default',
  placeholder: 'Поиск'
});


// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/back.js
var back = __webpack_require__(12);
var back_default = /*#__PURE__*/__webpack_require__.n(back);

// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/search.js
var _24_search = __webpack_require__(11);
var _24_search_default = /*#__PURE__*/__webpack_require__.n(_24_search);

// CONCATENATED MODULE: ./src/components/SearchAndroid/SearchAndroid.js
function SearchAndroid_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SearchAndroid_typeof = function _typeof(obj) { return typeof obj; }; } else { SearchAndroid_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SearchAndroid_typeof(obj); }

function SearchAndroid_extends() { SearchAndroid_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SearchAndroid_extends.apply(this, arguments); }

function SearchAndroid_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = SearchAndroid_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function SearchAndroid_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SearchAndroid_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchAndroid_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SearchAndroid_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchAndroid_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchAndroid_defineProperties(Constructor, staticProps); return Constructor; }

function SearchAndroid_possibleConstructorReturn(self, call) { if (call && (SearchAndroid_typeof(call) === "object" || typeof call === "function")) { return call; } return SearchAndroid_assertThisInitialized(self); }

function SearchAndroid_getPrototypeOf(o) { SearchAndroid_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SearchAndroid_getPrototypeOf(o); }

function SearchAndroid_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) SearchAndroid_setPrototypeOf(subClass, superClass); }

function SearchAndroid_setPrototypeOf(o, p) { SearchAndroid_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SearchAndroid_setPrototypeOf(o, p); }

function SearchAndroid_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SearchAndroid_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var SearchAndroid_baseClassName = getClassname('Search');

var SearchAndroid_SearchAndroid =
/*#__PURE__*/
function (_React$Component) {
  SearchAndroid_inherits(SearchAndroid, _React$Component);

  function SearchAndroid(props) {
    var _this;

    SearchAndroid_classCallCheck(this, SearchAndroid);

    _this = SearchAndroid_possibleConstructorReturn(this, SearchAndroid_getPrototypeOf(SearchAndroid).call(this, props));

    SearchAndroid_defineProperty(SearchAndroid_assertThisInitialized(SearchAndroid_assertThisInitialized(_this)), "onCancel", function () {
      if (!_this.isControlledOutside) {
        _this.setState({
          value: ''
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange('');
      }

      _this.inputEl.focus();
    });

    SearchAndroid_defineProperty(SearchAndroid_assertThisInitialized(SearchAndroid_assertThisInitialized(_this)), "onChange", function (e) {
      if (!_this.isControlledOutside) {
        _this.setState({
          value: e.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e.target.value, e);
      }
    });

    SearchAndroid_defineProperty(SearchAndroid_assertThisInitialized(SearchAndroid_assertThisInitialized(_this)), "inputRef", function (el) {
      _this.inputEl = el;
      _this.props.getRef && _this.props.getRef(el);
    });

    var state = {};

    if (props.hasOwnProperty('value')) {
      _this.isControlledOutside = true;
    } else {
      state.value = props.defaultValue || '';
    }

    _this.state = state;
    return _this;
  }

  SearchAndroid_createClass(SearchAndroid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.theme === 'header' && this.inputEl.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          getRef = _this$props.getRef,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          onClose = _this$props.onClose,
          theme = _this$props.theme,
          inputProps = SearchAndroid_objectWithoutProperties(_this$props, ["getRef", "value", "defaultValue", "onChange", "onClose", "theme"]);

      var className = classNames(SearchAndroid_baseClassName, (_classnames = {}, SearchAndroid_defineProperty(_classnames, "Search--".concat(theme), true), SearchAndroid_defineProperty(_classnames, 'Search--focused', this.state.focused), SearchAndroid_defineProperty(_classnames, 'Search--has-value', !!this.value), _classnames), this.props.className);
      return external_react_default.a.createElement("div", {
        className: className
      }, external_react_default.a.createElement("div", {
        className: "Search__container"
      }, external_react_default.a.createElement("div", {
        className: "Search__before"
      }, theme === 'default' && external_react_default.a.createElement(_24_search_default.a, null), theme === 'header' && external_react_default.a.createElement(components_HeaderButton_HeaderButton, {
        onClick: onClose
      }, external_react_default.a.createElement(back_default.a, null))), external_react_default.a.createElement("div", {
        className: "Search__control"
      }, external_react_default.a.createElement("input", SearchAndroid_extends({}, inputProps, {
        className: "Search__input",
        ref: this.inputRef,
        value: this.value,
        onChange: this.onChange
      }))), !!this.value && external_react_default.a.createElement("div", {
        className: "Search__after"
      }, theme === 'default' && external_react_default.a.createElement(cancel_default.a, {
        onClick: this.onCancel
      }), theme === 'header' && external_react_default.a.createElement(components_HeaderButton_HeaderButton, {
        onClick: this.onCancel
      }, external_react_default.a.createElement(cancel_default.a, null)))));
    }
  }, {
    key: "value",
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return SearchAndroid;
}(external_react_default.a.Component);

SearchAndroid_defineProperty(SearchAndroid_SearchAndroid, "propTypes", {
  className: external_prop_types_default.a.string,
  defaultValue: external_prop_types_default.a.string,
  value: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func,
  onFocus: external_prop_types_default.a.func,
  onBlur: external_prop_types_default.a.func,
  onClose: external_prop_types_default.a.func,
  placeholder: external_prop_types_default.a.node,
  theme: external_prop_types_default.a.oneOf(['header', 'default']),
  getRef: external_prop_types_default.a.func
});

SearchAndroid_defineProperty(SearchAndroid_SearchAndroid, "defaultProps", {
  placeholder: 'Поиск',
  theme: 'default'
});


// CONCATENATED MODULE: ./src/components/Search/Search.js
function Search_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Search_typeof = function _typeof(obj) { return typeof obj; }; } else { Search_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Search_typeof(obj); }

function Search_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Search_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Search_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Search_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Search_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Search_createClass(Constructor, protoProps, staticProps) { if (protoProps) Search_defineProperties(Constructor.prototype, protoProps); if (staticProps) Search_defineProperties(Constructor, staticProps); return Constructor; }

function Search_possibleConstructorReturn(self, call) { if (call && (Search_typeof(call) === "object" || typeof call === "function")) { return call; } return Search_assertThisInitialized(self); }

function Search_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Search_getPrototypeOf(o) { Search_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Search_getPrototypeOf(o); }

function Search_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Search_setPrototypeOf(subClass, superClass); }

function Search_setPrototypeOf(o, p) { Search_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Search_setPrototypeOf(o, p); }

function Search_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Search_osname = platform();

var Search_Search =
/*#__PURE__*/
function (_React$Component) {
  Search_inherits(Search, _React$Component);

  function Search() {
    Search_classCallCheck(this, Search);

    return Search_possibleConstructorReturn(this, Search_getPrototypeOf(Search).apply(this, arguments));
  }

  Search_createClass(Search, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          iosProps = Search_objectWithoutProperties(_this$props, ["onClose"]);

      var _this$props2 = this.props,
          after = _this$props2.after,
          before = _this$props2.before,
          androidProps = Search_objectWithoutProperties(_this$props2, ["after", "before"]);

      if (Search_osname === IOS) {
        return external_react_default.a.createElement(SearchIOS_SearchIOS, iosProps);
      } else {
        return external_react_default.a.createElement(SearchAndroid_SearchAndroid, androidProps);
      }
    }
  }]);

  return Search;
}(external_react_default.a.Component);

Search_defineProperty(Search_Search, "propTypes", {
  className: external_prop_types_default.a.string,
  getRef: external_prop_types_default.a.func,

  /**
   * iOS only. Текст кнопки "отмена", которая чистит текстовое поле и убирает фокус.
   */
  after: external_prop_types_default.a.node,

  /**
   * iOS only
   */
  before: external_prop_types_default.a.node,
  theme: external_prop_types_default.a.oneOf(['header', 'default']),

  /**
   * Android only. Вызывается при клике по стрелке (слева). Этот контрол служит для выхода из режима поиска.
   */
  onClose: external_prop_types_default.a.func,

  /**
   * **Важно:** в коллбэк первым аргументом прилетает *значение* текстового поля.
   * Объект события передается вторым аргументом.
   */
  onChange: external_prop_types_default.a.func,
  autoComplete: external_prop_types_default.a.string
});

Search_defineProperty(Search_Search, "defaultProps", {
  theme: 'default',
  autoComplete: 'off'
});


// CONCATENATED MODULE: ./src/components/Tabs/Tabs.js
function Tabs_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Tabs_typeof = function _typeof(obj) { return typeof obj; }; } else { Tabs_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Tabs_typeof(obj); }

function Tabs_extends() { Tabs_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Tabs_extends.apply(this, arguments); }

function Tabs_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Tabs_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Tabs_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Tabs_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tabs_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Tabs_createClass(Constructor, protoProps, staticProps) { if (protoProps) Tabs_defineProperties(Constructor.prototype, protoProps); if (staticProps) Tabs_defineProperties(Constructor, staticProps); return Constructor; }

function Tabs_possibleConstructorReturn(self, call) { if (call && (Tabs_typeof(call) === "object" || typeof call === "function")) { return call; } return Tabs_assertThisInitialized(self); }

function Tabs_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Tabs_getPrototypeOf(o) { Tabs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Tabs_getPrototypeOf(o); }

function Tabs_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Tabs_setPrototypeOf(subClass, superClass); }

function Tabs_setPrototypeOf(o, p) { Tabs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Tabs_setPrototypeOf(o, p); }

function Tabs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Tabs_baseClassName = getClassname('Tabs');

var Tabs_Tabs =
/*#__PURE__*/
function (_React$Component) {
  Tabs_inherits(Tabs, _React$Component);

  function Tabs() {
    Tabs_classCallCheck(this, Tabs);

    return Tabs_possibleConstructorReturn(this, Tabs_getPrototypeOf(Tabs).apply(this, arguments));
  }

  Tabs_createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          theme = _this$props.theme,
          style = _this$props.style,
          type = _this$props.type,
          getRootRef = _this$props.getRootRef,
          restProps = Tabs_objectWithoutProperties(_this$props, ["className", "children", "theme", "style", "type", "getRootRef"]);

      return external_react_default.a.createElement("div", Tabs_extends({}, restProps, {
        ref: getRootRef,
        className: classNames(Tabs_baseClassName, (_classnames = {}, Tabs_defineProperty(_classnames, "Tabs--".concat(this.theme), true), Tabs_defineProperty(_classnames, "Tabs--".concat(type), true), _classnames), className),
        style: style
      }), children);
    }
  }, {
    key: "theme",

    /**
     * Метод нужен для маппинга устаревших значений theme на новые
     * @returns {string}
     */
    get: function get() {
      switch (this.props.theme) {
        case 'white':
          return 'header';

        case 'gray':
          return 'light';

        default:
          return this.props.theme;
      }
    }
  }]);

  return Tabs;
}(external_react_default.a.Component);

Tabs_defineProperty(Tabs_Tabs, "propTypes", {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,

  /**
   * Значения white и gray устарели. Они будут удалены в следующей мажорной версии
   */
  theme: external_prop_types_default.a.oneOf(['light', 'header']),

  /**
   * Свойство отвечает за растягивание табов
   */
  type: external_prop_types_default.a.oneOf(['default', 'buttons']),
  style: external_prop_types_default.a.object,
  getRootRef: external_prop_types_default.a.func
});

Tabs_defineProperty(Tabs_Tabs, "defaultProps", {
  theme: 'light',
  type: 'default'
});


// CONCATENATED MODULE: ./src/components/TabsItem/TabsItem.js
function TabsItem_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { TabsItem_typeof = function _typeof(obj) { return typeof obj; }; } else { TabsItem_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return TabsItem_typeof(obj); }

function TabsItem_extends() { TabsItem_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return TabsItem_extends.apply(this, arguments); }

function TabsItem_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = TabsItem_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function TabsItem_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TabsItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TabsItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TabsItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) TabsItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) TabsItem_defineProperties(Constructor, staticProps); return Constructor; }

function TabsItem_possibleConstructorReturn(self, call) { if (call && (TabsItem_typeof(call) === "object" || typeof call === "function")) { return call; } return TabsItem_assertThisInitialized(self); }

function TabsItem_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function TabsItem_getPrototypeOf(o) { TabsItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return TabsItem_getPrototypeOf(o); }

function TabsItem_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) TabsItem_setPrototypeOf(subClass, superClass); }

function TabsItem_setPrototypeOf(o, p) { TabsItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return TabsItem_setPrototypeOf(o, p); }

function TabsItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var TabsItem_osname = platform();
var TabsItem_baseClassName = getClassname('TabsItem');

var TabsItem_TabsItem =
/*#__PURE__*/
function (_React$Component) {
  TabsItem_inherits(TabsItem, _React$Component);

  function TabsItem() {
    TabsItem_classCallCheck(this, TabsItem);

    return TabsItem_possibleConstructorReturn(this, TabsItem_getPrototypeOf(TabsItem).apply(this, arguments));
  }

  TabsItem_createClass(TabsItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          selected = _this$props.selected,
          className = _this$props.className,
          restProps = TabsItem_objectWithoutProperties(_this$props, ["children", "selected", "className"]);

      return external_react_default.a.createElement(Tappable_Tappable, TabsItem_extends({}, restProps, {
        className: classNames(TabsItem_baseClassName, {
          'TabsItem--selected': selected
        }, className),
        activeEffectDelay: TabsItem_osname === IOS ? 0 : ACTIVE_EFFECT_DELAY
      }), external_react_default.a.createElement("span", {
        className: "TabsItem__in"
      }, children));
    }
  }]);

  return TabsItem;
}(external_react_default.a.Component);

TabsItem_defineProperty(TabsItem_TabsItem, "propTypes", {
  children: external_prop_types_default.a.node,
  selected: external_prop_types_default.a.bool,
  className: external_prop_types_default.a.string
});

TabsItem_defineProperty(TabsItem_TabsItem, "defaultProps", {
  selected: false
});


// CONCATENATED MODULE: ./src/components/FixedTabs/FixedTabs.js
function FixedTabs_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FixedTabs_typeof = function _typeof(obj) { return typeof obj; }; } else { FixedTabs_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FixedTabs_typeof(obj); }

function FixedTabs_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FixedTabs_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FixedTabs_createClass(Constructor, protoProps, staticProps) { if (protoProps) FixedTabs_defineProperties(Constructor.prototype, protoProps); if (staticProps) FixedTabs_defineProperties(Constructor, staticProps); return Constructor; }

function FixedTabs_possibleConstructorReturn(self, call) { if (call && (FixedTabs_typeof(call) === "object" || typeof call === "function")) { return call; } return FixedTabs_assertThisInitialized(self); }

function FixedTabs_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FixedTabs_getPrototypeOf(o) { FixedTabs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FixedTabs_getPrototypeOf(o); }

function FixedTabs_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FixedTabs_setPrototypeOf(subClass, superClass); }

function FixedTabs_setPrototypeOf(o, p) { FixedTabs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FixedTabs_setPrototypeOf(o, p); }

function FixedTabs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var FixedTabs_osname = platform();
/**
 * @deprecated Для отрисовки фиксированных табов используйте связку `Tabs` и `FixedLayout`.
 * Этот компонент устарел и будет удален в 3.0.0.
 */

var FixedTabs_FixedTabs =
/*#__PURE__*/
function (_React$Component) {
  FixedTabs_inherits(FixedTabs, _React$Component);

  function FixedTabs() {
    FixedTabs_classCallCheck(this, FixedTabs);

    return FixedTabs_possibleConstructorReturn(this, FixedTabs_getPrototypeOf(FixedTabs).apply(this, arguments));
  }

  FixedTabs_createClass(FixedTabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          vertical = _this$props.vertical,
          className = _this$props.className,
          style = _this$props.style,
          theme = _this$props.theme,
          children = _this$props.children;
      return external_react_default.a.createElement(FixedLayout_FixedLayout, {
        vertical: vertical,
        className: className,
        style: style
      }, external_react_default.a.createElement(Tabs_Tabs, {
        theme: theme
      }, children));
    }
  }]);

  return FixedTabs;
}(external_react_default.a.Component);

FixedTabs_defineProperty(FixedTabs_FixedTabs, "propTypes", {
  children: external_prop_types_default.a.node.isRequired,
  className: external_prop_types_default.a.string,
  vertical: external_prop_types_default.a.oneOf(['top', 'bottom']),
  style: external_prop_types_default.a.object,

  /**
   * Значения white и gray устарели. Они будут удалены в следующей мажорной версии.
   * Для Android актуален только header
   */
  theme: external_prop_types_default.a.oneOf(['light', 'header']),

  /**
   * iOS only
   */
  type: external_prop_types_default.a.oneOf(['default', 'buttons'])
});

FixedTabs_defineProperty(FixedTabs_FixedTabs, "defaultProps", {
  theme: FixedTabs_osname === IOS ? 'light' : 'header',
  vertical: 'top'
});


// CONCATENATED MODULE: ./src/components/Link/Link.js
function Link_extends() { Link_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Link_extends.apply(this, arguments); }

function Link_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Link_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Link_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Link_baseClassName = getClassname('Link');

var Link_Link = function Link(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Component = _ref.Component,
      getRootRef = _ref.getRootRef,
      restProps = Link_objectWithoutProperties(_ref, ["children", "className", "Component", "getRootRef"]);

  return external_react_default.a.createElement(Component, Link_extends({}, restProps, {
    ref: getRootRef,
    className: classNames(Link_baseClassName, className)
  }), children);
};

Link_Link.propTypes = {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  Component: external_prop_types_default.a.any,
  getRootRef: external_prop_types_default.a.func
};
Link_Link.defaultProps = {
  Component: 'a'
};
/* harmony default export */ var components_Link_Link = (Link_Link);
// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.js
function Tooltip_extends() { Tooltip_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Tooltip_extends.apply(this, arguments); }

function Tooltip_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Tooltip_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Tooltip_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Tooltip_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Tooltip_typeof = function _typeof(obj) { return typeof obj; }; } else { Tooltip_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Tooltip_typeof(obj); }

function Tooltip_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tooltip_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Tooltip_createClass(Constructor, protoProps, staticProps) { if (protoProps) Tooltip_defineProperties(Constructor.prototype, protoProps); if (staticProps) Tooltip_defineProperties(Constructor, staticProps); return Constructor; }

function Tooltip_possibleConstructorReturn(self, call) { if (call && (Tooltip_typeof(call) === "object" || typeof call === "function")) { return call; } return Tooltip_assertThisInitialized(self); }

function Tooltip_getPrototypeOf(o) { Tooltip_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Tooltip_getPrototypeOf(o); }

function Tooltip_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Tooltip_setPrototypeOf(subClass, superClass); }

function Tooltip_setPrototypeOf(o, p) { Tooltip_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Tooltip_setPrototypeOf(o, p); }

function Tooltip_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Tooltip_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Tooltip_isElement = function isElement(element) {
  return external_react_default.a.isValidElement(element);
};

var isDOMTypeElement = function isDOMTypeElement(element) {
  return Tooltip_isElement(element) && typeof element.type === 'string';
};

var Tooltip_baseClassName = getClassname('Tooltip');

var Tooltip_TooltipPortal =
/*#__PURE__*/
function (_React$Component) {
  Tooltip_inherits(TooltipPortal, _React$Component);

  function TooltipPortal() {
    var _getPrototypeOf2;

    var _this;

    Tooltip_classCallCheck(this, TooltipPortal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Tooltip_possibleConstructorReturn(this, (_getPrototypeOf2 = Tooltip_getPrototypeOf(TooltipPortal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Tooltip_defineProperty(Tooltip_assertThisInitialized(Tooltip_assertThisInitialized(_this)), "state", {
      x: 0,
      y: 0
    });

    Tooltip_defineProperty(Tooltip_assertThisInitialized(Tooltip_assertThisInitialized(_this)), "fixedPortal", false);

    Tooltip_defineProperty(Tooltip_assertThisInitialized(Tooltip_assertThisInitialized(_this)), "getRef", function (el) {
      return _this.el = el;
    });

    return _this;
  }

  Tooltip_createClass(TooltipPortal, [{
    key: "findPortalTarget",
    value: function findPortalTarget() {
      var target = this.props.target;
      var closestFixed = target.closest('.FixedLayout');
      var closestHeader = target.closest('.PanelHeader__in');
      var closestPanel = this.document.getElementById(this.context.panel).childNodes[0];

      if (closestFixed || closestHeader) {
        this.fixedPortal = true;
      }

      return closestFixed || closestHeader || closestPanel;
    }
  }, {
    key: "getBoundingTargetRect",
    value: function getBoundingTargetRect() {
      var target = this.props.target;
      var targetBounds = target.getBoundingClientRect();
      var portalBounds = this.portalTarget.getBoundingClientRect();
      return {
        width: targetBounds.width,
        height: targetBounds.height,
        x: targetBounds.x - portalBounds.x,
        y: targetBounds.y - portalBounds.y
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.portalTarget = this.findPortalTarget();
      this.document.addEventListener('click', this.props.onClose);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.document.removeEventListener('click', this.props.onClose);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          offsetY = _this$props.offsetY,
          offsetX = _this$props.offsetX,
          alignX = _this$props.alignX,
          alignY = _this$props.alignY;
      var coords = this.getBoundingTargetRect();
      this.setState({
        x: coords.x + offsetX + (alignX === 'right' ? coords.width - this.el.offsetWidth : 0),
        y: coords.y + (alignY === 'top' ? -this.el.offsetHeight - offsetY : coords.height + offsetY)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props2 = this.props,
          title = _this$props2.title,
          text = _this$props2.text,
          alignX = _this$props2.alignX,
          alignY = _this$props2.alignY,
          cornerOffset = _this$props2.cornerOffset;
      return external_react_dom_default.a.createPortal(external_react_default.a.createElement("div", {
        className: classNames(Tooltip_baseClassName, (_classnames = {}, Tooltip_defineProperty(_classnames, "Tooltip--x-".concat(alignX), true), Tooltip_defineProperty(_classnames, "Tooltip--y-".concat(alignY), true), Tooltip_defineProperty(_classnames, 'Tooltip--fixed', this.fixedPortal), _classnames))
      }, external_react_default.a.createElement("div", {
        className: "Tooltip__container",
        style: {
          top: this.state.y,
          left: this.state.x
        },
        ref: this.getRef
      }, external_react_default.a.createElement("div", {
        className: "Tooltip__corner",
        style: Tooltip_defineProperty({}, alignX, 20 + cornerOffset)
      }), external_react_default.a.createElement("div", {
        className: "Tooltip__content"
      }, title && external_react_default.a.createElement("div", {
        className: "Tooltip__title"
      }, title), text && external_react_default.a.createElement("div", {
        className: "Tooltip__text"
      }, text)))), this.portalTarget);
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || document;
    }
  }]);

  return TooltipPortal;
}(external_react_default.a.Component);

Tooltip_defineProperty(Tooltip_TooltipPortal, "propTypes", {
  target: external_prop_types_default.a.object,
  text: external_prop_types_default.a.node,
  title: external_prop_types_default.a.node,
  alignX: external_prop_types_default.a.oneOf(['left', 'right']),
  alignY: external_prop_types_default.a.oneOf(['top', 'bottom']),
  offsetX: external_prop_types_default.a.number,
  offsetY: external_prop_types_default.a.number,
  cornerOffset: external_prop_types_default.a.number,
  onClose: external_prop_types_default.a.func.isRequired
});

Tooltip_defineProperty(Tooltip_TooltipPortal, "contextTypes", {
  document: external_prop_types_default.a.any,
  panel: external_prop_types_default.a.string
});

var Tooltip_Tooltip =
/*#__PURE__*/
function (_React$Component2) {
  Tooltip_inherits(Tooltip, _React$Component2);

  function Tooltip() {
    var _getPrototypeOf3;

    var _this2;

    Tooltip_classCallCheck(this, Tooltip);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = Tooltip_possibleConstructorReturn(this, (_getPrototypeOf3 = Tooltip_getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf3, [this].concat(args)));

    Tooltip_defineProperty(Tooltip_assertThisInitialized(Tooltip_assertThisInitialized(_this2)), "state", {
      ready: false
    });

    Tooltip_defineProperty(Tooltip_assertThisInitialized(Tooltip_assertThisInitialized(_this2)), "getRef", function (el) {
      return _this2.targetEl = el;
    });

    return _this2;
  }

  Tooltip_createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.targetEl && this.setState({
        ready: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _React$cloneElement;

      var _this$props3 = this.props,
          children = _this$props3.children,
          isShown = _this$props3.isShown,
          portalProps = Tooltip_objectWithoutProperties(_this$props3, ["children", "isShown"]);

      var child = external_react_default.a.cloneElement(children, (_React$cloneElement = {}, Tooltip_defineProperty(_React$cloneElement, isDOMTypeElement(children) ? 'ref' : 'getRootRef', this.getRef), Tooltip_defineProperty(_React$cloneElement, "key", 'c'), _React$cloneElement));

      if (!isShown || !this.state.ready) {
        return child;
      }

      return [child, external_react_default.a.createElement(Tooltip_TooltipPortal, Tooltip_extends({}, portalProps, {
        target: this.targetEl,
        key: "t"
      }))];
    }
  }]);

  return Tooltip;
}(external_react_default.a.Component);

Tooltip_defineProperty(Tooltip_Tooltip, "propTypes", {
  /**
   * **Важно**: если в `children` передан React-компонент, то необходимо убедиться в том, что он поддерживает
   * свойство `getRootRef`, которое должно возвращаться ссылку на корневой DOM-элемент компонента,
   * иначе тултип показан не будет. Если передан React-element, то такой проблемы нет.
   */
  children: external_prop_types_default.a.node.isRequired,

  /**
   * Если передан `false`, то рисуется просто `children`.
   */
  isShown: external_prop_types_default.a.bool.isRequired,

  /**
   * Текст тултипа.
   */
  text: external_prop_types_default.a.node,

  /**
   * Заголовок тултипа.
   */
  title: external_prop_types_default.a.node,

  /**
   * Положение по горизонтали (прижатие к левому или правому краю `children`).
   */
  alignX: external_prop_types_default.a.oneOf(['left', 'right']),

  /**
   * Положение по вертикали (расположение над или под `children`).
   */
  alignY: external_prop_types_default.a.oneOf(['top', 'bottom']),

  /**
   * Сдвиг по горизонтали (относительно портала, в котором рисуется тултип).
   */
  offsetX: external_prop_types_default.a.number,

  /**
   * Сдвиг по вертикали (относительно портала, в котором рисуется тултип).
   */
  offsetY: external_prop_types_default.a.number,

  /**
   * Сдвиг треугольника (относительно ширины тултипа).
   */
  cornerOffset: external_prop_types_default.a.number,

  /**
   * Callback, который вызывается при клике по любому месту в пределах экрана.
   */
  onClose: external_prop_types_default.a.func.isRequired
});

Tooltip_defineProperty(Tooltip_Tooltip, "defaultProps", {
  offsetX: 0,
  offsetY: 15,
  alignX: 'left',
  alignY: 'bottom',
  cornerOffset: 0,
  isShown: true
});


// CONCATENATED MODULE: ./src/components/FormLayout/FormLayout.js
function FormLayout_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { FormLayout_typeof = function _typeof(obj) { return typeof obj; }; } else { FormLayout_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return FormLayout_typeof(obj); }

function FormLayout_extends() { FormLayout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FormLayout_extends.apply(this, arguments); }

function FormLayout_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = FormLayout_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function FormLayout_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function FormLayout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FormLayout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FormLayout_createClass(Constructor, protoProps, staticProps) { if (protoProps) FormLayout_defineProperties(Constructor.prototype, protoProps); if (staticProps) FormLayout_defineProperties(Constructor, staticProps); return Constructor; }

function FormLayout_possibleConstructorReturn(self, call) { if (call && (FormLayout_typeof(call) === "object" || typeof call === "function")) { return call; } return FormLayout_assertThisInitialized(self); }

function FormLayout_getPrototypeOf(o) { FormLayout_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return FormLayout_getPrototypeOf(o); }

function FormLayout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) FormLayout_setPrototypeOf(subClass, superClass); }

function FormLayout_setPrototypeOf(o, p) { FormLayout_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return FormLayout_setPrototypeOf(o, p); }

function FormLayout_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function FormLayout_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var FormLayout_baseClassName = getClassname('FormLayout');

var FormLayout_FormLayout =
/*#__PURE__*/
function (_React$Component) {
  FormLayout_inherits(FormLayout, _React$Component);

  function FormLayout() {
    var _getPrototypeOf2;

    var _this;

    FormLayout_classCallCheck(this, FormLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = FormLayout_possibleConstructorReturn(this, (_getPrototypeOf2 = FormLayout_getPrototypeOf(FormLayout)).call.apply(_getPrototypeOf2, [this].concat(args)));

    FormLayout_defineProperty(FormLayout_assertThisInitialized(FormLayout_assertThisInitialized(_this)), "onSubmit", function (e) {
      return _this.props.onSubmit ? _this.props.onSubmit(e) : e.preventDefault();
    });

    return _this;
  }

  FormLayout_createClass(FormLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          TagName = _this$props.TagName,
          className = _this$props.className,
          getRef = _this$props.getRef,
          restProps = FormLayout_objectWithoutProperties(_this$props, ["children", "TagName", "className", "getRef"]);

      var arrayChildren = Array.isArray(children) ? children : [children];
      return external_react_default.a.createElement(TagName, FormLayout_extends({}, restProps, {
        className: classNames(FormLayout_baseClassName, className),
        onSubmit: this.onSubmit,
        ref: getRef
      }), external_react_default.a.createElement("div", {
        className: "FormLayout__container"
      }, arrayChildren.map(function (field, i) {
        return field ? external_react_default.a.createElement("div", {
          className: "FormLayout__row",
          key: field.key || "row-".concat(i)
        }, field.props.top && external_react_default.a.createElement("div", {
          className: "FormLayout__row-top"
        }, field.props.top), external_react_default.a.createElement("div", {
          className: "FormLayout__field"
        }, field), field.props.bottom && external_react_default.a.createElement("div", {
          className: "FormLayout__row-bottom"
        }, field.props.bottom)) : null;
      })), TagName === 'form' && external_react_default.a.createElement("input", {
        type: "submit",
        className: "FormLayout__submit",
        value: ""
      }));
    }
  }]);

  return FormLayout;
}(external_react_default.a.Component);

FormLayout_defineProperty(FormLayout_FormLayout, "propTypes", {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  TagName: external_prop_types_default.a.string,
  onSubmit: external_prop_types_default.a.func,
  getRef: external_prop_types_default.a.func
});

FormLayout_defineProperty(FormLayout_FormLayout, "defaultProps", {
  status: 'default',
  TagName: 'form'
});


// CONCATENATED MODULE: ./src/components/FormLayoutGroup/FormLayoutGroup.js
function FormLayoutGroup_extends() { FormLayoutGroup_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FormLayoutGroup_extends.apply(this, arguments); }

function FormLayoutGroup_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = FormLayoutGroup_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function FormLayoutGroup_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var FormLayoutGroup_baseClassNames = getClassname('FormLayoutGroup');

var FormLayoutGroup_FormLayoutGroup = function FormLayoutGroup(_ref) {
  var children = _ref.children,
      top = _ref.top,
      bottom = _ref.bottom,
      className = _ref.className,
      restProps = FormLayoutGroup_objectWithoutProperties(_ref, ["children", "top", "bottom", "className"]);

  return external_react_default.a.createElement("div", FormLayoutGroup_extends({
    className: classNames(FormLayoutGroup_baseClassNames, className)
  }, restProps), children);
};

FormLayoutGroup_FormLayoutGroup.propTypes = {
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,
  top: external_prop_types_default.a.node,
  bottom: external_prop_types_default.a.node
};
/* harmony default export */ var components_FormLayoutGroup_FormLayoutGroup = (FormLayoutGroup_FormLayoutGroup);
// CONCATENATED MODULE: ./src/components/FormStatus/FormStatus.js
function FormStatus_extends() { FormStatus_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FormStatus_extends.apply(this, arguments); }

function FormStatus_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function FormStatus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = FormStatus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function FormStatus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var FormStatus_baseClassName = getClassname('FormStatus');

var FormStatus_FormStatus = function FormStatus(_ref) {
  var state = _ref.state,
      title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
      restProps = FormStatus_objectWithoutProperties(_ref, ["state", "title", "children", "className", "dangerouslySetInnerHTML"]);

  return external_react_default.a.createElement("div", FormStatus_extends({}, restProps, {
    className: classNames(FormStatus_baseClassName, FormStatus_defineProperty({}, "FormStatus--".concat(state), state), className)
  }), title && external_react_default.a.createElement("div", {
    className: "FormStatus__title"
  }, title), dangerouslySetInnerHTML && external_react_default.a.createElement("div", {
    className: "FormStatus__content",
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  }), children && !dangerouslySetInnerHTML && external_react_default.a.createElement("div", {
    className: "FormStatus__content"
  }, children));
};

FormStatus_FormStatus.propTypes = {
  state: external_prop_types_default.a.oneOf(['default', 'error']),
  title: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,
  dangerouslySetInnerHTML: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string
};
/* harmony default export */ var components_FormStatus_FormStatus = (FormStatus_FormStatus);
// CONCATENATED MODULE: ./src/components/Switch/Switch.js
function Switch_extends() { Switch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Switch_extends.apply(this, arguments); }

function Switch_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Switch_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Switch_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Switch_baseClassNames = getClassname('Switch');

var Switch_Switch = function Switch(_ref) {
  var style = _ref.style,
      className = _ref.className,
      getRef = _ref.getRef,
      getRootRef = _ref.getRootRef,
      restProps = Switch_objectWithoutProperties(_ref, ["style", "className", "getRef", "getRootRef"]);

  return external_react_default.a.createElement("label", {
    className: classNames(Switch_baseClassNames, className),
    style: style,
    ref: getRootRef
  }, external_react_default.a.createElement("input", Switch_extends({}, restProps, {
    type: "checkbox",
    className: "Switch__self",
    ref: getRef
  })), external_react_default.a.createElement("span", {
    className: "Switch__pseudo"
  }));
};

Switch_Switch.propTypes = {
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  getRef: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func
};
/* harmony default export */ var components_Switch_Switch = (Switch_Switch);
// CONCATENATED MODULE: ./src/components/File/File.js
function File_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { File_typeof = function _typeof(obj) { return typeof obj; }; } else { File_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return File_typeof(obj); }

function File_extends() { File_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return File_extends.apply(this, arguments); }

function File_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = File_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function File_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function File_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function File_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function File_createClass(Constructor, protoProps, staticProps) { if (protoProps) File_defineProperties(Constructor.prototype, protoProps); if (staticProps) File_defineProperties(Constructor, staticProps); return Constructor; }

function File_possibleConstructorReturn(self, call) { if (call && (File_typeof(call) === "object" || typeof call === "function")) { return call; } return File_assertThisInitialized(self); }

function File_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function File_getPrototypeOf(o) { File_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return File_getPrototypeOf(o); }

function File_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) File_setPrototypeOf(subClass, superClass); }

function File_setPrototypeOf(o, p) { File_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return File_setPrototypeOf(o, p); }

function File_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var File_baseClassNames = getClassname('File');

var File_File =
/*#__PURE__*/
function (_Component) {
  File_inherits(File, _Component);

  function File(props) {
    var _this;

    File_classCallCheck(this, File);

    _this = File_possibleConstructorReturn(this, File_getPrototypeOf(File).call(this, props));
    _this.state = {
      value: null
    };
    return _this;
  }

  File_createClass(File, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          alignment = _this$props.alignment,
          align = _this$props.align,
          size = _this$props.size,
          level = _this$props.level,
          type = _this$props.type,
          stretched = _this$props.stretched,
          before = _this$props.before,
          className = _this$props.className,
          style = _this$props.style,
          getRef = _this$props.getRef,
          getRootRef = _this$props.getRootRef,
          restProps = File_objectWithoutProperties(_this$props, ["children", "label", "alignment", "align", "size", "level", "type", "stretched", "before", "className", "style", "getRef", "getRootRef"]);

      return external_react_default.a.createElement(Button_Button, {
        align: align || alignment,
        className: classNames(File_baseClassNames, className),
        component: "label",
        type: type,
        stretched: stretched,
        level: level,
        size: size,
        before: before,
        style: style,
        getRootRef: getRootRef
      }, external_react_default.a.createElement("input", File_extends({}, restProps, {
        className: "File__input",
        type: "file",
        ref: getRef
      })), children || label);
    }
  }]);

  return File;
}(external_react_["Component"]);

File_defineProperty(File_File, "propTypes", {
  style: external_prop_types_default.a.object,
  children: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,

  /**
   * @ignore
   */
  level: external_prop_types_default.a.any,

  /**
   * @ignore
   */
  size: external_prop_types_default.a.any,

  /**
   * @ignore
   */
  type: external_prop_types_default.a.any,

  /**
   * @ignore
   */
  align: external_prop_types_default.a.any,

  /**
   * @ignore
   */
  stretched: external_prop_types_default.a.any,

  /**
   * @ignore
   */
  before: external_prop_types_default.a.any,
  getRef: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func,

  /**
   * @deprecated Используйте `children`. Свойство `label` будет удалено в 3.0.0
   */
  label: external_prop_types_default.a.string,

  /**
   * @deprecated Используйте `align`. Свойство `alignment` будет удалено в 3.0.0
   */
  alignment: external_prop_types_default.a.oneOf(['left', 'center', 'right'])
});

File_defineProperty(File_File, "defaultProps", {
  label: 'Выберите файл',
  children: 'Выберите файл',
  alignment: 'left',
  align: 'left'
});


// CONCATENATED MODULE: ./src/components/Input/Input.js
function Input_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Input_typeof = function _typeof(obj) { return typeof obj; }; } else { Input_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Input_typeof(obj); }

function Input_extends() { Input_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Input_extends.apply(this, arguments); }

function Input_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Input_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Input_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Input_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Input_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Input_createClass(Constructor, protoProps, staticProps) { if (protoProps) Input_defineProperties(Constructor.prototype, protoProps); if (staticProps) Input_defineProperties(Constructor, staticProps); return Constructor; }

function Input_possibleConstructorReturn(self, call) { if (call && (Input_typeof(call) === "object" || typeof call === "function")) { return call; } return Input_assertThisInitialized(self); }

function Input_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Input_getPrototypeOf(o) { Input_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Input_getPrototypeOf(o); }

function Input_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Input_setPrototypeOf(subClass, superClass); }

function Input_setPrototypeOf(o, p) { Input_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Input_setPrototypeOf(o, p); }

function Input_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Input_baseClassName = getClassname('Input');

var Input_Input =
/*#__PURE__*/
function (_PureComponent) {
  Input_inherits(Input, _PureComponent);

  function Input() {
    Input_classCallCheck(this, Input);

    return Input_possibleConstructorReturn(this, Input_getPrototypeOf(Input).apply(this, arguments));
  }

  Input_createClass(Input, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          alignment = _this$props.alignment,
          status = _this$props.status,
          getRef = _this$props.getRef,
          className = _this$props.className,
          getRootRef = _this$props.getRootRef,
          restProps = Input_objectWithoutProperties(_this$props, ["alignment", "status", "getRef", "className", "getRootRef"]);

      return external_react_default.a.createElement("div", {
        className: classNames(Input_baseClassName, (_classnames = {}, Input_defineProperty(_classnames, "Input--".concat(alignment), alignment), Input_defineProperty(_classnames, "Input--s-".concat(status), status), _classnames), className),
        ref: getRootRef
      }, external_react_default.a.createElement("input", Input_extends({}, restProps, {
        className: "Input__el",
        ref: getRef
      })), external_react_default.a.createElement("div", {
        className: "Input__border"
      }));
    }
  }]);

  return Input;
}(external_react_["PureComponent"]);

Input_defineProperty(Input_Input, "propTypes", {
  type: external_prop_types_default.a.string,
  alignment: external_prop_types_default.a.oneOf(['left', 'center', 'right']),
  value: external_prop_types_default.a.string,
  defaultValue: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func,
  placeholder: external_prop_types_default.a.string,
  status: external_prop_types_default.a.oneOf(['default', 'error', 'verified']),
  getRef: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func,
  className: external_prop_types_default.a.string
});

Input_defineProperty(Input_Input, "defaultProps", {
  type: 'text'
});


// CONCATENATED MODULE: ./src/components/Slider/Slider.js
function Slider_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Slider_typeof = function _typeof(obj) { return typeof obj; }; } else { Slider_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Slider_typeof(obj); }

function Slider_extends() { Slider_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Slider_extends.apply(this, arguments); }

function Slider_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Slider_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Slider_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Slider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Slider_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Slider_createClass(Constructor, protoProps, staticProps) { if (protoProps) Slider_defineProperties(Constructor.prototype, protoProps); if (staticProps) Slider_defineProperties(Constructor, staticProps); return Constructor; }

function Slider_possibleConstructorReturn(self, call) { if (call && (Slider_typeof(call) === "object" || typeof call === "function")) { return call; } return Slider_assertThisInitialized(self); }

function Slider_getPrototypeOf(o) { Slider_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Slider_getPrototypeOf(o); }

function Slider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Slider_setPrototypeOf(subClass, superClass); }

function Slider_setPrototypeOf(o, p) { Slider_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Slider_setPrototypeOf(o, p); }

function Slider_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Slider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Slider_baseClassNames = getClassname('Slider');

function precisionRound(number, precision) {
  var factor = Math.pow(10, precision || 1);
  return Math.round(number * factor) / factor;
}

var Slider_Slider =
/*#__PURE__*/
function (_Component) {
  Slider_inherits(Slider, _Component);

  function Slider(props) {
    var _this;

    Slider_classCallCheck(this, Slider);

    _this = Slider_possibleConstructorReturn(this, Slider_getPrototypeOf(Slider).call(this, props));

    Slider_defineProperty(Slider_assertThisInitialized(Slider_assertThisInitialized(_this)), "onStart", function (e) {
      var absolutePosition = _this.validateAbsolute(e.startX - _this.state.containerLeft);

      var percentPosition = _this.absoluteToPecent(absolutePosition);

      _this.onChange(_this.percentToValue(percentPosition));

      if (_this.isControlledOutside) {
        _this.setState({
          startX: absolutePosition
        });
      } else {
        _this.setState({
          startX: absolutePosition,
          percentPosition: percentPosition
        });
      }

      _this.setState({
        active: !!e.originalEvent.target.closest('.Slider__thumb')
      });
    });

    Slider_defineProperty(Slider_assertThisInitialized(Slider_assertThisInitialized(_this)), "onMoveX", function (e) {
      var absolutePosition = _this.validateAbsolute(_this.state.startX + (e.shiftX || 0));

      var percentPosition = _this.absoluteToPecent(absolutePosition);

      _this.onChange(_this.percentToValue(percentPosition));

      if (!_this.isControlledOutside) {
        _this.setState({
          percentPosition: percentPosition
        });
      }

      e.originalEvent.preventDefault();
    });

    Slider_defineProperty(Slider_assertThisInitialized(Slider_assertThisInitialized(_this)), "onEnd", function () {
      _this.setState({
        active: false
      });
    });

    Slider_defineProperty(Slider_assertThisInitialized(Slider_assertThisInitialized(_this)), "onResize", function (callback) {
      _this.setState({
        containerLeft: _this.container.offsetLeft,
        containerWidth: _this.container.offsetWidth
      }, function () {
        typeof callback === 'function' && callback();
      });
    });

    Slider_defineProperty(Slider_assertThisInitialized(Slider_assertThisInitialized(_this)), "getRef", function (container) {
      _this.container = container;
      _this.props.getRootRef && _this.props.getRootRef(container);
    });

    _this.state = {
      startX: 0
    };
    _this.isControlledOutside = _this.props.hasOwnProperty('value');
    return _this;
  }

  Slider_createClass(Slider, [{
    key: "onChange",
    value: function onChange(value) {
      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: "validateAbsolute",
    value: function validateAbsolute(absolute) {
      var res = Math.max(0, Math.min(absolute, this.state.containerWidth));

      if (this.props.step > 0) {
        var stepCount = (this.props.max - this.props.min) / this.props.step;
        var absStep = this.state.containerWidth / stepCount;
        res = Math.round(res / absStep) * absStep;
      }

      return res;
    }
  }, {
    key: "validatePercent",
    value: function validatePercent(percent) {
      return Math.max(0, Math.min(percent, 100));
    }
  }, {
    key: "absoluteToPecent",
    value: function absoluteToPecent(absolute) {
      return absolute * 100 / this.state.containerWidth;
    }
  }, {
    key: "percentToValue",
    value: function percentToValue(percent) {
      var res = percent * (this.props.max - this.props.min) / 100 + this.props.min;

      if (this.props.step > 0) {
        var stepFloatPart = "".concat(this.props.step).split('.')[1] || '';
        return precisionRound(res, stepFloatPart.length);
      }

      return res;
    }
  }, {
    key: "valueToPercent",
    value: function valueToPercent(value) {
      return (value - this.props.min) * 100 / (this.props.max - this.props.min);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.onResize);
      this.onResize(function () {
        _this2.setState({
          percentPosition: _this2.validatePercent(_this2.valueToPercent(_this2.value))
        });
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlledOutside && nextProps.value !== this.props.value) {
        this.setState({
          percentPosition: this.validatePercent(this.valueToPercent(nextProps.value))
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          getRootRef = _this$props.getRootRef,
          restProps = Slider_objectWithoutProperties(_this$props, ["className", "min", "max", "step", "value", "defaultValue", "onChange", "getRootRef"]);

      return external_react_default.a.createElement("div", Slider_extends({}, restProps, {
        className: classNames(Slider_baseClassNames, className),
        ref: this.getRef
      }), external_react_default.a.createElement(Touch_Touch, {
        onStart: this.onStart,
        onMoveX: this.onMoveX,
        onEnd: this.onEnd,
        className: "Slider__in"
      }, external_react_default.a.createElement("div", {
        className: "Slider__dragger",
        style: {
          width: this.state.percentPosition + '%'
        }
      }, external_react_default.a.createElement("span", {
        className: classNames('Slider__thumb', 'Slider__thumb--end', {
          'Slider__thumb--active': this.state.active
        })
      }))));
    }
  }, {
    key: "value",
    get: function get() {
      if (this.isControlledOutside) {
        return this.props.value;
      } else if (this.props.hasOwnProperty('defaultValue')) {
        return this.props.defaultValue;
      } else {
        return this.props.min;
      }
    }
  }]);

  return Slider;
}(external_react_["Component"]);

Slider_defineProperty(Slider_Slider, "propTypes", {
  min: external_prop_types_default.a.number,
  max: external_prop_types_default.a.number,
  value: external_prop_types_default.a.number,
  step: external_prop_types_default.a.number,
  onChange: external_prop_types_default.a.func,
  defaultValue: external_prop_types_default.a.number,
  className: external_prop_types_default.a.string,
  style: external_prop_types_default.a.object,
  getRootRef: external_prop_types_default.a.func
});

Slider_defineProperty(Slider_Slider, "defaultProps", {
  min: 0,
  max: 100,
  step: 0
});


// CONCATENATED MODULE: ./src/components/RangeSlider/RangeSlider.js
function RangeSlider_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RangeSlider_typeof = function _typeof(obj) { return typeof obj; }; } else { RangeSlider_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RangeSlider_typeof(obj); }

function RangeSlider_extends() { RangeSlider_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return RangeSlider_extends.apply(this, arguments); }

function RangeSlider_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = RangeSlider_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function RangeSlider_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RangeSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { RangeSlider_defineProperty(target, key, source[key]); }); } return target; }

function RangeSlider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RangeSlider_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RangeSlider_createClass(Constructor, protoProps, staticProps) { if (protoProps) RangeSlider_defineProperties(Constructor.prototype, protoProps); if (staticProps) RangeSlider_defineProperties(Constructor, staticProps); return Constructor; }

function RangeSlider_possibleConstructorReturn(self, call) { if (call && (RangeSlider_typeof(call) === "object" || typeof call === "function")) { return call; } return RangeSlider_assertThisInitialized(self); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = RangeSlider_getPrototypeOf(object); if (object === null) break; } return object; }

function RangeSlider_getPrototypeOf(o) { RangeSlider_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return RangeSlider_getPrototypeOf(o); }

function RangeSlider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) RangeSlider_setPrototypeOf(subClass, superClass); }

function RangeSlider_setPrototypeOf(o, p) { RangeSlider_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return RangeSlider_setPrototypeOf(o, p); }

function RangeSlider_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function RangeSlider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var RangeSlider_baseClassNames = getClassname('Slider');

var RangeSlider_RangeSlider =
/*#__PURE__*/
function (_Slider) {
  RangeSlider_inherits(RangeSlider, _Slider);

  function RangeSlider() {
    var _getPrototypeOf2;

    var _this;

    RangeSlider_classCallCheck(this, RangeSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = RangeSlider_possibleConstructorReturn(this, (_getPrototypeOf2 = RangeSlider_getPrototypeOf(RangeSlider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    RangeSlider_defineProperty(RangeSlider_assertThisInitialized(RangeSlider_assertThisInitialized(_this)), "onStart", function (e) {
      var absolutePosition = _this.validateAbsolute(e.startX - _this.state.containerLeft);

      var percentPosition = _this.absoluteToPecent(absolutePosition);

      var percentRange = _this.calcPercentRange(percentPosition);

      _this.onChange(_this.percentToValue(percentRange));

      if (_this.isControlledOutside) {
        _this.setState({
          startX: absolutePosition
        });
      } else {
        _this.setState(RangeSlider_objectSpread({
          startX: absolutePosition
        }, percentRange));
      }

      var thumb = e.originalEvent.target.closest('.Slider__thumb');

      if (thumb === _this.thumbStart) {
        _this.setState({
          active: 'start'
        });
      } else if (thumb === _this.thumbEnd) {
        _this.setState({
          active: 'end'
        });
      }
    });

    RangeSlider_defineProperty(RangeSlider_assertThisInitialized(RangeSlider_assertThisInitialized(_this)), "onMoveX", function (e) {
      var absolutePosition = _this.validateAbsolute(_this.state.startX + (e.shiftX || 0));

      var percentPosition = _this.absoluteToPecent(absolutePosition);

      var percentRange = _this.calcPercentRange(percentPosition);

      _this.onChange(_this.percentToValue(percentRange));

      if (!_this.isControlledOutside) {
        _this.setState(percentRange);
      }

      e.originalEvent.preventDefault();
    });

    return _this;
  }

  RangeSlider_createClass(RangeSlider, [{
    key: "calcPercentRange",
    value: function calcPercentRange(percent) {
      var _this$state = this.state,
          percentStart = _this$state.percentStart,
          percentEnd = _this$state.percentEnd;

      if (percentStart === 100) {
        return {
          percentStart: percent,
          percentEnd: percentEnd
        };
      } else if (percentEnd === 0) {
        return {
          percentEnd: percent,
          percentStart: percentStart
        };
      } else if (Math.abs(percentStart - percent) <= Math.abs(percentEnd - percent)) {
        return {
          percentStart: percent,
          percentEnd: percentEnd
        };
      } else {
        return {
          percentEnd: percent,
          percentStart: percentStart
        };
      }
    }
  }, {
    key: "validatePercent",
    value: function validatePercent(_ref) {
      var percentStart = _ref.percentStart,
          percentEnd = _ref.percentEnd;
      return {
        percentStart: _get(RangeSlider_getPrototypeOf(RangeSlider.prototype), "validatePercent", this).call(this, percentStart),
        percentEnd: _get(RangeSlider_getPrototypeOf(RangeSlider.prototype), "validatePercent", this).call(this, percentEnd)
      };
    }
  }, {
    key: "percentToValue",
    value: function percentToValue(_ref2) {
      var percentStart = _ref2.percentStart,
          percentEnd = _ref2.percentEnd;
      return [_get(RangeSlider_getPrototypeOf(RangeSlider.prototype), "percentToValue", this).call(this, percentStart), _get(RangeSlider_getPrototypeOf(RangeSlider.prototype), "percentToValue", this).call(this, percentEnd)];
    }
  }, {
    key: "valueToPercent",
    value: function valueToPercent(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          valueStart = _ref4[0],
          valueEnd = _ref4[1];

      return {
        percentStart: _get(RangeSlider_getPrototypeOf(RangeSlider.prototype), "valueToPercent", this).call(this, valueStart),
        percentEnd: _get(RangeSlider_getPrototypeOf(RangeSlider.prototype), "valueToPercent", this).call(this, valueEnd)
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.onResize);
      this.onResize(function () {
        _this2.setState(_this2.validatePercent(_this2.valueToPercent(_this2.value)));
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlledOutside && nextProps.value !== this.props.value) {
        this.setState(this.validatePercent(this.valueToPercent(nextProps.value)));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          getRootRef = _this$props.getRootRef,
          restProps = RangeSlider_objectWithoutProperties(_this$props, ["className", "min", "max", "step", "value", "defaultValue", "onChange", "getRootRef"]);

      return external_react_default.a.createElement("div", RangeSlider_extends({}, restProps, {
        className: classNames(RangeSlider_baseClassNames, className),
        ref: this.getRef
      }), external_react_default.a.createElement(Touch_Touch, {
        onStart: this.onStart,
        onMoveX: this.onMoveX,
        onEnd: this.onEnd,
        className: "Slider__in"
      }, external_react_default.a.createElement("div", {
        className: "Slider__dragger",
        style: {
          width: this.state.percentEnd - this.state.percentStart + '%',
          left: this.state.percentStart + '%'
        }
      }, external_react_default.a.createElement("span", {
        className: classNames('Slider__thumb', 'Slider__thumb--start', {
          'Slider__thumb--active': this.state.active === 'start'
        }),
        ref: function ref(el) {
          return _this3.thumbStart = el;
        }
      }), external_react_default.a.createElement("span", {
        className: classNames('Slider__thumb', 'Slider__thumb--end', {
          'Slider__thumb--active': this.state.active === 'end'
        }),
        ref: function ref(el) {
          return _this3.thumbEnd = el;
        }
      }))));
    }
  }, {
    key: "value",
    get: function get() {
      if (this.isControlledOutside) {
        return this.props.value;
      } else if (this.props.hasOwnProperty('defaultValue')) {
        return this.props.defaultValue;
      } else {
        return [this.props.min, this.props.max];
      }
    }
  }]);

  return RangeSlider;
}(Slider_Slider);

RangeSlider_defineProperty(RangeSlider_RangeSlider, "propTypes", RangeSlider_objectSpread({}, Slider_Slider.propTypes, {
  value: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number),
  defaultValue: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number)
}));

RangeSlider_defineProperty(RangeSlider_RangeSlider, "defaultProps", Slider_Slider.defaultProps);


// CONCATENATED MODULE: ./src/components/Textarea/Textarea.js
function Textarea_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Textarea_typeof = function _typeof(obj) { return typeof obj; }; } else { Textarea_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Textarea_typeof(obj); }

function Textarea_extends() { Textarea_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Textarea_extends.apply(this, arguments); }

function Textarea_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Textarea_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Textarea_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Textarea_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Textarea_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Textarea_createClass(Constructor, protoProps, staticProps) { if (protoProps) Textarea_defineProperties(Constructor.prototype, protoProps); if (staticProps) Textarea_defineProperties(Constructor, staticProps); return Constructor; }

function Textarea_possibleConstructorReturn(self, call) { if (call && (Textarea_typeof(call) === "object" || typeof call === "function")) { return call; } return Textarea_assertThisInitialized(self); }

function Textarea_getPrototypeOf(o) { Textarea_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Textarea_getPrototypeOf(o); }

function Textarea_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Textarea_setPrototypeOf(subClass, superClass); }

function Textarea_setPrototypeOf(o, p) { Textarea_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Textarea_setPrototypeOf(o, p); }

function Textarea_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Textarea_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var Textarea_baseClassName = getClassname('Textarea');

var Textarea_Textarea =
/*#__PURE__*/
function (_PureComponent) {
  Textarea_inherits(Textarea, _PureComponent);

  function Textarea(props) {
    var _this;

    Textarea_classCallCheck(this, Textarea);

    _this = Textarea_possibleConstructorReturn(this, Textarea_getPrototypeOf(Textarea).call(this, props));

    Textarea_defineProperty(Textarea_assertThisInitialized(Textarea_assertThisInitialized(_this)), "getRef", function (element) {
      _this.element = element;
      _this.props.getRef && _this.props.getRef(element);
    });

    Textarea_defineProperty(Textarea_assertThisInitialized(Textarea_assertThisInitialized(_this)), "resize", function () {
      var el = _this.element;

      if (el) {
        var offsetHeight = el.offsetHeight,
            scrollHeight = el.scrollHeight;
        var style = window.getComputedStyle(el);
        var paddingTop = parseInt(style.paddingTop);
        var paddingBottom = parseInt(style.paddingBottom);
        var diff = paddingTop + paddingBottom;

        if (scrollHeight + diff <= offsetHeight) {
          diff = 0;
        }

        if (el.value) {
          _this.setState({
            height: scrollHeight - diff
          });
        }

        _this.setState({
          height: 0
        }, function () {
          var height = el.scrollHeight - diff;

          _this.setState({
            height: height
          });

          _this.props.onResize(el);
        });
      }
    });

    Textarea_defineProperty(Textarea_assertThisInitialized(Textarea_assertThisInitialized(_this)), "onChange", function (e) {
      if (_this.props.grow) {
        _this.resize();
      }

      if (!_this.isControlledOutside) {
        _this.setState({
          value: e.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    });

    if (typeof props.value !== 'undefined') {
      _this.isControlledOutside = true;
      _this.state = {};
    } else {
      _this.state = {
        value: props.defaultValue || ''
      };
    }

    return _this;
  }

  Textarea_createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.grow) {
        this.resize();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.value && this.props.value === '') {
        // Fix iOS extra indent on removing content
        window.requestAnimationFrame(function () {
          _this2.element.value = '';
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          defaultValue = _this$props.defaultValue,
          value = _this$props.value,
          onChange = _this$props.onChange,
          grow = _this$props.grow,
          style = _this$props.style,
          onResize = _this$props.onResize,
          className = _this$props.className,
          getRootRef = _this$props.getRootRef,
          restProps = Textarea_objectWithoutProperties(_this$props, ["defaultValue", "value", "onChange", "grow", "style", "onResize", "className", "getRootRef"]);

      var height = this.state.height || style.height || 66;
      return external_react_default.a.createElement("div", {
        className: classNames(Textarea_baseClassName, className),
        style: style,
        ref: getRootRef
      }, external_react_default.a.createElement("textarea", Textarea_extends({}, restProps, {
        value: this.value,
        onChange: this.onChange,
        ref: this.getRef,
        style: {
          height: height
        }
      })), external_react_default.a.createElement("div", {
        className: "Textarea__border"
      }));
    }
  }, {
    key: "value",
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return Textarea;
}(external_react_["PureComponent"]);

Textarea_defineProperty(Textarea_Textarea, "propTypes", {
  style: external_prop_types_default.a.object,
  value: external_prop_types_default.a.string,
  defaultValue: external_prop_types_default.a.string,
  grow: external_prop_types_default.a.bool,
  onChange: external_prop_types_default.a.func,
  onResize: external_prop_types_default.a.func,
  className: external_prop_types_default.a.string,
  getRef: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func
});

Textarea_defineProperty(Textarea_Textarea, "defaultProps", {
  style: {},
  defaultValue: '',
  grow: true,
  onResize: function onResize() {}
});


// CONCATENATED MODULE: ./src/components/Radio/Radio.js
function Radio_extends() { Radio_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Radio_extends.apply(this, arguments); }

function Radio_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Radio_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Radio_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Radio_osname = platform();
var Radio_baseClassName = getClassname('Radio');

var Radio_Radio = function Radio(_ref) {
  var children = _ref.children,
      description = _ref.description,
      style = _ref.style,
      className = _ref.className,
      getRef = _ref.getRef,
      getRootRef = _ref.getRootRef,
      restProps = Radio_objectWithoutProperties(_ref, ["children", "description", "style", "className", "getRef", "getRootRef"]);

  return external_react_default.a.createElement(Tappable_Tappable, {
    component: "label",
    style: style,
    className: classNames(Radio_baseClassName, className),
    activeEffectDelay: Radio_osname === IOS ? 100 : ACTIVE_EFFECT_DELAY,
    disabled: restProps.disabled,
    getRootRef: getRootRef
  }, external_react_default.a.createElement("input", Radio_extends({}, restProps, {
    type: "radio",
    className: "Radio__input",
    ref: getRef
  })), external_react_default.a.createElement("div", {
    className: "Radio__container"
  }, external_react_default.a.createElement("div", {
    className: "Radio__icon"
  }), external_react_default.a.createElement("div", {
    className: "Radio__content"
  }, children, external_react_default.a.createElement("div", {
    className: "Radio__description"
  }, description))));
};

Radio_Radio.propTypes = {
  children: external_prop_types_default.a.node,
  description: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  getRef: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func
};
/* harmony default export */ var components_Radio_Radio = (Radio_Radio);
// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.js
function Checkbox_extends() { Checkbox_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Checkbox_extends.apply(this, arguments); }

function Checkbox_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Checkbox_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Checkbox_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var Checkbox_osname = platform();
var Checkbox_baseClassName = getClassname('Checkbox');

var Checkbox_Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = Checkbox_objectWithoutProperties(_ref, ["children", "className", "style", "getRootRef"]);

  return external_react_default.a.createElement(Tappable_Tappable, {
    component: "label",
    className: classNames(Checkbox_baseClassName, className),
    style: style,
    disabled: restProps.disabled,
    activeEffectDelay: Checkbox_osname === IOS ? 100 : ACTIVE_EFFECT_DELAY,
    getRootRef: getRootRef
  }, external_react_default.a.createElement("input", Checkbox_extends({}, restProps, {
    type: "checkbox",
    className: "Checkbox__input"
  })), external_react_default.a.createElement("div", {
    className: "Checkbox__container"
  }, external_react_default.a.createElement("div", {
    className: "Checkbox__icon"
  }, external_react_default.a.createElement(done_default.a, null)), external_react_default.a.createElement("div", {
    className: "Checkbox__content"
  }, children)));
};

Checkbox_Checkbox.propTypes = {
  children: external_prop_types_default.a.node,
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  getRootRef: external_prop_types_default.a.func
};
/* harmony default export */ var components_Checkbox_Checkbox = (Checkbox_Checkbox);
// EXTERNAL MODULE: ./node_modules/@vkontakte/icons/dist/24/dropdown.js
var dropdown = __webpack_require__(7);
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown);

// CONCATENATED MODULE: ./src/components/Select/Select.js
function Select_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Select_typeof = function _typeof(obj) { return typeof obj; }; } else { Select_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Select_typeof(obj); }

function Select_extends() { Select_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Select_extends.apply(this, arguments); }

function Select_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Select_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Select_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Select_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Select_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Select_createClass(Constructor, protoProps, staticProps) { if (protoProps) Select_defineProperties(Constructor.prototype, protoProps); if (staticProps) Select_defineProperties(Constructor, staticProps); return Constructor; }

function Select_possibleConstructorReturn(self, call) { if (call && (Select_typeof(call) === "object" || typeof call === "function")) { return call; } return Select_assertThisInitialized(self); }

function Select_getPrototypeOf(o) { Select_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Select_getPrototypeOf(o); }

function Select_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Select_setPrototypeOf(subClass, superClass); }

function Select_setPrototypeOf(o, p) { Select_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Select_setPrototypeOf(o, p); }

function Select_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Select_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Select_osname = platform();
var Select_baseClassName = getClassname('Select');

var Select_Select =
/*#__PURE__*/
function (_Component) {
  Select_inherits(Select, _Component);

  function Select(props) {
    var _this;

    Select_classCallCheck(this, Select);

    _this = Select_possibleConstructorReturn(this, Select_getPrototypeOf(Select).call(this, props));

    Select_defineProperty(Select_assertThisInitialized(Select_assertThisInitialized(_this)), "onChange", function (e) {
      _this.setTitle();

      if (!_this.isControlledOutside) {
        _this.setState({
          value: e.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    });

    Select_defineProperty(Select_assertThisInitialized(Select_assertThisInitialized(_this)), "setTitle", function () {
      var selectedOption = _this.selectEl.options[_this.selectEl.selectedIndex];
      selectedOption && _this.setState({
        title: selectedOption.text,
        notSelected: selectedOption.value === '' && _this.props.hasOwnProperty('placeholder')
      });
    });

    Select_defineProperty(Select_assertThisInitialized(Select_assertThisInitialized(_this)), "getRef", function (el) {
      _this.selectEl = el;
      _this.props.getRef && _this.props.getRef(el);
    });

    var state = {
      title: '',
      notSelected: false
    };

    if (typeof props.value !== 'undefined') {
      _this.isControlledOutside = true;
    } else {
      state.value = props.defaultValue || '';
    }

    _this.state = state;
    return _this;
  }

  Select_createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value || prevProps.children !== this.props.children) {
        this.setTitle();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTitle();
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          style = _this$props.style,
          label = _this$props.label,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          alignment = _this$props.alignment,
          placeholder = _this$props.placeholder,
          children = _this$props.children,
          className = _this$props.className,
          getRef = _this$props.getRef,
          getRootRef = _this$props.getRootRef,
          restProps = Select_objectWithoutProperties(_this$props, ["style", "label", "value", "defaultValue", "onChange", "alignment", "placeholder", "children", "className", "getRef", "getRootRef"]);

      return external_react_default.a.createElement("label", {
        className: classNames(Select_baseClassName, (_classnames = {}, Select_defineProperty(_classnames, "Select--not-selected", this.state.notSelected), Select_defineProperty(_classnames, "Select--align-".concat(alignment), alignment), _classnames), className),
        style: style,
        ref: getRootRef
      }, external_react_default.a.createElement("select", Select_extends({
        onChange: this.onChange,
        value: this.value,
        ref: this.getRef
      }, restProps), placeholder && external_react_default.a.createElement("option", {
        value: ""
      }, placeholder), children), external_react_default.a.createElement("div", {
        className: "Select__container"
      }, external_react_default.a.createElement("div", {
        className: "Select__title"
      }, this.state.title), external_react_default.a.createElement(dropdown_default.a, null)), Select_osname === ANDROID && external_react_default.a.createElement("div", {
        className: "Select__border"
      }));
    }
  }, {
    key: "value",
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return Select;
}(external_react_["Component"]);

Select_defineProperty(Select_Select, "propTypes", {
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  label: external_prop_types_default.a.string,
  name: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func,
  value: external_prop_types_default.a.any,
  defaultValue: external_prop_types_default.a.any,
  children: external_prop_types_default.a.node,
  placeholder: external_prop_types_default.a.string,
  getRef: external_prop_types_default.a.func,
  getRootRef: external_prop_types_default.a.func,
  alignment: external_prop_types_default.a.oneOf(['left', 'center', 'top'])
});

Select_defineProperty(Select_Select, "defaultProps", {
  alignment: 'left'
});


// CONCATENATED MODULE: ./src/components/SelectMimicry/SelectMimicry.js
function SelectMimicry_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SelectMimicry_typeof = function _typeof(obj) { return typeof obj; }; } else { SelectMimicry_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SelectMimicry_typeof(obj); }

function SelectMimicry_extends() { SelectMimicry_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SelectMimicry_extends.apply(this, arguments); }

function SelectMimicry_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = SelectMimicry_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function SelectMimicry_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SelectMimicry_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectMimicry_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SelectMimicry_createClass(Constructor, protoProps, staticProps) { if (protoProps) SelectMimicry_defineProperties(Constructor.prototype, protoProps); if (staticProps) SelectMimicry_defineProperties(Constructor, staticProps); return Constructor; }

function SelectMimicry_possibleConstructorReturn(self, call) { if (call && (SelectMimicry_typeof(call) === "object" || typeof call === "function")) { return call; } return SelectMimicry_assertThisInitialized(self); }

function SelectMimicry_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SelectMimicry_getPrototypeOf(o) { SelectMimicry_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SelectMimicry_getPrototypeOf(o); }

function SelectMimicry_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) SelectMimicry_setPrototypeOf(subClass, superClass); }

function SelectMimicry_setPrototypeOf(o, p) { SelectMimicry_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SelectMimicry_setPrototypeOf(o, p); }

function SelectMimicry_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var SelectMimicry_baseClassName = getClassname('Select');

var SelectMimicry_SelectMimicry =
/*#__PURE__*/
function (_Component) {
  SelectMimicry_inherits(SelectMimicry, _Component);

  function SelectMimicry() {
    SelectMimicry_classCallCheck(this, SelectMimicry);

    return SelectMimicry_possibleConstructorReturn(this, SelectMimicry_getPrototypeOf(SelectMimicry).apply(this, arguments));
  }

  SelectMimicry_createClass(SelectMimicry, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          placeholder = _this$props.placeholder,
          children = _this$props.children,
          alignment = _this$props.alignment,
          getRootRef = _this$props.getRootRef,
          restProps = SelectMimicry_objectWithoutProperties(_this$props, ["className", "placeholder", "children", "alignment", "getRootRef"]);

      return external_react_default.a.createElement("div", SelectMimicry_extends({}, restProps, {
        className: classNames(SelectMimicry_baseClassName, SelectMimicry_defineProperty({
          'Select--not-selected': !children,
          'Select--mimicry': true
        }, "Select--align-".concat(alignment), alignment), className),
        ref: getRootRef
      }), external_react_default.a.createElement("div", {
        className: "Select__container"
      }, external_react_default.a.createElement("div", {
        className: "Select__title"
      }, children || placeholder), external_react_default.a.createElement(dropdown_default.a, null)), external_react_default.a.createElement("div", {
        className: "Select__border"
      }));
    }
  }]);

  return SelectMimicry;
}(external_react_["Component"]);

SelectMimicry_defineProperty(SelectMimicry_SelectMimicry, "propTypes", {
  style: external_prop_types_default.a.object,
  className: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node,
  tabIndex: external_prop_types_default.a.number,
  placeholder: external_prop_types_default.a.string,
  alignment: external_prop_types_default.a.oneOf(['left', 'center', 'top']),
  getRootRef: external_prop_types_default.a.func
});

SelectMimicry_defineProperty(SelectMimicry_SelectMimicry, "defaultProps", {
  tabIndex: 0
});


// EXTERNAL MODULE: ./node_modules/@vkontakte/vkui-connect/index.js
var vkui_connect = __webpack_require__(10);
var vkui_connect_default = /*#__PURE__*/__webpack_require__.n(vkui_connect);

// CONCATENATED MODULE: ./src/lib/webview.js

var isWebView = vkui_connect_default.a.supports('VKWebAppInit');
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(9);

// CONCATENATED MODULE: ./src/components/ConfigProvider/ConfigProvider.js
function ConfigProvider_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ConfigProvider_typeof = function _typeof(obj) { return typeof obj; }; } else { ConfigProvider_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ConfigProvider_typeof(obj); }

function ConfigProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ConfigProvider_defineProperty(target, key, source[key]); }); } return target; }

function ConfigProvider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConfigProvider_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ConfigProvider_createClass(Constructor, protoProps, staticProps) { if (protoProps) ConfigProvider_defineProperties(Constructor.prototype, protoProps); if (staticProps) ConfigProvider_defineProperties(Constructor, staticProps); return Constructor; }

function ConfigProvider_possibleConstructorReturn(self, call) { if (call && (ConfigProvider_typeof(call) === "object" || typeof call === "function")) { return call; } return ConfigProvider_assertThisInitialized(self); }

function ConfigProvider_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ConfigProvider_getPrototypeOf(o) { ConfigProvider_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ConfigProvider_getPrototypeOf(o); }

function ConfigProvider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ConfigProvider_setPrototypeOf(subClass, superClass); }

function ConfigProvider_setPrototypeOf(o, p) { ConfigProvider_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ConfigProvider_setPrototypeOf(o, p); }

function ConfigProvider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ConfigProvider =
/*#__PURE__*/
function (_React$Component) {
  ConfigProvider_inherits(ConfigProvider, _React$Component);

  function ConfigProvider(props) {
    var _this;

    ConfigProvider_classCallCheck(this, ConfigProvider);

    _this = ConfigProvider_possibleConstructorReturn(this, ConfigProvider_getPrototypeOf(ConfigProvider).call(this, props));
    _this.state = {
      bottomInset: props.insets.bottom > 100 ? 0 : props.insets.bottom
    };
    return _this;
  }

  ConfigProvider_createClass(ConfigProvider, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.document.body.setAttribute('scheme', this.props.scheme);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.scheme !== this.props.scheme) {
        this.document.body.setAttribute('scheme', nextProps.scheme);
      }

      if (nextProps.insets.bottom !== this.props.insets.bottom) {
        this.setState({
          bottomInset: nextProps.insets.bottom > 100 ? this.props.insets.bottom : nextProps.insets.bottom
        });
      }
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        insets: ConfigProvider_objectSpread({}, this.props.insets, {
          bottom: this.state.bottomInset
        }),
        isWebView: this.props.isWebView,
        webviewType: this.props.webviewType,
        scheme: this.props.scheme,
        app: this.props.app
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }, {
    key: "document",
    get: function get() {
      return this.context.document || window.document;
    }
  }]);

  return ConfigProvider;
}(external_react_default.a.Component);

ConfigProvider_defineProperty(ConfigProvider, "childContextTypes", {
  insets: external_prop_types_default.a.shape({
    top: external_prop_types_default.a.number,
    right: external_prop_types_default.a.number,
    bottom: external_prop_types_default.a.number,
    left: external_prop_types_default.a.number
  }),
  isWebView: external_prop_types_default.a.bool,
  scheme: external_prop_types_default.a.string,
  webviewType: external_prop_types_default.a.oneOf(['vkapps', 'internal']),
  app: external_prop_types_default.a.string
});

ConfigProvider_defineProperty(ConfigProvider, "propTypes", {
  insets: external_prop_types_default.a.shape({
    top: external_prop_types_default.a.number,
    right: external_prop_types_default.a.number,
    bottom: external_prop_types_default.a.number,
    left: external_prop_types_default.a.number
  }),
  scheme: external_prop_types_default.a.string,
  isWebView: external_prop_types_default.a.bool,
  webviewType: external_prop_types_default.a.oneOf(['vkapps', 'internal']),
  app: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node
});

ConfigProvider_defineProperty(ConfigProvider, "defaultProps", {
  webviewType: 'internal',
  isWebView: isWebView,
  scheme: package_0.defaultSchemeId,
  insets: {}
});

ConfigProvider_defineProperty(ConfigProvider, "contextTypes", {
  document: external_prop_types_default.a.object
});


// CONCATENATED MODULE: ./src/lib/querystring.js
function querystring_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { querystring_defineProperty(target, key, source[key]); }); } return target; }

function querystring_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function querystring_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { querystring_typeof = function _typeof(obj) { return typeof obj; }; } else { querystring_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return querystring_typeof(obj); }

var querystring = {
  parse: function parse() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (typeof string !== 'string') return {};
    var matches = /\?(.+)$/ig.exec(string);
    var str = matches ? matches[1] : string;
    return str.split('&').reduce(function (acc, item) {
      var param = item.split('=');

      if (param[1]) {
        acc[param[0]] = decodeURIComponent(param[1]);
      }

      return acc;
    }, {});
  },
  create: function create() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = arguments.length > 1 ? arguments[1] : undefined;
    if (querystring_typeof(data) !== 'object' || data === null) return '';

    var options = querystring_objectSpread({
      encode: true
    }, opts);

    return Object.keys(data).reduce(function (acc, item) {
      var type = querystring_typeof(data[item]);

      if (type === 'string' || type === 'number' || type === 'boolean') {
        acc.push(item + '=' + (options.encode ? encodeURIComponent(data[item]) : data[item]));
      }

      if (Array.isArray(data[item])) {
        data[item].forEach(function (value) {
          acc.push(item + '[]=' + (options.encode ? encodeURIComponent(value) : value));
        });
      }

      return acc;
    }, []).join('&');
  }
};
/* harmony default export */ var lib_querystring = (querystring);
// CONCATENATED MODULE: ./src/lib/request.js
function request_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { request_defineProperty(target, key, source[key]); }); } return target; }

function request_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var defaultOptions = {
  method: 'GET',
  data: null
};

function getXMLHttpRequest() {
  if (typeof XMLHttpRequest !== 'undefined') {
    // eslint-disable-next-line
    return new XMLHttpRequest();
  }
}

function makeRequest(url, options) {
  var isCanceled;
  var error = new Error('Request was aborted');
  var request = getXMLHttpRequest();

  var opts = request_objectSpread({}, defaultOptions, options);

  if (opts.data && opts.method.toLowerCase() === 'get') {
    url += "?".concat(lib_querystring.create(opts.data));
  }

  var requestPromise = new Promise(function (resolve, reject) {
    if (!request) {
      reject(new Error('XMLHttpRequest not supported'));
    }

    if (opts.timeout) {
      request.timeout = opts.timeout;
    }

    request.open(opts.method, url, true);

    if (opts.headers) {
      Object.keys(opts.headers).forEach(function (key) {
        request.setRequestHeader(key, opts.headers[key]);
      });
    }

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200) {
          resolve(request.responseText);
        } else {
          reject(new Error(request.status));
        }
      }
    };

    request.ontimeout = function () {
      reject(new Error('XMLHttpRequest timeout expires'));
    };

    request.send(opts.data);
  });
  return {
    promise: new Promise(function (resolve, reject) {
      requestPromise.then(function (res) {
        return isCanceled ? reject(error) : resolve(res);
      }).catch(function (e) {
        return isCanceled ? console.log(error) || reject(error) : reject(e);
      });
    }),
    abort: function abort() {
      isCanceled = true;

      if (request) {
        request.abort();
      }
    }
  };
}

/* harmony default export */ var lib_request = (function (url, options) {
  return makeRequest(url, options);
});
// CONCATENATED MODULE: ./src/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return src_v; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Root", function() { return Root_Root; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "View", function() { return View_View; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Panel", function() { return Panel_Panel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HeaderButton", function() { return components_HeaderButton_HeaderButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PanelHeader", function() { return PanelHeader_PanelHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PanelHeaderContent", function() { return components_PanelHeaderContent_PanelHeaderContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HeaderContext", function() { return HeaderContext_HeaderContext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Epic", function() { return Epic_Epic; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tabbar", function() { return Tabbar_Tabbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabbarItem", function() { return TabbarItem_TabbarItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InnerScroll", function() { return InnerScroll_InnerScroll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HorizontalScroll", function() { return HorizontalScroll_HorizontalScroll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FixedLayout", function() { return FixedLayout_FixedLayout; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NativePopouts", function() { return NativePopouts_NativePopouts; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "PopoutWrapper", function() { return PopoutWrapper_PopoutWrapper; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Alert", function() { return Alert_Alert; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ActionSheet", function() { return ActionSheet_ActionSheet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ActionSheetItem", function() { return components_ActionSheetItem_ActionSheetItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ScreenSpinner", function() { return ScreenSpinner; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Button", function() { return Button_Button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CellButton", function() { return components_CellButton_CellButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Header", function() { return components_Header_Header; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Group", function() { return Group_Group; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "List", function() { return components_List_List; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Cell", function() { return Cell_Cell; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListItem", function() { return Cell_Cell; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Footer", function() { return components_Footer_Footer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InfoRow", function() { return components_InfoRow_InfoRow; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Entity", function() { return Entity_Entity; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Gallery", function() { return Gallery_Gallery; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Avatar", function() { return components_Avatar_Avatar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Progress", function() { return components_Progress_Progress; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Search", function() { return Search_Search; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tabs", function() { return Tabs_Tabs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabsItem", function() { return TabsItem_TabsItem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FixedTabs", function() { return FixedTabs_FixedTabs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Spinner", function() { return Spinner_Spinner; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return components_Link_Link; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tooltip", function() { return Tooltip_Tooltip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormLayout", function() { return FormLayout_FormLayout; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormLayoutGroup", function() { return components_FormLayoutGroup_FormLayoutGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormStatus", function() { return components_FormStatus_FormStatus; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Switch", function() { return components_Switch_Switch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "File", function() { return File_File; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Input", function() { return Input_Input; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Slider", function() { return Slider_Slider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RangeSlider", function() { return RangeSlider_RangeSlider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Textarea", function() { return Textarea_Textarea; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Radio", function() { return components_Radio_Radio; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Checkbox", function() { return components_Checkbox_Checkbox; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Select", function() { return Select_Select; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SelectMimicry", function() { return SelectMimicry_SelectMimicry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Div", function() { return Div; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tappable", function() { return Tappable_Tappable; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Touch", function() { return Touch_Touch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ConfigProvider", function() { return ConfigProvider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "classnames", function() { return classNames; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "platform", function() { return platform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ANDROID", function() { return ANDROID; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IOS", function() { return IOS; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "request", function() { return lib_request; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "querystring", function() { return lib_querystring; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getClassName", function() { return getClassname; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWebView", function() { return isWebView; });


/**
 * Layout
 */














/**
 * Popouts
 */







/**
 * Blocks
 */







/**
 * @deprecated алиас для Cell. Будет удален в 3.0.0
 */















/**
 * Forms
 */














/**
 * Helpers
 */





/**
 * Utils
 */







/**
 * @deprecated будет удален в 3.0.0
 * @type {{}}
 */

var colors = {};
var src_v = "2.16.3";

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// Element.prototype.closest
if (window) {
  window.Element.prototype.closest = window.Element.prototype.closest || function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
} // Array.prototype.find


Array.prototype.find = Array.prototype.find || function (callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.find called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }

  var list = Object(this);
  var length = list.length >>> 0;
  var thisArg = arguments[1];

  for (var i = 0; i < length; i++) {
    var element = list[i];

    if (callback.call(thisArg, element, i, list)) {
      return element;
    }
  }
};

/***/ })
/******/ ]);
});
//# sourceMappingURL=vkui.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vkontakte/vkui/dist/vkui.js
// module id = 20
// module chunks = 0